/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root';
import { Route as LoginImport } from './routes/login';
import { Route as GhlAuthorizeImport } from './routes/ghl-authorize';
import { Route as ForgotPasswordImport } from './routes/forgot-password';
import { Route as ExchangeUserContextImport } from './routes/exchange-user-context';
import { Route as CrmSessionBreakoutImport } from './routes/crm-session-breakout';
import { Route as ConnectAppImport } from './routes/connect-app';
import { Route as AuthorizeImport } from './routes/authorize';
import { Route as AuthRouteImport } from './routes/_auth/route';
import { Route as IndexImport } from './routes/index';
import { Route as PublicEventShareShareTokenImport } from './routes/public-event-share/$shareToken';
import { Route as PublicClassShareShareTokenImport } from './routes/public-class-share/$shareToken';
import { Route as EmbedFormImport } from './routes/embed/form';
import { Route as AuthSettingsImport } from './routes/_auth/settings';
import { Route as AuthSetPasswordImport } from './routes/_auth/set-password';
import { Route as AuthScheduledDropsImport } from './routes/_auth/scheduled-drops';
import { Route as AuthRegisterStudentImport } from './routes/_auth/register-student';
import { Route as AuthFamilyImport } from './routes/_auth/family';
import { Route as AuthEventCalendarImport } from './routes/_auth/event-calendar';
import { Route as AuthDashboardImport } from './routes/_auth/dashboard';
import { Route as AuthClassCalendarImport } from './routes/_auth/class-calendar';
import { Route as AuthLayoutRouteImport } from './routes/_auth/_layout/route';
import { Route as PublicClassesClassIdImport } from './routes/_public/classes/$classId';
import { Route as AuthLayoutV2ModeImport } from './routes/_auth/_layout/v2-mode';
import { Route as AuthLayoutRoomOverviewImport } from './routes/_auth/_layout/room-overview';
import { Route as AuthLayoutPublicPageLinkImport } from './routes/_auth/_layout/public-page-link';
import { Route as AuthLayoutParentPortalLinkImport } from './routes/_auth/_layout/parent-portal-link';
import { Route as AuthLayoutParentFormConfigImport } from './routes/_auth/_layout/parent-form-config';
import { Route as AuthLayoutOutgoingEmailLogsImport } from './routes/_auth/_layout/outgoing-email-logs';
import { Route as AuthLayoutNewDashboardImport } from './routes/_auth/_layout/new-dashboard';
import { Route as AuthLayoutMobileInventorIntegrationImport } from './routes/_auth/_layout/mobile-inventor-integration';
import { Route as AuthLayoutIntegrationsImport } from './routes/_auth/_layout/integrations';
import { Route as AuthLayoutFormsImport } from './routes/_auth/_layout/forms';
import { Route as AuthLayoutFormSubmissionsImport } from './routes/_auth/_layout/form-submissions';
import { Route as AuthLayoutEmailCustomizerImport } from './routes/_auth/_layout/email-customizer';
import { Route as AuthLayoutEmailCampaignsImport } from './routes/_auth/_layout/email-campaigns';
import { Route as AuthLayoutEmailBuilderImport } from './routes/_auth/_layout/email-builder';
import { Route as AuthLayoutDrtIntegrationImport } from './routes/_auth/_layout/drt-integration';
import { Route as AuthLayoutDowntimeImport } from './routes/_auth/_layout/downtime';
import { Route as AuthLayoutDiscountsImport } from './routes/_auth/_layout/discounts';
import { Route as AuthLayoutDemoModeImport } from './routes/_auth/_layout/demo-mode';
import { Route as AuthLayoutDailyDigestImport } from './routes/_auth/_layout/daily-digest';
import { Route as AuthLayoutBugsFeatureImport } from './routes/_auth/_layout/bugs-feature';
import { Route as AuthLayoutAuditLogsImport } from './routes/_auth/_layout/audit-logs';
import { Route as AuthLayoutStudioProfileRouteImport } from './routes/_auth/_layout/studio-profile/route';
import { Route as AuthLayoutStudentsRouteImport } from './routes/_auth/_layout/students/route';
import { Route as AuthLayoutSessionsRouteImport } from './routes/_auth/_layout/sessions/route';
import { Route as AuthLayoutRecitalsRouteImport } from './routes/_auth/_layout/recitals/route';
import { Route as AuthLayoutPerformanceDashboardRouteImport } from './routes/_auth/_layout/performance-dashboard/route';
import { Route as AuthLayoutPaymentRouteImport } from './routes/_auth/_layout/payment/route';
import { Route as AuthLayoutEventsRouteImport } from './routes/_auth/_layout/events/route';
import { Route as AuthLayoutClassesRouteImport } from './routes/_auth/_layout/classes/route';
import { Route as AuthLayoutClassAnalyticsRouteImport } from './routes/_auth/_layout/class-analytics/route';
import { Route as AuthLayoutCategoryConfigRouteImport } from './routes/_auth/_layout/category-config/route';
import { Route as AuthLayoutAttendanceRouteImport } from './routes/_auth/_layout/attendance/route';
import { Route as AuthLayoutStudentsIndexImport } from './routes/_auth/_layout/students/index';
import { Route as AuthLayoutSessionsIndexImport } from './routes/_auth/_layout/sessions/index';
import { Route as AuthLayoutRecitalsIndexImport } from './routes/_auth/_layout/recitals/index';
import { Route as AuthLayoutPoliciesIndexImport } from './routes/_auth/_layout/policies/index';
import { Route as AuthLayoutParentsIndexImport } from './routes/_auth/_layout/parents/index';
import { Route as AuthLayoutEventsIndexImport } from './routes/_auth/_layout/events/index';
import { Route as AuthLayoutClassesIndexImport } from './routes/_auth/_layout/classes/index';
import { Route as AuthLayoutCategoryConfigIndexImport } from './routes/_auth/_layout/category-config/index';
import { Route as AuthLayoutAttendanceIndexImport } from './routes/_auth/_layout/attendance/index';
import { Route as AuthLayoutAnnouncementsIndexImport } from './routes/_auth/_layout/announcements/index';
import { Route as AuthLayoutSessionsRolloverImport } from './routes/_auth/_layout/sessions/rollover';
import { Route as AuthLayoutSessionsNewImport } from './routes/_auth/_layout/sessions/new';
import { Route as AuthLayoutRecitalsNewImport } from './routes/_auth/_layout/recitals/new';
import { Route as AuthLayoutParentsTransactionsTableImport } from './routes/_auth/_layout/parents/transactions-table';
import { Route as AuthLayoutEventsNewImport } from './routes/_auth/_layout/events/new';
import { Route as AuthLayoutClassesTrialStudentsImport } from './routes/_auth/_layout/classes/trial-students';
import { Route as AuthLayoutClassesPrivateLessonsImport } from './routes/_auth/_layout/classes/private-lessons';
import { Route as AuthLayoutClassesBulkUploadImport } from './routes/_auth/_layout/classes/bulk-upload';
import { Route as AuthLayoutCategoryConfigTagsImport } from './routes/_auth/_layout/category-config/tags';
import { Route as AuthLayoutCategoryConfigRoomsImport } from './routes/_auth/_layout/category-config/rooms';
import { Route as AuthLayoutCategoryConfigLocationsImport } from './routes/_auth/_layout/category-config/locations';
import { Route as AuthLayoutCategoryConfigInstructorsImport } from './routes/_auth/_layout/category-config/instructors';
import { Route as AuthLayoutCategoryConfigGroupsImport } from './routes/_auth/_layout/category-config/groups';
import { Route as AuthLayoutSettingsUserManagementImport } from './routes/_auth/_layout/_settings/user-management';
import { Route as AuthLayoutSettingsTrialBookingsImport } from './routes/_auth/_layout/_settings/trial-bookings';
import { Route as AuthLayoutSettingsRemindersImport } from './routes/_auth/_layout/_settings/reminders';
import { Route as AuthLayoutSettingsPreflightCheckImport } from './routes/_auth/_layout/_settings/preflight-check';
import { Route as AuthLayoutSettingsPortalBannerImport } from './routes/_auth/_layout/_settings/portal-banner';
import { Route as AuthLayoutSettingsMakeupClassesImport } from './routes/_auth/_layout/_settings/makeup-classes';
import { Route as AuthLayoutSettingsImportDataLogsImport } from './routes/_auth/_layout/_settings/import-data-logs';
import { Route as AuthLayoutSettingsImportDataImport } from './routes/_auth/_layout/_settings/import-data';
import { Route as AuthLayoutSettingsEmailSettingsImport } from './routes/_auth/_layout/_settings/email-settings';
import { Route as AuthLayoutSettingsCrmEmailSyncImport } from './routes/_auth/_layout/_settings/crm-email-sync';
import { Route as AuthLayoutStudentsStudentIdRouteImport } from './routes/_auth/_layout/students/$studentId/route';
import { Route as AuthLayoutRecitalsRecitalIdRouteImport } from './routes/_auth/_layout/recitals/$recitalId/route';
import { Route as AuthLayoutPoliciesNewRouteImport } from './routes/_auth/_layout/policies/new/route';
import { Route as AuthLayoutPaymentUpcomingPaymentsRouteImport } from './routes/_auth/_layout/payment/upcoming-payments/route';
import { Route as AuthLayoutPaymentTransactionFeeSettingsRouteImport } from './routes/_auth/_layout/payment/transaction-fee-settings/route';
import { Route as AuthLayoutPaymentTransactionCodesRouteImport } from './routes/_auth/_layout/payment/transaction-codes/route';
import { Route as AuthLayoutPaymentStudioTransactionTableRouteImport } from './routes/_auth/_layout/payment/studio-transaction-table/route';
import { Route as AuthLayoutPaymentStudentChargeHistoryRouteImport } from './routes/_auth/_layout/payment/student-charge-history/route';
import { Route as AuthLayoutPaymentPortalCrmEmailSyncIssueRouteImport } from './routes/_auth/_layout/payment/portal-crm-email-sync-issue/route';
import { Route as AuthLayoutPaymentPaymentSettingsRouteImport } from './routes/_auth/_layout/payment/payment-settings/route';
import { Route as AuthLayoutPaymentPaymentRunReviewRouteImport } from './routes/_auth/_layout/payment/payment-run-review/route';
import { Route as AuthLayoutPaymentPaymentReportsRouteImport } from './routes/_auth/_layout/payment/payment-reports/route';
import { Route as AuthLayoutPaymentPaymentProcessingRouteImport } from './routes/_auth/_layout/payment/payment-processing/route';
import { Route as AuthLayoutPaymentPaymentIntegrationRouteImport } from './routes/_auth/_layout/payment/payment-integration/route';
import { Route as AuthLayoutPaymentPaymentDashboardRouteImport } from './routes/_auth/_layout/payment/payment-dashboard/route';
import { Route as AuthLayoutPaymentOutstandingAndOverdueRouteImport } from './routes/_auth/_layout/payment/outstanding-and-overdue/route';
import { Route as AuthLayoutPaymentLateFeesRouteImport } from './routes/_auth/_layout/payment/late-fees/route';
import { Route as AuthLayoutPaymentInvoicesRouteImport } from './routes/_auth/_layout/payment/invoices/route';
import { Route as AuthLayoutPaymentFailedPaymentsRouteImport } from './routes/_auth/_layout/payment/failed-payments/route';
import { Route as AuthLayoutPaymentFailedAndRefundedRouteImport } from './routes/_auth/_layout/payment/failed-and-refunded/route';
import { Route as AuthLayoutPaymentClassChargeHistoryRouteImport } from './routes/_auth/_layout/payment/class-charge-history/route';
import { Route as AuthLayoutPaymentBulkChargeStudentsRouteImport } from './routes/_auth/_layout/payment/bulk-charge-students/route';
import { Route as AuthLayoutPaymentAttendanceReportRouteImport } from './routes/_auth/_layout/payment/attendance-report/route';
import { Route as AuthLayoutFamiliesFamilyIdRouteImport } from './routes/_auth/_layout/families/$familyId/route';
import { Route as AuthLayoutEventsEventIdRouteImport } from './routes/_auth/_layout/events/$eventId/route';
import { Route as AuthLayoutClassesNewRouteImport } from './routes/_auth/_layout/classes/new/route';
import { Route as AuthLayoutClassesClassIdRouteImport } from './routes/_auth/_layout/classes/$classId/route';
import { Route as AuthLayoutClassAnalyticsClassIdRouteImport } from './routes/_auth/_layout/class-analytics/$classId/route';
import { Route as AuthLayoutAttendanceClassIdRouteImport } from './routes/_auth/_layout/attendance/$classId/route';
import { Route as AuthLayoutAnnouncementsNewRouteImport } from './routes/_auth/_layout/announcements/new/route';
import { Route as AuthLayoutStudentsStudentIdIndexImport } from './routes/_auth/_layout/students/$studentId/index';
import { Route as AuthLayoutRecitalsRecitalIdIndexImport } from './routes/_auth/_layout/recitals/$recitalId/index';
import { Route as AuthLayoutPoliciesPolicyIdIndexImport } from './routes/_auth/_layout/policies/$policyId/index';
import { Route as AuthLayoutPaymentHourlyTuitionIndexImport } from './routes/_auth/_layout/payment/hourly-tuition/index';
import { Route as AuthLayoutPaymentClassCountTuitionIndexImport } from './routes/_auth/_layout/payment/class-count-tuition/index';
import { Route as AuthLayoutParentsCsvBatchProcessingIndexImport } from './routes/_auth/_layout/parents/csv-batch-processing/index';
import { Route as AuthLayoutParentsBulkUploadIndexImport } from './routes/_auth/_layout/parents/bulk-upload/index';
import { Route as AuthLayoutFamiliesFamilyIdIndexImport } from './routes/_auth/_layout/families/$familyId/index';
import { Route as AuthLayoutAttendanceClassIdIndexImport } from './routes/_auth/_layout/attendance/$classId/index';
import { Route as AuthLayoutAnnouncementsAnnouncementIdIndexImport } from './routes/_auth/_layout/announcements/$announcementId/index';
import { Route as AuthLayoutStudentsStudentIdPoliciesImport } from './routes/_auth/_layout/students/$studentId/policies';
import { Route as AuthLayoutStudentsStudentIdPaymentsImport } from './routes/_auth/_layout/students/$studentId/payments';
import { Route as AuthLayoutStudentsStudentIdNotesImport } from './routes/_auth/_layout/students/$studentId/notes';
import { Route as AuthLayoutStudentsStudentIdNewPaymentsImport } from './routes/_auth/_layout/students/$studentId/new-payments';
import { Route as AuthLayoutStudentsStudentIdMakeupsImport } from './routes/_auth/_layout/students/$studentId/makeups';
import { Route as AuthLayoutStudentsStudentIdDetailsImport } from './routes/_auth/_layout/students/$studentId/details';
import { Route as AuthLayoutStudentsStudentIdContactsImport } from './routes/_auth/_layout/students/$studentId/contacts';
import { Route as AuthLayoutStudentsStudentIdClassesImport } from './routes/_auth/_layout/students/$studentId/classes';
import { Route as AuthLayoutSessionsSessionIdRolloverImport } from './routes/_auth/_layout/sessions/$sessionId/rollover';
import { Route as AuthLayoutSessionsSessionIdEditImport } from './routes/_auth/_layout/sessions/$sessionId/edit';
import { Route as AuthLayoutParentsBulkUploadHistoryImport } from './routes/_auth/_layout/parents/bulk-upload/history';
import { Route as AuthLayoutParentsParentIdSavedPaymentMethodsImport } from './routes/_auth/_layout/parents/$parentId/saved-payment-methods';
import { Route as AuthLayoutFamiliesFamilyIdTransactionsImport } from './routes/_auth/_layout/families/$familyId/transactions';
import { Route as AuthLayoutFamiliesFamilyIdSummaryImport } from './routes/_auth/_layout/families/$familyId/summary';
import { Route as AuthLayoutFamiliesFamilyIdNotesImport } from './routes/_auth/_layout/families/$familyId/notes';
import { Route as AuthLayoutFamiliesFamilyIdContactsImport } from './routes/_auth/_layout/families/$familyId/contacts';
import { Route as AuthLayoutFamiliesFamilyIdClassesImport } from './routes/_auth/_layout/families/$familyId/classes';
import { Route as AuthLayoutFamiliesFamilyIdBillingImport } from './routes/_auth/_layout/families/$familyId/billing';
import { Route as AuthLayoutEventsEventIdUpdateImport } from './routes/_auth/_layout/events/$eventId/update';
import { Route as AuthLayoutEventsEventIdPaymentsImport } from './routes/_auth/_layout/events/$eventId/payments';
import { Route as AuthLayoutEventsEventIdEnrolledStudentsImport } from './routes/_auth/_layout/events/$eventId/enrolled-students';
import { Route as AuthLayoutClassesClassIdWaitListImport } from './routes/_auth/_layout/classes/$classId/wait-list';
import { Route as AuthLayoutClassesClassIdUpdateImport } from './routes/_auth/_layout/classes/$classId/update';
import { Route as AuthLayoutClassesClassIdEnrolledStudentsImport } from './routes/_auth/_layout/classes/$classId/enrolled-students';
import { Route as AuthLayoutClassesClassIdBulkEnrollStudentsImport } from './routes/_auth/_layout/classes/$classId/bulk-enroll-students';
import { Route as AuthLayoutPaymentHourlyTuitionSettingsRouteImport } from './routes/_auth/_layout/payment/hourly-tuition/settings/route';
import { Route as AuthLayoutPaymentHourlyTuitionReviewRouteImport } from './routes/_auth/_layout/payment/hourly-tuition/review/route';
import { Route as AuthLayoutPaymentHourlyTuitionDraftsRouteImport } from './routes/_auth/_layout/payment/hourly-tuition/drafts/route';
import { Route as AuthLayoutParentsCsvBatchProcessingIdIndexImport } from './routes/_auth/_layout/parents/csv-batch-processing/$id/index';
import { Route as AuthLayoutParentsBulkUploadResultsJobIdImport } from './routes/_auth/_layout/parents/bulk-upload/results.$jobId';

// Create/Update Routes

const LoginRoute = LoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRoute,
} as any);

const GhlAuthorizeRoute = GhlAuthorizeImport.update({
  id: '/ghl-authorize',
  path: '/ghl-authorize',
  getParentRoute: () => rootRoute,
} as any);

const ForgotPasswordRoute = ForgotPasswordImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRoute,
} as any);

const ExchangeUserContextRoute = ExchangeUserContextImport.update({
  id: '/exchange-user-context',
  path: '/exchange-user-context',
  getParentRoute: () => rootRoute,
} as any);

const CrmSessionBreakoutRoute = CrmSessionBreakoutImport.update({
  id: '/crm-session-breakout',
  path: '/crm-session-breakout',
  getParentRoute: () => rootRoute,
} as any);

const ConnectAppRoute = ConnectAppImport.update({
  id: '/connect-app',
  path: '/connect-app',
  getParentRoute: () => rootRoute,
} as any);

const AuthorizeRoute = AuthorizeImport.update({
  id: '/authorize',
  path: '/authorize',
  getParentRoute: () => rootRoute,
} as any);

const AuthRouteRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRoute,
} as any);

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any);

const PublicEventShareShareTokenRoute = PublicEventShareShareTokenImport.update(
  {
    id: '/public-event-share/$shareToken',
    path: '/public-event-share/$shareToken',
    getParentRoute: () => rootRoute,
  } as any,
);

const PublicClassShareShareTokenRoute = PublicClassShareShareTokenImport.update(
  {
    id: '/public-class-share/$shareToken',
    path: '/public-class-share/$shareToken',
    getParentRoute: () => rootRoute,
  } as any,
);

const EmbedFormRoute = EmbedFormImport.update({
  id: '/embed/form',
  path: '/embed/form',
  getParentRoute: () => rootRoute,
} as any);

const AuthSettingsRoute = AuthSettingsImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthRouteRoute,
} as any);

const AuthSetPasswordRoute = AuthSetPasswordImport.update({
  id: '/set-password',
  path: '/set-password',
  getParentRoute: () => AuthRouteRoute,
} as any);

const AuthScheduledDropsRoute = AuthScheduledDropsImport.update({
  id: '/scheduled-drops',
  path: '/scheduled-drops',
  getParentRoute: () => AuthRouteRoute,
} as any);

const AuthRegisterStudentRoute = AuthRegisterStudentImport.update({
  id: '/register-student',
  path: '/register-student',
  getParentRoute: () => AuthRouteRoute,
} as any);

const AuthFamilyRoute = AuthFamilyImport.update({
  id: '/family',
  path: '/family',
  getParentRoute: () => AuthRouteRoute,
} as any);

const AuthEventCalendarRoute = AuthEventCalendarImport.update({
  id: '/event-calendar',
  path: '/event-calendar',
  getParentRoute: () => AuthRouteRoute,
} as any);

const AuthDashboardRoute = AuthDashboardImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthRouteRoute,
} as any);

const AuthClassCalendarRoute = AuthClassCalendarImport.update({
  id: '/class-calendar',
  path: '/class-calendar',
  getParentRoute: () => AuthRouteRoute,
} as any);

const AuthLayoutRouteRoute = AuthLayoutRouteImport.update({
  id: '/_layout',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/_layout/route.lazy').then((d) => d.Route),
);

const PublicClassesClassIdRoute = PublicClassesClassIdImport.update({
  id: '/_public/classes/$classId',
  path: '/classes/$classId',
  getParentRoute: () => rootRoute,
} as any);

const AuthLayoutV2ModeRoute = AuthLayoutV2ModeImport.update({
  id: '/v2-mode',
  path: '/v2-mode',
  getParentRoute: () => AuthLayoutRouteRoute,
} as any);

const AuthLayoutRoomOverviewRoute = AuthLayoutRoomOverviewImport.update({
  id: '/room-overview',
  path: '/room-overview',
  getParentRoute: () => AuthLayoutRouteRoute,
} as any);

const AuthLayoutPublicPageLinkRoute = AuthLayoutPublicPageLinkImport.update({
  id: '/public-page-link',
  path: '/public-page-link',
  getParentRoute: () => AuthLayoutRouteRoute,
} as any);

const AuthLayoutParentPortalLinkRoute = AuthLayoutParentPortalLinkImport.update(
  {
    id: '/parent-portal-link',
    path: '/parent-portal-link',
    getParentRoute: () => AuthLayoutRouteRoute,
  } as any,
);

const AuthLayoutParentFormConfigRoute = AuthLayoutParentFormConfigImport.update(
  {
    id: '/parent-form-config',
    path: '/parent-form-config',
    getParentRoute: () => AuthLayoutRouteRoute,
  } as any,
);

const AuthLayoutOutgoingEmailLogsRoute =
  AuthLayoutOutgoingEmailLogsImport.update({
    id: '/outgoing-email-logs',
    path: '/outgoing-email-logs',
    getParentRoute: () => AuthLayoutRouteRoute,
  } as any);

const AuthLayoutNewDashboardRoute = AuthLayoutNewDashboardImport.update({
  id: '/new-dashboard',
  path: '/new-dashboard',
  getParentRoute: () => AuthLayoutRouteRoute,
} as any);

const AuthLayoutMobileInventorIntegrationRoute =
  AuthLayoutMobileInventorIntegrationImport.update({
    id: '/mobile-inventor-integration',
    path: '/mobile-inventor-integration',
    getParentRoute: () => AuthLayoutRouteRoute,
  } as any);

const AuthLayoutIntegrationsRoute = AuthLayoutIntegrationsImport.update({
  id: '/integrations',
  path: '/integrations',
  getParentRoute: () => AuthLayoutRouteRoute,
} as any);

const AuthLayoutFormsRoute = AuthLayoutFormsImport.update({
  id: '/forms',
  path: '/forms',
  getParentRoute: () => AuthLayoutRouteRoute,
} as any);

const AuthLayoutFormSubmissionsRoute = AuthLayoutFormSubmissionsImport.update({
  id: '/form-submissions',
  path: '/form-submissions',
  getParentRoute: () => AuthLayoutRouteRoute,
} as any);

const AuthLayoutEmailCustomizerRoute = AuthLayoutEmailCustomizerImport.update({
  id: '/email-customizer',
  path: '/email-customizer',
  getParentRoute: () => AuthLayoutRouteRoute,
} as any);

const AuthLayoutEmailCampaignsRoute = AuthLayoutEmailCampaignsImport.update({
  id: '/email-campaigns',
  path: '/email-campaigns',
  getParentRoute: () => AuthLayoutRouteRoute,
} as any);

const AuthLayoutEmailBuilderRoute = AuthLayoutEmailBuilderImport.update({
  id: '/email-builder',
  path: '/email-builder',
  getParentRoute: () => AuthLayoutRouteRoute,
} as any);

const AuthLayoutDrtIntegrationRoute = AuthLayoutDrtIntegrationImport.update({
  id: '/drt-integration',
  path: '/drt-integration',
  getParentRoute: () => AuthLayoutRouteRoute,
} as any);

const AuthLayoutDowntimeRoute = AuthLayoutDowntimeImport.update({
  id: '/downtime',
  path: '/downtime',
  getParentRoute: () => AuthLayoutRouteRoute,
} as any);

const AuthLayoutDiscountsRoute = AuthLayoutDiscountsImport.update({
  id: '/discounts',
  path: '/discounts',
  getParentRoute: () => AuthLayoutRouteRoute,
} as any);

const AuthLayoutDemoModeRoute = AuthLayoutDemoModeImport.update({
  id: '/demo-mode',
  path: '/demo-mode',
  getParentRoute: () => AuthLayoutRouteRoute,
} as any);

const AuthLayoutDailyDigestRoute = AuthLayoutDailyDigestImport.update({
  id: '/daily-digest',
  path: '/daily-digest',
  getParentRoute: () => AuthLayoutRouteRoute,
} as any);

const AuthLayoutBugsFeatureRoute = AuthLayoutBugsFeatureImport.update({
  id: '/bugs-feature',
  path: '/bugs-feature',
  getParentRoute: () => AuthLayoutRouteRoute,
} as any);

const AuthLayoutAuditLogsRoute = AuthLayoutAuditLogsImport.update({
  id: '/audit-logs',
  path: '/audit-logs',
  getParentRoute: () => AuthLayoutRouteRoute,
} as any);

const AuthLayoutStudioProfileRouteRoute =
  AuthLayoutStudioProfileRouteImport.update({
    id: '/studio-profile',
    path: '/studio-profile',
    getParentRoute: () => AuthLayoutRouteRoute,
  } as any);

const AuthLayoutStudentsRouteRoute = AuthLayoutStudentsRouteImport.update({
  id: '/students',
  path: '/students',
  getParentRoute: () => AuthLayoutRouteRoute,
} as any);

const AuthLayoutSessionsRouteRoute = AuthLayoutSessionsRouteImport.update({
  id: '/sessions',
  path: '/sessions',
  getParentRoute: () => AuthLayoutRouteRoute,
} as any);

const AuthLayoutRecitalsRouteRoute = AuthLayoutRecitalsRouteImport.update({
  id: '/recitals',
  path: '/recitals',
  getParentRoute: () => AuthLayoutRouteRoute,
} as any);

const AuthLayoutPerformanceDashboardRouteRoute =
  AuthLayoutPerformanceDashboardRouteImport.update({
    id: '/performance-dashboard',
    path: '/performance-dashboard',
    getParentRoute: () => AuthLayoutRouteRoute,
  } as any);

const AuthLayoutPaymentRouteRoute = AuthLayoutPaymentRouteImport.update({
  id: '/payment',
  path: '/payment',
  getParentRoute: () => AuthLayoutRouteRoute,
} as any);

const AuthLayoutEventsRouteRoute = AuthLayoutEventsRouteImport.update({
  id: '/events',
  path: '/events',
  getParentRoute: () => AuthLayoutRouteRoute,
} as any);

const AuthLayoutClassesRouteRoute = AuthLayoutClassesRouteImport.update({
  id: '/classes',
  path: '/classes',
  getParentRoute: () => AuthLayoutRouteRoute,
} as any);

const AuthLayoutClassAnalyticsRouteRoute =
  AuthLayoutClassAnalyticsRouteImport.update({
    id: '/class-analytics',
    path: '/class-analytics',
    getParentRoute: () => AuthLayoutRouteRoute,
  } as any);

const AuthLayoutCategoryConfigRouteRoute =
  AuthLayoutCategoryConfigRouteImport.update({
    id: '/category-config',
    path: '/category-config',
    getParentRoute: () => AuthLayoutRouteRoute,
  } as any);

const AuthLayoutAttendanceRouteRoute = AuthLayoutAttendanceRouteImport.update({
  id: '/attendance',
  path: '/attendance',
  getParentRoute: () => AuthLayoutRouteRoute,
} as any);

const AuthLayoutStudentsIndexRoute = AuthLayoutStudentsIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthLayoutStudentsRouteRoute,
} as any);

const AuthLayoutSessionsIndexRoute = AuthLayoutSessionsIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthLayoutSessionsRouteRoute,
} as any);

const AuthLayoutRecitalsIndexRoute = AuthLayoutRecitalsIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthLayoutRecitalsRouteRoute,
} as any);

const AuthLayoutPoliciesIndexRoute = AuthLayoutPoliciesIndexImport.update({
  id: '/policies/',
  path: '/policies/',
  getParentRoute: () => AuthLayoutRouteRoute,
} as any);

const AuthLayoutParentsIndexRoute = AuthLayoutParentsIndexImport.update({
  id: '/parents/',
  path: '/parents/',
  getParentRoute: () => AuthLayoutRouteRoute,
} as any);

const AuthLayoutEventsIndexRoute = AuthLayoutEventsIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthLayoutEventsRouteRoute,
} as any);

const AuthLayoutClassesIndexRoute = AuthLayoutClassesIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthLayoutClassesRouteRoute,
} as any);

const AuthLayoutCategoryConfigIndexRoute =
  AuthLayoutCategoryConfigIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthLayoutCategoryConfigRouteRoute,
  } as any);

const AuthLayoutAttendanceIndexRoute = AuthLayoutAttendanceIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthLayoutAttendanceRouteRoute,
} as any);

const AuthLayoutAnnouncementsIndexRoute =
  AuthLayoutAnnouncementsIndexImport.update({
    id: '/announcements/',
    path: '/announcements/',
    getParentRoute: () => AuthLayoutRouteRoute,
  } as any);

const AuthLayoutSessionsRolloverRoute = AuthLayoutSessionsRolloverImport.update(
  {
    id: '/rollover',
    path: '/rollover',
    getParentRoute: () => AuthLayoutSessionsRouteRoute,
  } as any,
);

const AuthLayoutSessionsNewRoute = AuthLayoutSessionsNewImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthLayoutSessionsRouteRoute,
} as any);

const AuthLayoutRecitalsNewRoute = AuthLayoutRecitalsNewImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthLayoutRecitalsRouteRoute,
} as any);

const AuthLayoutParentsTransactionsTableRoute =
  AuthLayoutParentsTransactionsTableImport.update({
    id: '/parents/transactions-table',
    path: '/parents/transactions-table',
    getParentRoute: () => AuthLayoutRouteRoute,
  } as any);

const AuthLayoutEventsNewRoute = AuthLayoutEventsNewImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthLayoutEventsRouteRoute,
} as any);

const AuthLayoutClassesTrialStudentsRoute =
  AuthLayoutClassesTrialStudentsImport.update({
    id: '/trial-students',
    path: '/trial-students',
    getParentRoute: () => AuthLayoutClassesRouteRoute,
  } as any);

const AuthLayoutClassesPrivateLessonsRoute =
  AuthLayoutClassesPrivateLessonsImport.update({
    id: '/private-lessons',
    path: '/private-lessons',
    getParentRoute: () => AuthLayoutClassesRouteRoute,
  } as any);

const AuthLayoutClassesBulkUploadRoute =
  AuthLayoutClassesBulkUploadImport.update({
    id: '/bulk-upload',
    path: '/bulk-upload',
    getParentRoute: () => AuthLayoutClassesRouteRoute,
  } as any);

const AuthLayoutCategoryConfigTagsRoute =
  AuthLayoutCategoryConfigTagsImport.update({
    id: '/tags',
    path: '/tags',
    getParentRoute: () => AuthLayoutCategoryConfigRouteRoute,
  } as any);

const AuthLayoutCategoryConfigRoomsRoute =
  AuthLayoutCategoryConfigRoomsImport.update({
    id: '/rooms',
    path: '/rooms',
    getParentRoute: () => AuthLayoutCategoryConfigRouteRoute,
  } as any);

const AuthLayoutCategoryConfigLocationsRoute =
  AuthLayoutCategoryConfigLocationsImport.update({
    id: '/locations',
    path: '/locations',
    getParentRoute: () => AuthLayoutCategoryConfigRouteRoute,
  } as any);

const AuthLayoutCategoryConfigInstructorsRoute =
  AuthLayoutCategoryConfigInstructorsImport.update({
    id: '/instructors',
    path: '/instructors',
    getParentRoute: () => AuthLayoutCategoryConfigRouteRoute,
  } as any);

const AuthLayoutCategoryConfigGroupsRoute =
  AuthLayoutCategoryConfigGroupsImport.update({
    id: '/groups',
    path: '/groups',
    getParentRoute: () => AuthLayoutCategoryConfigRouteRoute,
  } as any);

const AuthLayoutSettingsUserManagementRoute =
  AuthLayoutSettingsUserManagementImport.update({
    id: '/_settings/user-management',
    path: '/user-management',
    getParentRoute: () => AuthLayoutRouteRoute,
  } as any);

const AuthLayoutSettingsTrialBookingsRoute =
  AuthLayoutSettingsTrialBookingsImport.update({
    id: '/_settings/trial-bookings',
    path: '/trial-bookings',
    getParentRoute: () => AuthLayoutRouteRoute,
  } as any);

const AuthLayoutSettingsRemindersRoute =
  AuthLayoutSettingsRemindersImport.update({
    id: '/_settings/reminders',
    path: '/reminders',
    getParentRoute: () => AuthLayoutRouteRoute,
  } as any);

const AuthLayoutSettingsPreflightCheckRoute =
  AuthLayoutSettingsPreflightCheckImport.update({
    id: '/_settings/preflight-check',
    path: '/preflight-check',
    getParentRoute: () => AuthLayoutRouteRoute,
  } as any);

const AuthLayoutSettingsPortalBannerRoute =
  AuthLayoutSettingsPortalBannerImport.update({
    id: '/_settings/portal-banner',
    path: '/portal-banner',
    getParentRoute: () => AuthLayoutRouteRoute,
  } as any);

const AuthLayoutSettingsMakeupClassesRoute =
  AuthLayoutSettingsMakeupClassesImport.update({
    id: '/_settings/makeup-classes',
    path: '/makeup-classes',
    getParentRoute: () => AuthLayoutRouteRoute,
  } as any);

const AuthLayoutSettingsImportDataLogsRoute =
  AuthLayoutSettingsImportDataLogsImport.update({
    id: '/_settings/import-data-logs',
    path: '/import-data-logs',
    getParentRoute: () => AuthLayoutRouteRoute,
  } as any);

const AuthLayoutSettingsImportDataRoute =
  AuthLayoutSettingsImportDataImport.update({
    id: '/_settings/import-data',
    path: '/import-data',
    getParentRoute: () => AuthLayoutRouteRoute,
  } as any);

const AuthLayoutSettingsEmailSettingsRoute =
  AuthLayoutSettingsEmailSettingsImport.update({
    id: '/_settings/email-settings',
    path: '/email-settings',
    getParentRoute: () => AuthLayoutRouteRoute,
  } as any);

const AuthLayoutSettingsCrmEmailSyncRoute =
  AuthLayoutSettingsCrmEmailSyncImport.update({
    id: '/_settings/crm-email-sync',
    path: '/crm-email-sync',
    getParentRoute: () => AuthLayoutRouteRoute,
  } as any);

const AuthLayoutStudentsStudentIdRouteRoute =
  AuthLayoutStudentsStudentIdRouteImport.update({
    id: '/$studentId',
    path: '/$studentId',
    getParentRoute: () => AuthLayoutStudentsRouteRoute,
  } as any);

const AuthLayoutRecitalsRecitalIdRouteRoute =
  AuthLayoutRecitalsRecitalIdRouteImport.update({
    id: '/$recitalId',
    path: '/$recitalId',
    getParentRoute: () => AuthLayoutRecitalsRouteRoute,
  } as any);

const AuthLayoutPoliciesNewRouteRoute = AuthLayoutPoliciesNewRouteImport.update(
  {
    id: '/policies/new',
    path: '/policies/new',
    getParentRoute: () => AuthLayoutRouteRoute,
  } as any,
).lazy(() =>
  import('./routes/_auth/_layout/policies/new/route.lazy').then((d) => d.Route),
);

const AuthLayoutPaymentUpcomingPaymentsRouteRoute =
  AuthLayoutPaymentUpcomingPaymentsRouteImport.update({
    id: '/upcoming-payments',
    path: '/upcoming-payments',
    getParentRoute: () => AuthLayoutPaymentRouteRoute,
  } as any);

const AuthLayoutPaymentTransactionFeeSettingsRouteRoute =
  AuthLayoutPaymentTransactionFeeSettingsRouteImport.update({
    id: '/transaction-fee-settings',
    path: '/transaction-fee-settings',
    getParentRoute: () => AuthLayoutPaymentRouteRoute,
  } as any);

const AuthLayoutPaymentTransactionCodesRouteRoute =
  AuthLayoutPaymentTransactionCodesRouteImport.update({
    id: '/transaction-codes',
    path: '/transaction-codes',
    getParentRoute: () => AuthLayoutPaymentRouteRoute,
  } as any);

const AuthLayoutPaymentStudioTransactionTableRouteRoute =
  AuthLayoutPaymentStudioTransactionTableRouteImport.update({
    id: '/studio-transaction-table',
    path: '/studio-transaction-table',
    getParentRoute: () => AuthLayoutPaymentRouteRoute,
  } as any);

const AuthLayoutPaymentStudentChargeHistoryRouteRoute =
  AuthLayoutPaymentStudentChargeHistoryRouteImport.update({
    id: '/student-charge-history',
    path: '/student-charge-history',
    getParentRoute: () => AuthLayoutPaymentRouteRoute,
  } as any);

const AuthLayoutPaymentPortalCrmEmailSyncIssueRouteRoute =
  AuthLayoutPaymentPortalCrmEmailSyncIssueRouteImport.update({
    id: '/portal-crm-email-sync-issue',
    path: '/portal-crm-email-sync-issue',
    getParentRoute: () => AuthLayoutPaymentRouteRoute,
  } as any);

const AuthLayoutPaymentPaymentSettingsRouteRoute =
  AuthLayoutPaymentPaymentSettingsRouteImport.update({
    id: '/payment-settings',
    path: '/payment-settings',
    getParentRoute: () => AuthLayoutPaymentRouteRoute,
  } as any);

const AuthLayoutPaymentPaymentRunReviewRouteRoute =
  AuthLayoutPaymentPaymentRunReviewRouteImport.update({
    id: '/payment-run-review',
    path: '/payment-run-review',
    getParentRoute: () => AuthLayoutPaymentRouteRoute,
  } as any);

const AuthLayoutPaymentPaymentReportsRouteRoute =
  AuthLayoutPaymentPaymentReportsRouteImport.update({
    id: '/payment-reports',
    path: '/payment-reports',
    getParentRoute: () => AuthLayoutPaymentRouteRoute,
  } as any);

const AuthLayoutPaymentPaymentProcessingRouteRoute =
  AuthLayoutPaymentPaymentProcessingRouteImport.update({
    id: '/payment-processing',
    path: '/payment-processing',
    getParentRoute: () => AuthLayoutPaymentRouteRoute,
  } as any);

const AuthLayoutPaymentPaymentIntegrationRouteRoute =
  AuthLayoutPaymentPaymentIntegrationRouteImport.update({
    id: '/payment-integration',
    path: '/payment-integration',
    getParentRoute: () => AuthLayoutPaymentRouteRoute,
  } as any);

const AuthLayoutPaymentPaymentDashboardRouteRoute =
  AuthLayoutPaymentPaymentDashboardRouteImport.update({
    id: '/payment-dashboard',
    path: '/payment-dashboard',
    getParentRoute: () => AuthLayoutPaymentRouteRoute,
  } as any);

const AuthLayoutPaymentOutstandingAndOverdueRouteRoute =
  AuthLayoutPaymentOutstandingAndOverdueRouteImport.update({
    id: '/outstanding-and-overdue',
    path: '/outstanding-and-overdue',
    getParentRoute: () => AuthLayoutPaymentRouteRoute,
  } as any);

const AuthLayoutPaymentLateFeesRouteRoute =
  AuthLayoutPaymentLateFeesRouteImport.update({
    id: '/late-fees',
    path: '/late-fees',
    getParentRoute: () => AuthLayoutPaymentRouteRoute,
  } as any);

const AuthLayoutPaymentInvoicesRouteRoute =
  AuthLayoutPaymentInvoicesRouteImport.update({
    id: '/invoices',
    path: '/invoices',
    getParentRoute: () => AuthLayoutPaymentRouteRoute,
  } as any);

const AuthLayoutPaymentFailedPaymentsRouteRoute =
  AuthLayoutPaymentFailedPaymentsRouteImport.update({
    id: '/failed-payments',
    path: '/failed-payments',
    getParentRoute: () => AuthLayoutPaymentRouteRoute,
  } as any);

const AuthLayoutPaymentFailedAndRefundedRouteRoute =
  AuthLayoutPaymentFailedAndRefundedRouteImport.update({
    id: '/failed-and-refunded',
    path: '/failed-and-refunded',
    getParentRoute: () => AuthLayoutPaymentRouteRoute,
  } as any);

const AuthLayoutPaymentClassChargeHistoryRouteRoute =
  AuthLayoutPaymentClassChargeHistoryRouteImport.update({
    id: '/class-charge-history',
    path: '/class-charge-history',
    getParentRoute: () => AuthLayoutPaymentRouteRoute,
  } as any);

const AuthLayoutPaymentBulkChargeStudentsRouteRoute =
  AuthLayoutPaymentBulkChargeStudentsRouteImport.update({
    id: '/bulk-charge-students',
    path: '/bulk-charge-students',
    getParentRoute: () => AuthLayoutPaymentRouteRoute,
  } as any);

const AuthLayoutPaymentAttendanceReportRouteRoute =
  AuthLayoutPaymentAttendanceReportRouteImport.update({
    id: '/attendance-report',
    path: '/attendance-report',
    getParentRoute: () => AuthLayoutPaymentRouteRoute,
  } as any);

const AuthLayoutFamiliesFamilyIdRouteRoute =
  AuthLayoutFamiliesFamilyIdRouteImport.update({
    id: '/families/$familyId',
    path: '/families/$familyId',
    getParentRoute: () => AuthLayoutRouteRoute,
  } as any);

const AuthLayoutEventsEventIdRouteRoute =
  AuthLayoutEventsEventIdRouteImport.update({
    id: '/$eventId',
    path: '/$eventId',
    getParentRoute: () => AuthLayoutEventsRouteRoute,
  } as any);

const AuthLayoutClassesNewRouteRoute = AuthLayoutClassesNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthLayoutClassesRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/_layout/classes/new/route.lazy').then((d) => d.Route),
);

const AuthLayoutClassesClassIdRouteRoute =
  AuthLayoutClassesClassIdRouteImport.update({
    id: '/$classId',
    path: '/$classId',
    getParentRoute: () => AuthLayoutClassesRouteRoute,
  } as any);

const AuthLayoutClassAnalyticsClassIdRouteRoute =
  AuthLayoutClassAnalyticsClassIdRouteImport.update({
    id: '/$classId',
    path: '/$classId',
    getParentRoute: () => AuthLayoutClassAnalyticsRouteRoute,
  } as any);

const AuthLayoutAttendanceClassIdRouteRoute =
  AuthLayoutAttendanceClassIdRouteImport.update({
    id: '/$classId',
    path: '/$classId',
    getParentRoute: () => AuthLayoutAttendanceRouteRoute,
  } as any);

const AuthLayoutAnnouncementsNewRouteRoute =
  AuthLayoutAnnouncementsNewRouteImport.update({
    id: '/announcements/new',
    path: '/announcements/new',
    getParentRoute: () => AuthLayoutRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth/_layout/announcements/new/route.lazy').then(
      (d) => d.Route,
    ),
  );

const AuthLayoutStudentsStudentIdIndexRoute =
  AuthLayoutStudentsStudentIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthLayoutStudentsStudentIdRouteRoute,
  } as any);

const AuthLayoutRecitalsRecitalIdIndexRoute =
  AuthLayoutRecitalsRecitalIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthLayoutRecitalsRecitalIdRouteRoute,
  } as any);

const AuthLayoutPoliciesPolicyIdIndexRoute =
  AuthLayoutPoliciesPolicyIdIndexImport.update({
    id: '/policies/$policyId/',
    path: '/policies/$policyId/',
    getParentRoute: () => AuthLayoutRouteRoute,
  } as any);

const AuthLayoutPaymentHourlyTuitionIndexRoute =
  AuthLayoutPaymentHourlyTuitionIndexImport.update({
    id: '/hourly-tuition/',
    path: '/hourly-tuition/',
    getParentRoute: () => AuthLayoutPaymentRouteRoute,
  } as any);

const AuthLayoutPaymentClassCountTuitionIndexRoute =
  AuthLayoutPaymentClassCountTuitionIndexImport.update({
    id: '/class-count-tuition/',
    path: '/class-count-tuition/',
    getParentRoute: () => AuthLayoutPaymentRouteRoute,
  } as any);

const AuthLayoutParentsCsvBatchProcessingIndexRoute =
  AuthLayoutParentsCsvBatchProcessingIndexImport.update({
    id: '/parents/csv-batch-processing/',
    path: '/parents/csv-batch-processing/',
    getParentRoute: () => AuthLayoutRouteRoute,
  } as any);

const AuthLayoutParentsBulkUploadIndexRoute =
  AuthLayoutParentsBulkUploadIndexImport.update({
    id: '/parents/bulk-upload/',
    path: '/parents/bulk-upload/',
    getParentRoute: () => AuthLayoutRouteRoute,
  } as any);

const AuthLayoutFamiliesFamilyIdIndexRoute =
  AuthLayoutFamiliesFamilyIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthLayoutFamiliesFamilyIdRouteRoute,
  } as any);

const AuthLayoutAttendanceClassIdIndexRoute =
  AuthLayoutAttendanceClassIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthLayoutAttendanceClassIdRouteRoute,
  } as any);

const AuthLayoutAnnouncementsAnnouncementIdIndexRoute =
  AuthLayoutAnnouncementsAnnouncementIdIndexImport.update({
    id: '/announcements/$announcementId/',
    path: '/announcements/$announcementId/',
    getParentRoute: () => AuthLayoutRouteRoute,
  } as any);

const AuthLayoutStudentsStudentIdPoliciesRoute =
  AuthLayoutStudentsStudentIdPoliciesImport.update({
    id: '/policies',
    path: '/policies',
    getParentRoute: () => AuthLayoutStudentsStudentIdRouteRoute,
  } as any);

const AuthLayoutStudentsStudentIdPaymentsRoute =
  AuthLayoutStudentsStudentIdPaymentsImport.update({
    id: '/payments',
    path: '/payments',
    getParentRoute: () => AuthLayoutStudentsStudentIdRouteRoute,
  } as any);

const AuthLayoutStudentsStudentIdNotesRoute =
  AuthLayoutStudentsStudentIdNotesImport.update({
    id: '/notes',
    path: '/notes',
    getParentRoute: () => AuthLayoutStudentsStudentIdRouteRoute,
  } as any);

const AuthLayoutStudentsStudentIdNewPaymentsRoute =
  AuthLayoutStudentsStudentIdNewPaymentsImport.update({
    id: '/new-payments',
    path: '/new-payments',
    getParentRoute: () => AuthLayoutStudentsStudentIdRouteRoute,
  } as any);

const AuthLayoutStudentsStudentIdMakeupsRoute =
  AuthLayoutStudentsStudentIdMakeupsImport.update({
    id: '/makeups',
    path: '/makeups',
    getParentRoute: () => AuthLayoutStudentsStudentIdRouteRoute,
  } as any);

const AuthLayoutStudentsStudentIdDetailsRoute =
  AuthLayoutStudentsStudentIdDetailsImport.update({
    id: '/details',
    path: '/details',
    getParentRoute: () => AuthLayoutStudentsStudentIdRouteRoute,
  } as any);

const AuthLayoutStudentsStudentIdContactsRoute =
  AuthLayoutStudentsStudentIdContactsImport.update({
    id: '/contacts',
    path: '/contacts',
    getParentRoute: () => AuthLayoutStudentsStudentIdRouteRoute,
  } as any);

const AuthLayoutStudentsStudentIdClassesRoute =
  AuthLayoutStudentsStudentIdClassesImport.update({
    id: '/classes',
    path: '/classes',
    getParentRoute: () => AuthLayoutStudentsStudentIdRouteRoute,
  } as any);

const AuthLayoutSessionsSessionIdRolloverRoute =
  AuthLayoutSessionsSessionIdRolloverImport.update({
    id: '/$sessionId/rollover',
    path: '/$sessionId/rollover',
    getParentRoute: () => AuthLayoutSessionsRouteRoute,
  } as any);

const AuthLayoutSessionsSessionIdEditRoute =
  AuthLayoutSessionsSessionIdEditImport.update({
    id: '/$sessionId/edit',
    path: '/$sessionId/edit',
    getParentRoute: () => AuthLayoutSessionsRouteRoute,
  } as any);

const AuthLayoutParentsBulkUploadHistoryRoute =
  AuthLayoutParentsBulkUploadHistoryImport.update({
    id: '/parents/bulk-upload/history',
    path: '/parents/bulk-upload/history',
    getParentRoute: () => AuthLayoutRouteRoute,
  } as any);

const AuthLayoutParentsParentIdSavedPaymentMethodsRoute =
  AuthLayoutParentsParentIdSavedPaymentMethodsImport.update({
    id: '/parents/$parentId/saved-payment-methods',
    path: '/parents/$parentId/saved-payment-methods',
    getParentRoute: () => AuthLayoutRouteRoute,
  } as any);

const AuthLayoutFamiliesFamilyIdTransactionsRoute =
  AuthLayoutFamiliesFamilyIdTransactionsImport.update({
    id: '/transactions',
    path: '/transactions',
    getParentRoute: () => AuthLayoutFamiliesFamilyIdRouteRoute,
  } as any);

const AuthLayoutFamiliesFamilyIdSummaryRoute =
  AuthLayoutFamiliesFamilyIdSummaryImport.update({
    id: '/summary',
    path: '/summary',
    getParentRoute: () => AuthLayoutFamiliesFamilyIdRouteRoute,
  } as any);

const AuthLayoutFamiliesFamilyIdNotesRoute =
  AuthLayoutFamiliesFamilyIdNotesImport.update({
    id: '/notes',
    path: '/notes',
    getParentRoute: () => AuthLayoutFamiliesFamilyIdRouteRoute,
  } as any);

const AuthLayoutFamiliesFamilyIdContactsRoute =
  AuthLayoutFamiliesFamilyIdContactsImport.update({
    id: '/contacts',
    path: '/contacts',
    getParentRoute: () => AuthLayoutFamiliesFamilyIdRouteRoute,
  } as any);

const AuthLayoutFamiliesFamilyIdClassesRoute =
  AuthLayoutFamiliesFamilyIdClassesImport.update({
    id: '/classes',
    path: '/classes',
    getParentRoute: () => AuthLayoutFamiliesFamilyIdRouteRoute,
  } as any);

const AuthLayoutFamiliesFamilyIdBillingRoute =
  AuthLayoutFamiliesFamilyIdBillingImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => AuthLayoutFamiliesFamilyIdRouteRoute,
  } as any);

const AuthLayoutEventsEventIdUpdateRoute =
  AuthLayoutEventsEventIdUpdateImport.update({
    id: '/update',
    path: '/update',
    getParentRoute: () => AuthLayoutEventsEventIdRouteRoute,
  } as any);

const AuthLayoutEventsEventIdPaymentsRoute =
  AuthLayoutEventsEventIdPaymentsImport.update({
    id: '/payments',
    path: '/payments',
    getParentRoute: () => AuthLayoutEventsEventIdRouteRoute,
  } as any);

const AuthLayoutEventsEventIdEnrolledStudentsRoute =
  AuthLayoutEventsEventIdEnrolledStudentsImport.update({
    id: '/enrolled-students',
    path: '/enrolled-students',
    getParentRoute: () => AuthLayoutEventsEventIdRouteRoute,
  } as any);

const AuthLayoutClassesClassIdWaitListRoute =
  AuthLayoutClassesClassIdWaitListImport.update({
    id: '/wait-list',
    path: '/wait-list',
    getParentRoute: () => AuthLayoutClassesClassIdRouteRoute,
  } as any);

const AuthLayoutClassesClassIdUpdateRoute =
  AuthLayoutClassesClassIdUpdateImport.update({
    id: '/update',
    path: '/update',
    getParentRoute: () => AuthLayoutClassesClassIdRouteRoute,
  } as any);

const AuthLayoutClassesClassIdEnrolledStudentsRoute =
  AuthLayoutClassesClassIdEnrolledStudentsImport.update({
    id: '/enrolled-students',
    path: '/enrolled-students',
    getParentRoute: () => AuthLayoutClassesClassIdRouteRoute,
  } as any);

const AuthLayoutClassesClassIdBulkEnrollStudentsRoute =
  AuthLayoutClassesClassIdBulkEnrollStudentsImport.update({
    id: '/bulk-enroll-students',
    path: '/bulk-enroll-students',
    getParentRoute: () => AuthLayoutClassesClassIdRouteRoute,
  } as any);

const AuthLayoutPaymentHourlyTuitionSettingsRouteRoute =
  AuthLayoutPaymentHourlyTuitionSettingsRouteImport.update({
    id: '/hourly-tuition/settings',
    path: '/hourly-tuition/settings',
    getParentRoute: () => AuthLayoutPaymentRouteRoute,
  } as any);

const AuthLayoutPaymentHourlyTuitionReviewRouteRoute =
  AuthLayoutPaymentHourlyTuitionReviewRouteImport.update({
    id: '/hourly-tuition/review',
    path: '/hourly-tuition/review',
    getParentRoute: () => AuthLayoutPaymentRouteRoute,
  } as any);

const AuthLayoutPaymentHourlyTuitionDraftsRouteRoute =
  AuthLayoutPaymentHourlyTuitionDraftsRouteImport.update({
    id: '/hourly-tuition/drafts',
    path: '/hourly-tuition/drafts',
    getParentRoute: () => AuthLayoutPaymentRouteRoute,
  } as any);

const AuthLayoutParentsCsvBatchProcessingIdIndexRoute =
  AuthLayoutParentsCsvBatchProcessingIdIndexImport.update({
    id: '/parents/csv-batch-processing/$id/',
    path: '/parents/csv-batch-processing/$id/',
    getParentRoute: () => AuthLayoutRouteRoute,
  } as any);

const AuthLayoutParentsBulkUploadResultsJobIdRoute =
  AuthLayoutParentsBulkUploadResultsJobIdImport.update({
    id: '/parents/bulk-upload/results/$jobId',
    path: '/parents/bulk-upload/results/$jobId',
    getParentRoute: () => AuthLayoutRouteRoute,
  } as any);

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexImport;
      parentRoute: typeof rootRoute;
    };
    '/_auth': {
      id: '/_auth';
      path: '';
      fullPath: '';
      preLoaderRoute: typeof AuthRouteImport;
      parentRoute: typeof rootRoute;
    };
    '/authorize': {
      id: '/authorize';
      path: '/authorize';
      fullPath: '/authorize';
      preLoaderRoute: typeof AuthorizeImport;
      parentRoute: typeof rootRoute;
    };
    '/connect-app': {
      id: '/connect-app';
      path: '/connect-app';
      fullPath: '/connect-app';
      preLoaderRoute: typeof ConnectAppImport;
      parentRoute: typeof rootRoute;
    };
    '/crm-session-breakout': {
      id: '/crm-session-breakout';
      path: '/crm-session-breakout';
      fullPath: '/crm-session-breakout';
      preLoaderRoute: typeof CrmSessionBreakoutImport;
      parentRoute: typeof rootRoute;
    };
    '/exchange-user-context': {
      id: '/exchange-user-context';
      path: '/exchange-user-context';
      fullPath: '/exchange-user-context';
      preLoaderRoute: typeof ExchangeUserContextImport;
      parentRoute: typeof rootRoute;
    };
    '/forgot-password': {
      id: '/forgot-password';
      path: '/forgot-password';
      fullPath: '/forgot-password';
      preLoaderRoute: typeof ForgotPasswordImport;
      parentRoute: typeof rootRoute;
    };
    '/ghl-authorize': {
      id: '/ghl-authorize';
      path: '/ghl-authorize';
      fullPath: '/ghl-authorize';
      preLoaderRoute: typeof GhlAuthorizeImport;
      parentRoute: typeof rootRoute;
    };
    '/login': {
      id: '/login';
      path: '/login';
      fullPath: '/login';
      preLoaderRoute: typeof LoginImport;
      parentRoute: typeof rootRoute;
    };
    '/_auth/_layout': {
      id: '/_auth/_layout';
      path: '';
      fullPath: '';
      preLoaderRoute: typeof AuthLayoutRouteImport;
      parentRoute: typeof AuthRouteImport;
    };
    '/_auth/class-calendar': {
      id: '/_auth/class-calendar';
      path: '/class-calendar';
      fullPath: '/class-calendar';
      preLoaderRoute: typeof AuthClassCalendarImport;
      parentRoute: typeof AuthRouteImport;
    };
    '/_auth/dashboard': {
      id: '/_auth/dashboard';
      path: '/dashboard';
      fullPath: '/dashboard';
      preLoaderRoute: typeof AuthDashboardImport;
      parentRoute: typeof AuthRouteImport;
    };
    '/_auth/event-calendar': {
      id: '/_auth/event-calendar';
      path: '/event-calendar';
      fullPath: '/event-calendar';
      preLoaderRoute: typeof AuthEventCalendarImport;
      parentRoute: typeof AuthRouteImport;
    };
    '/_auth/family': {
      id: '/_auth/family';
      path: '/family';
      fullPath: '/family';
      preLoaderRoute: typeof AuthFamilyImport;
      parentRoute: typeof AuthRouteImport;
    };
    '/_auth/register-student': {
      id: '/_auth/register-student';
      path: '/register-student';
      fullPath: '/register-student';
      preLoaderRoute: typeof AuthRegisterStudentImport;
      parentRoute: typeof AuthRouteImport;
    };
    '/_auth/scheduled-drops': {
      id: '/_auth/scheduled-drops';
      path: '/scheduled-drops';
      fullPath: '/scheduled-drops';
      preLoaderRoute: typeof AuthScheduledDropsImport;
      parentRoute: typeof AuthRouteImport;
    };
    '/_auth/set-password': {
      id: '/_auth/set-password';
      path: '/set-password';
      fullPath: '/set-password';
      preLoaderRoute: typeof AuthSetPasswordImport;
      parentRoute: typeof AuthRouteImport;
    };
    '/_auth/settings': {
      id: '/_auth/settings';
      path: '/settings';
      fullPath: '/settings';
      preLoaderRoute: typeof AuthSettingsImport;
      parentRoute: typeof AuthRouteImport;
    };
    '/embed/form': {
      id: '/embed/form';
      path: '/embed/form';
      fullPath: '/embed/form';
      preLoaderRoute: typeof EmbedFormImport;
      parentRoute: typeof rootRoute;
    };
    '/public-class-share/$shareToken': {
      id: '/public-class-share/$shareToken';
      path: '/public-class-share/$shareToken';
      fullPath: '/public-class-share/$shareToken';
      preLoaderRoute: typeof PublicClassShareShareTokenImport;
      parentRoute: typeof rootRoute;
    };
    '/public-event-share/$shareToken': {
      id: '/public-event-share/$shareToken';
      path: '/public-event-share/$shareToken';
      fullPath: '/public-event-share/$shareToken';
      preLoaderRoute: typeof PublicEventShareShareTokenImport;
      parentRoute: typeof rootRoute;
    };
    '/_auth/_layout/attendance': {
      id: '/_auth/_layout/attendance';
      path: '/attendance';
      fullPath: '/attendance';
      preLoaderRoute: typeof AuthLayoutAttendanceRouteImport;
      parentRoute: typeof AuthLayoutRouteImport;
    };
    '/_auth/_layout/category-config': {
      id: '/_auth/_layout/category-config';
      path: '/category-config';
      fullPath: '/category-config';
      preLoaderRoute: typeof AuthLayoutCategoryConfigRouteImport;
      parentRoute: typeof AuthLayoutRouteImport;
    };
    '/_auth/_layout/class-analytics': {
      id: '/_auth/_layout/class-analytics';
      path: '/class-analytics';
      fullPath: '/class-analytics';
      preLoaderRoute: typeof AuthLayoutClassAnalyticsRouteImport;
      parentRoute: typeof AuthLayoutRouteImport;
    };
    '/_auth/_layout/classes': {
      id: '/_auth/_layout/classes';
      path: '/classes';
      fullPath: '/classes';
      preLoaderRoute: typeof AuthLayoutClassesRouteImport;
      parentRoute: typeof AuthLayoutRouteImport;
    };
    '/_auth/_layout/events': {
      id: '/_auth/_layout/events';
      path: '/events';
      fullPath: '/events';
      preLoaderRoute: typeof AuthLayoutEventsRouteImport;
      parentRoute: typeof AuthLayoutRouteImport;
    };
    '/_auth/_layout/payment': {
      id: '/_auth/_layout/payment';
      path: '/payment';
      fullPath: '/payment';
      preLoaderRoute: typeof AuthLayoutPaymentRouteImport;
      parentRoute: typeof AuthLayoutRouteImport;
    };
    '/_auth/_layout/performance-dashboard': {
      id: '/_auth/_layout/performance-dashboard';
      path: '/performance-dashboard';
      fullPath: '/performance-dashboard';
      preLoaderRoute: typeof AuthLayoutPerformanceDashboardRouteImport;
      parentRoute: typeof AuthLayoutRouteImport;
    };
    '/_auth/_layout/recitals': {
      id: '/_auth/_layout/recitals';
      path: '/recitals';
      fullPath: '/recitals';
      preLoaderRoute: typeof AuthLayoutRecitalsRouteImport;
      parentRoute: typeof AuthLayoutRouteImport;
    };
    '/_auth/_layout/sessions': {
      id: '/_auth/_layout/sessions';
      path: '/sessions';
      fullPath: '/sessions';
      preLoaderRoute: typeof AuthLayoutSessionsRouteImport;
      parentRoute: typeof AuthLayoutRouteImport;
    };
    '/_auth/_layout/students': {
      id: '/_auth/_layout/students';
      path: '/students';
      fullPath: '/students';
      preLoaderRoute: typeof AuthLayoutStudentsRouteImport;
      parentRoute: typeof AuthLayoutRouteImport;
    };
    '/_auth/_layout/studio-profile': {
      id: '/_auth/_layout/studio-profile';
      path: '/studio-profile';
      fullPath: '/studio-profile';
      preLoaderRoute: typeof AuthLayoutStudioProfileRouteImport;
      parentRoute: typeof AuthLayoutRouteImport;
    };
    '/_auth/_layout/audit-logs': {
      id: '/_auth/_layout/audit-logs';
      path: '/audit-logs';
      fullPath: '/audit-logs';
      preLoaderRoute: typeof AuthLayoutAuditLogsImport;
      parentRoute: typeof AuthLayoutRouteImport;
    };
    '/_auth/_layout/bugs-feature': {
      id: '/_auth/_layout/bugs-feature';
      path: '/bugs-feature';
      fullPath: '/bugs-feature';
      preLoaderRoute: typeof AuthLayoutBugsFeatureImport;
      parentRoute: typeof AuthLayoutRouteImport;
    };
    '/_auth/_layout/daily-digest': {
      id: '/_auth/_layout/daily-digest';
      path: '/daily-digest';
      fullPath: '/daily-digest';
      preLoaderRoute: typeof AuthLayoutDailyDigestImport;
      parentRoute: typeof AuthLayoutRouteImport;
    };
    '/_auth/_layout/demo-mode': {
      id: '/_auth/_layout/demo-mode';
      path: '/demo-mode';
      fullPath: '/demo-mode';
      preLoaderRoute: typeof AuthLayoutDemoModeImport;
      parentRoute: typeof AuthLayoutRouteImport;
    };
    '/_auth/_layout/discounts': {
      id: '/_auth/_layout/discounts';
      path: '/discounts';
      fullPath: '/discounts';
      preLoaderRoute: typeof AuthLayoutDiscountsImport;
      parentRoute: typeof AuthLayoutRouteImport;
    };
    '/_auth/_layout/downtime': {
      id: '/_auth/_layout/downtime';
      path: '/downtime';
      fullPath: '/downtime';
      preLoaderRoute: typeof AuthLayoutDowntimeImport;
      parentRoute: typeof AuthLayoutRouteImport;
    };
    '/_auth/_layout/drt-integration': {
      id: '/_auth/_layout/drt-integration';
      path: '/drt-integration';
      fullPath: '/drt-integration';
      preLoaderRoute: typeof AuthLayoutDrtIntegrationImport;
      parentRoute: typeof AuthLayoutRouteImport;
    };
    '/_auth/_layout/email-builder': {
      id: '/_auth/_layout/email-builder';
      path: '/email-builder';
      fullPath: '/email-builder';
      preLoaderRoute: typeof AuthLayoutEmailBuilderImport;
      parentRoute: typeof AuthLayoutRouteImport;
    };
    '/_auth/_layout/email-campaigns': {
      id: '/_auth/_layout/email-campaigns';
      path: '/email-campaigns';
      fullPath: '/email-campaigns';
      preLoaderRoute: typeof AuthLayoutEmailCampaignsImport;
      parentRoute: typeof AuthLayoutRouteImport;
    };
    '/_auth/_layout/email-customizer': {
      id: '/_auth/_layout/email-customizer';
      path: '/email-customizer';
      fullPath: '/email-customizer';
      preLoaderRoute: typeof AuthLayoutEmailCustomizerImport;
      parentRoute: typeof AuthLayoutRouteImport;
    };
    '/_auth/_layout/form-submissions': {
      id: '/_auth/_layout/form-submissions';
      path: '/form-submissions';
      fullPath: '/form-submissions';
      preLoaderRoute: typeof AuthLayoutFormSubmissionsImport;
      parentRoute: typeof AuthLayoutRouteImport;
    };
    '/_auth/_layout/forms': {
      id: '/_auth/_layout/forms';
      path: '/forms';
      fullPath: '/forms';
      preLoaderRoute: typeof AuthLayoutFormsImport;
      parentRoute: typeof AuthLayoutRouteImport;
    };
    '/_auth/_layout/integrations': {
      id: '/_auth/_layout/integrations';
      path: '/integrations';
      fullPath: '/integrations';
      preLoaderRoute: typeof AuthLayoutIntegrationsImport;
      parentRoute: typeof AuthLayoutRouteImport;
    };
    '/_auth/_layout/mobile-inventor-integration': {
      id: '/_auth/_layout/mobile-inventor-integration';
      path: '/mobile-inventor-integration';
      fullPath: '/mobile-inventor-integration';
      preLoaderRoute: typeof AuthLayoutMobileInventorIntegrationImport;
      parentRoute: typeof AuthLayoutRouteImport;
    };
    '/_auth/_layout/new-dashboard': {
      id: '/_auth/_layout/new-dashboard';
      path: '/new-dashboard';
      fullPath: '/new-dashboard';
      preLoaderRoute: typeof AuthLayoutNewDashboardImport;
      parentRoute: typeof AuthLayoutRouteImport;
    };
    '/_auth/_layout/outgoing-email-logs': {
      id: '/_auth/_layout/outgoing-email-logs';
      path: '/outgoing-email-logs';
      fullPath: '/outgoing-email-logs';
      preLoaderRoute: typeof AuthLayoutOutgoingEmailLogsImport;
      parentRoute: typeof AuthLayoutRouteImport;
    };
    '/_auth/_layout/parent-form-config': {
      id: '/_auth/_layout/parent-form-config';
      path: '/parent-form-config';
      fullPath: '/parent-form-config';
      preLoaderRoute: typeof AuthLayoutParentFormConfigImport;
      parentRoute: typeof AuthLayoutRouteImport;
    };
    '/_auth/_layout/parent-portal-link': {
      id: '/_auth/_layout/parent-portal-link';
      path: '/parent-portal-link';
      fullPath: '/parent-portal-link';
      preLoaderRoute: typeof AuthLayoutParentPortalLinkImport;
      parentRoute: typeof AuthLayoutRouteImport;
    };
    '/_auth/_layout/public-page-link': {
      id: '/_auth/_layout/public-page-link';
      path: '/public-page-link';
      fullPath: '/public-page-link';
      preLoaderRoute: typeof AuthLayoutPublicPageLinkImport;
      parentRoute: typeof AuthLayoutRouteImport;
    };
    '/_auth/_layout/room-overview': {
      id: '/_auth/_layout/room-overview';
      path: '/room-overview';
      fullPath: '/room-overview';
      preLoaderRoute: typeof AuthLayoutRoomOverviewImport;
      parentRoute: typeof AuthLayoutRouteImport;
    };
    '/_auth/_layout/v2-mode': {
      id: '/_auth/_layout/v2-mode';
      path: '/v2-mode';
      fullPath: '/v2-mode';
      preLoaderRoute: typeof AuthLayoutV2ModeImport;
      parentRoute: typeof AuthLayoutRouteImport;
    };
    '/_public/classes/$classId': {
      id: '/_public/classes/$classId';
      path: '/classes/$classId';
      fullPath: '/classes/$classId';
      preLoaderRoute: typeof PublicClassesClassIdImport;
      parentRoute: typeof rootRoute;
    };
    '/_auth/_layout/announcements/new': {
      id: '/_auth/_layout/announcements/new';
      path: '/announcements/new';
      fullPath: '/announcements/new';
      preLoaderRoute: typeof AuthLayoutAnnouncementsNewRouteImport;
      parentRoute: typeof AuthLayoutRouteImport;
    };
    '/_auth/_layout/attendance/$classId': {
      id: '/_auth/_layout/attendance/$classId';
      path: '/$classId';
      fullPath: '/attendance/$classId';
      preLoaderRoute: typeof AuthLayoutAttendanceClassIdRouteImport;
      parentRoute: typeof AuthLayoutAttendanceRouteImport;
    };
    '/_auth/_layout/class-analytics/$classId': {
      id: '/_auth/_layout/class-analytics/$classId';
      path: '/$classId';
      fullPath: '/class-analytics/$classId';
      preLoaderRoute: typeof AuthLayoutClassAnalyticsClassIdRouteImport;
      parentRoute: typeof AuthLayoutClassAnalyticsRouteImport;
    };
    '/_auth/_layout/classes/$classId': {
      id: '/_auth/_layout/classes/$classId';
      path: '/$classId';
      fullPath: '/classes/$classId';
      preLoaderRoute: typeof AuthLayoutClassesClassIdRouteImport;
      parentRoute: typeof AuthLayoutClassesRouteImport;
    };
    '/_auth/_layout/classes/new': {
      id: '/_auth/_layout/classes/new';
      path: '/new';
      fullPath: '/classes/new';
      preLoaderRoute: typeof AuthLayoutClassesNewRouteImport;
      parentRoute: typeof AuthLayoutClassesRouteImport;
    };
    '/_auth/_layout/events/$eventId': {
      id: '/_auth/_layout/events/$eventId';
      path: '/$eventId';
      fullPath: '/events/$eventId';
      preLoaderRoute: typeof AuthLayoutEventsEventIdRouteImport;
      parentRoute: typeof AuthLayoutEventsRouteImport;
    };
    '/_auth/_layout/families/$familyId': {
      id: '/_auth/_layout/families/$familyId';
      path: '/families/$familyId';
      fullPath: '/families/$familyId';
      preLoaderRoute: typeof AuthLayoutFamiliesFamilyIdRouteImport;
      parentRoute: typeof AuthLayoutRouteImport;
    };
    '/_auth/_layout/payment/attendance-report': {
      id: '/_auth/_layout/payment/attendance-report';
      path: '/attendance-report';
      fullPath: '/payment/attendance-report';
      preLoaderRoute: typeof AuthLayoutPaymentAttendanceReportRouteImport;
      parentRoute: typeof AuthLayoutPaymentRouteImport;
    };
    '/_auth/_layout/payment/bulk-charge-students': {
      id: '/_auth/_layout/payment/bulk-charge-students';
      path: '/bulk-charge-students';
      fullPath: '/payment/bulk-charge-students';
      preLoaderRoute: typeof AuthLayoutPaymentBulkChargeStudentsRouteImport;
      parentRoute: typeof AuthLayoutPaymentRouteImport;
    };
    '/_auth/_layout/payment/class-charge-history': {
      id: '/_auth/_layout/payment/class-charge-history';
      path: '/class-charge-history';
      fullPath: '/payment/class-charge-history';
      preLoaderRoute: typeof AuthLayoutPaymentClassChargeHistoryRouteImport;
      parentRoute: typeof AuthLayoutPaymentRouteImport;
    };
    '/_auth/_layout/payment/failed-and-refunded': {
      id: '/_auth/_layout/payment/failed-and-refunded';
      path: '/failed-and-refunded';
      fullPath: '/payment/failed-and-refunded';
      preLoaderRoute: typeof AuthLayoutPaymentFailedAndRefundedRouteImport;
      parentRoute: typeof AuthLayoutPaymentRouteImport;
    };
    '/_auth/_layout/payment/failed-payments': {
      id: '/_auth/_layout/payment/failed-payments';
      path: '/failed-payments';
      fullPath: '/payment/failed-payments';
      preLoaderRoute: typeof AuthLayoutPaymentFailedPaymentsRouteImport;
      parentRoute: typeof AuthLayoutPaymentRouteImport;
    };
    '/_auth/_layout/payment/invoices': {
      id: '/_auth/_layout/payment/invoices';
      path: '/invoices';
      fullPath: '/payment/invoices';
      preLoaderRoute: typeof AuthLayoutPaymentInvoicesRouteImport;
      parentRoute: typeof AuthLayoutPaymentRouteImport;
    };
    '/_auth/_layout/payment/late-fees': {
      id: '/_auth/_layout/payment/late-fees';
      path: '/late-fees';
      fullPath: '/payment/late-fees';
      preLoaderRoute: typeof AuthLayoutPaymentLateFeesRouteImport;
      parentRoute: typeof AuthLayoutPaymentRouteImport;
    };
    '/_auth/_layout/payment/outstanding-and-overdue': {
      id: '/_auth/_layout/payment/outstanding-and-overdue';
      path: '/outstanding-and-overdue';
      fullPath: '/payment/outstanding-and-overdue';
      preLoaderRoute: typeof AuthLayoutPaymentOutstandingAndOverdueRouteImport;
      parentRoute: typeof AuthLayoutPaymentRouteImport;
    };
    '/_auth/_layout/payment/payment-dashboard': {
      id: '/_auth/_layout/payment/payment-dashboard';
      path: '/payment-dashboard';
      fullPath: '/payment/payment-dashboard';
      preLoaderRoute: typeof AuthLayoutPaymentPaymentDashboardRouteImport;
      parentRoute: typeof AuthLayoutPaymentRouteImport;
    };
    '/_auth/_layout/payment/payment-integration': {
      id: '/_auth/_layout/payment/payment-integration';
      path: '/payment-integration';
      fullPath: '/payment/payment-integration';
      preLoaderRoute: typeof AuthLayoutPaymentPaymentIntegrationRouteImport;
      parentRoute: typeof AuthLayoutPaymentRouteImport;
    };
    '/_auth/_layout/payment/payment-processing': {
      id: '/_auth/_layout/payment/payment-processing';
      path: '/payment-processing';
      fullPath: '/payment/payment-processing';
      preLoaderRoute: typeof AuthLayoutPaymentPaymentProcessingRouteImport;
      parentRoute: typeof AuthLayoutPaymentRouteImport;
    };
    '/_auth/_layout/payment/payment-reports': {
      id: '/_auth/_layout/payment/payment-reports';
      path: '/payment-reports';
      fullPath: '/payment/payment-reports';
      preLoaderRoute: typeof AuthLayoutPaymentPaymentReportsRouteImport;
      parentRoute: typeof AuthLayoutPaymentRouteImport;
    };
    '/_auth/_layout/payment/payment-run-review': {
      id: '/_auth/_layout/payment/payment-run-review';
      path: '/payment-run-review';
      fullPath: '/payment/payment-run-review';
      preLoaderRoute: typeof AuthLayoutPaymentPaymentRunReviewRouteImport;
      parentRoute: typeof AuthLayoutPaymentRouteImport;
    };
    '/_auth/_layout/payment/payment-settings': {
      id: '/_auth/_layout/payment/payment-settings';
      path: '/payment-settings';
      fullPath: '/payment/payment-settings';
      preLoaderRoute: typeof AuthLayoutPaymentPaymentSettingsRouteImport;
      parentRoute: typeof AuthLayoutPaymentRouteImport;
    };
    '/_auth/_layout/payment/portal-crm-email-sync-issue': {
      id: '/_auth/_layout/payment/portal-crm-email-sync-issue';
      path: '/portal-crm-email-sync-issue';
      fullPath: '/payment/portal-crm-email-sync-issue';
      preLoaderRoute: typeof AuthLayoutPaymentPortalCrmEmailSyncIssueRouteImport;
      parentRoute: typeof AuthLayoutPaymentRouteImport;
    };
    '/_auth/_layout/payment/student-charge-history': {
      id: '/_auth/_layout/payment/student-charge-history';
      path: '/student-charge-history';
      fullPath: '/payment/student-charge-history';
      preLoaderRoute: typeof AuthLayoutPaymentStudentChargeHistoryRouteImport;
      parentRoute: typeof AuthLayoutPaymentRouteImport;
    };
    '/_auth/_layout/payment/studio-transaction-table': {
      id: '/_auth/_layout/payment/studio-transaction-table';
      path: '/studio-transaction-table';
      fullPath: '/payment/studio-transaction-table';
      preLoaderRoute: typeof AuthLayoutPaymentStudioTransactionTableRouteImport;
      parentRoute: typeof AuthLayoutPaymentRouteImport;
    };
    '/_auth/_layout/payment/transaction-codes': {
      id: '/_auth/_layout/payment/transaction-codes';
      path: '/transaction-codes';
      fullPath: '/payment/transaction-codes';
      preLoaderRoute: typeof AuthLayoutPaymentTransactionCodesRouteImport;
      parentRoute: typeof AuthLayoutPaymentRouteImport;
    };
    '/_auth/_layout/payment/transaction-fee-settings': {
      id: '/_auth/_layout/payment/transaction-fee-settings';
      path: '/transaction-fee-settings';
      fullPath: '/payment/transaction-fee-settings';
      preLoaderRoute: typeof AuthLayoutPaymentTransactionFeeSettingsRouteImport;
      parentRoute: typeof AuthLayoutPaymentRouteImport;
    };
    '/_auth/_layout/payment/upcoming-payments': {
      id: '/_auth/_layout/payment/upcoming-payments';
      path: '/upcoming-payments';
      fullPath: '/payment/upcoming-payments';
      preLoaderRoute: typeof AuthLayoutPaymentUpcomingPaymentsRouteImport;
      parentRoute: typeof AuthLayoutPaymentRouteImport;
    };
    '/_auth/_layout/policies/new': {
      id: '/_auth/_layout/policies/new';
      path: '/policies/new';
      fullPath: '/policies/new';
      preLoaderRoute: typeof AuthLayoutPoliciesNewRouteImport;
      parentRoute: typeof AuthLayoutRouteImport;
    };
    '/_auth/_layout/recitals/$recitalId': {
      id: '/_auth/_layout/recitals/$recitalId';
      path: '/$recitalId';
      fullPath: '/recitals/$recitalId';
      preLoaderRoute: typeof AuthLayoutRecitalsRecitalIdRouteImport;
      parentRoute: typeof AuthLayoutRecitalsRouteImport;
    };
    '/_auth/_layout/students/$studentId': {
      id: '/_auth/_layout/students/$studentId';
      path: '/$studentId';
      fullPath: '/students/$studentId';
      preLoaderRoute: typeof AuthLayoutStudentsStudentIdRouteImport;
      parentRoute: typeof AuthLayoutStudentsRouteImport;
    };
    '/_auth/_layout/_settings/crm-email-sync': {
      id: '/_auth/_layout/_settings/crm-email-sync';
      path: '/crm-email-sync';
      fullPath: '/crm-email-sync';
      preLoaderRoute: typeof AuthLayoutSettingsCrmEmailSyncImport;
      parentRoute: typeof AuthLayoutRouteImport;
    };
    '/_auth/_layout/_settings/email-settings': {
      id: '/_auth/_layout/_settings/email-settings';
      path: '/email-settings';
      fullPath: '/email-settings';
      preLoaderRoute: typeof AuthLayoutSettingsEmailSettingsImport;
      parentRoute: typeof AuthLayoutRouteImport;
    };
    '/_auth/_layout/_settings/import-data': {
      id: '/_auth/_layout/_settings/import-data';
      path: '/import-data';
      fullPath: '/import-data';
      preLoaderRoute: typeof AuthLayoutSettingsImportDataImport;
      parentRoute: typeof AuthLayoutRouteImport;
    };
    '/_auth/_layout/_settings/import-data-logs': {
      id: '/_auth/_layout/_settings/import-data-logs';
      path: '/import-data-logs';
      fullPath: '/import-data-logs';
      preLoaderRoute: typeof AuthLayoutSettingsImportDataLogsImport;
      parentRoute: typeof AuthLayoutRouteImport;
    };
    '/_auth/_layout/_settings/makeup-classes': {
      id: '/_auth/_layout/_settings/makeup-classes';
      path: '/makeup-classes';
      fullPath: '/makeup-classes';
      preLoaderRoute: typeof AuthLayoutSettingsMakeupClassesImport;
      parentRoute: typeof AuthLayoutRouteImport;
    };
    '/_auth/_layout/_settings/portal-banner': {
      id: '/_auth/_layout/_settings/portal-banner';
      path: '/portal-banner';
      fullPath: '/portal-banner';
      preLoaderRoute: typeof AuthLayoutSettingsPortalBannerImport;
      parentRoute: typeof AuthLayoutRouteImport;
    };
    '/_auth/_layout/_settings/preflight-check': {
      id: '/_auth/_layout/_settings/preflight-check';
      path: '/preflight-check';
      fullPath: '/preflight-check';
      preLoaderRoute: typeof AuthLayoutSettingsPreflightCheckImport;
      parentRoute: typeof AuthLayoutRouteImport;
    };
    '/_auth/_layout/_settings/reminders': {
      id: '/_auth/_layout/_settings/reminders';
      path: '/reminders';
      fullPath: '/reminders';
      preLoaderRoute: typeof AuthLayoutSettingsRemindersImport;
      parentRoute: typeof AuthLayoutRouteImport;
    };
    '/_auth/_layout/_settings/trial-bookings': {
      id: '/_auth/_layout/_settings/trial-bookings';
      path: '/trial-bookings';
      fullPath: '/trial-bookings';
      preLoaderRoute: typeof AuthLayoutSettingsTrialBookingsImport;
      parentRoute: typeof AuthLayoutRouteImport;
    };
    '/_auth/_layout/_settings/user-management': {
      id: '/_auth/_layout/_settings/user-management';
      path: '/user-management';
      fullPath: '/user-management';
      preLoaderRoute: typeof AuthLayoutSettingsUserManagementImport;
      parentRoute: typeof AuthLayoutRouteImport;
    };
    '/_auth/_layout/category-config/groups': {
      id: '/_auth/_layout/category-config/groups';
      path: '/groups';
      fullPath: '/category-config/groups';
      preLoaderRoute: typeof AuthLayoutCategoryConfigGroupsImport;
      parentRoute: typeof AuthLayoutCategoryConfigRouteImport;
    };
    '/_auth/_layout/category-config/instructors': {
      id: '/_auth/_layout/category-config/instructors';
      path: '/instructors';
      fullPath: '/category-config/instructors';
      preLoaderRoute: typeof AuthLayoutCategoryConfigInstructorsImport;
      parentRoute: typeof AuthLayoutCategoryConfigRouteImport;
    };
    '/_auth/_layout/category-config/locations': {
      id: '/_auth/_layout/category-config/locations';
      path: '/locations';
      fullPath: '/category-config/locations';
      preLoaderRoute: typeof AuthLayoutCategoryConfigLocationsImport;
      parentRoute: typeof AuthLayoutCategoryConfigRouteImport;
    };
    '/_auth/_layout/category-config/rooms': {
      id: '/_auth/_layout/category-config/rooms';
      path: '/rooms';
      fullPath: '/category-config/rooms';
      preLoaderRoute: typeof AuthLayoutCategoryConfigRoomsImport;
      parentRoute: typeof AuthLayoutCategoryConfigRouteImport;
    };
    '/_auth/_layout/category-config/tags': {
      id: '/_auth/_layout/category-config/tags';
      path: '/tags';
      fullPath: '/category-config/tags';
      preLoaderRoute: typeof AuthLayoutCategoryConfigTagsImport;
      parentRoute: typeof AuthLayoutCategoryConfigRouteImport;
    };
    '/_auth/_layout/classes/bulk-upload': {
      id: '/_auth/_layout/classes/bulk-upload';
      path: '/bulk-upload';
      fullPath: '/classes/bulk-upload';
      preLoaderRoute: typeof AuthLayoutClassesBulkUploadImport;
      parentRoute: typeof AuthLayoutClassesRouteImport;
    };
    '/_auth/_layout/classes/private-lessons': {
      id: '/_auth/_layout/classes/private-lessons';
      path: '/private-lessons';
      fullPath: '/classes/private-lessons';
      preLoaderRoute: typeof AuthLayoutClassesPrivateLessonsImport;
      parentRoute: typeof AuthLayoutClassesRouteImport;
    };
    '/_auth/_layout/classes/trial-students': {
      id: '/_auth/_layout/classes/trial-students';
      path: '/trial-students';
      fullPath: '/classes/trial-students';
      preLoaderRoute: typeof AuthLayoutClassesTrialStudentsImport;
      parentRoute: typeof AuthLayoutClassesRouteImport;
    };
    '/_auth/_layout/events/new': {
      id: '/_auth/_layout/events/new';
      path: '/new';
      fullPath: '/events/new';
      preLoaderRoute: typeof AuthLayoutEventsNewImport;
      parentRoute: typeof AuthLayoutEventsRouteImport;
    };
    '/_auth/_layout/parents/transactions-table': {
      id: '/_auth/_layout/parents/transactions-table';
      path: '/parents/transactions-table';
      fullPath: '/parents/transactions-table';
      preLoaderRoute: typeof AuthLayoutParentsTransactionsTableImport;
      parentRoute: typeof AuthLayoutRouteImport;
    };
    '/_auth/_layout/recitals/new': {
      id: '/_auth/_layout/recitals/new';
      path: '/new';
      fullPath: '/recitals/new';
      preLoaderRoute: typeof AuthLayoutRecitalsNewImport;
      parentRoute: typeof AuthLayoutRecitalsRouteImport;
    };
    '/_auth/_layout/sessions/new': {
      id: '/_auth/_layout/sessions/new';
      path: '/new';
      fullPath: '/sessions/new';
      preLoaderRoute: typeof AuthLayoutSessionsNewImport;
      parentRoute: typeof AuthLayoutSessionsRouteImport;
    };
    '/_auth/_layout/sessions/rollover': {
      id: '/_auth/_layout/sessions/rollover';
      path: '/rollover';
      fullPath: '/sessions/rollover';
      preLoaderRoute: typeof AuthLayoutSessionsRolloverImport;
      parentRoute: typeof AuthLayoutSessionsRouteImport;
    };
    '/_auth/_layout/announcements/': {
      id: '/_auth/_layout/announcements/';
      path: '/announcements';
      fullPath: '/announcements';
      preLoaderRoute: typeof AuthLayoutAnnouncementsIndexImport;
      parentRoute: typeof AuthLayoutRouteImport;
    };
    '/_auth/_layout/attendance/': {
      id: '/_auth/_layout/attendance/';
      path: '/';
      fullPath: '/attendance/';
      preLoaderRoute: typeof AuthLayoutAttendanceIndexImport;
      parentRoute: typeof AuthLayoutAttendanceRouteImport;
    };
    '/_auth/_layout/category-config/': {
      id: '/_auth/_layout/category-config/';
      path: '/';
      fullPath: '/category-config/';
      preLoaderRoute: typeof AuthLayoutCategoryConfigIndexImport;
      parentRoute: typeof AuthLayoutCategoryConfigRouteImport;
    };
    '/_auth/_layout/classes/': {
      id: '/_auth/_layout/classes/';
      path: '/';
      fullPath: '/classes/';
      preLoaderRoute: typeof AuthLayoutClassesIndexImport;
      parentRoute: typeof AuthLayoutClassesRouteImport;
    };
    '/_auth/_layout/events/': {
      id: '/_auth/_layout/events/';
      path: '/';
      fullPath: '/events/';
      preLoaderRoute: typeof AuthLayoutEventsIndexImport;
      parentRoute: typeof AuthLayoutEventsRouteImport;
    };
    '/_auth/_layout/parents/': {
      id: '/_auth/_layout/parents/';
      path: '/parents';
      fullPath: '/parents';
      preLoaderRoute: typeof AuthLayoutParentsIndexImport;
      parentRoute: typeof AuthLayoutRouteImport;
    };
    '/_auth/_layout/policies/': {
      id: '/_auth/_layout/policies/';
      path: '/policies';
      fullPath: '/policies';
      preLoaderRoute: typeof AuthLayoutPoliciesIndexImport;
      parentRoute: typeof AuthLayoutRouteImport;
    };
    '/_auth/_layout/recitals/': {
      id: '/_auth/_layout/recitals/';
      path: '/';
      fullPath: '/recitals/';
      preLoaderRoute: typeof AuthLayoutRecitalsIndexImport;
      parentRoute: typeof AuthLayoutRecitalsRouteImport;
    };
    '/_auth/_layout/sessions/': {
      id: '/_auth/_layout/sessions/';
      path: '/';
      fullPath: '/sessions/';
      preLoaderRoute: typeof AuthLayoutSessionsIndexImport;
      parentRoute: typeof AuthLayoutSessionsRouteImport;
    };
    '/_auth/_layout/students/': {
      id: '/_auth/_layout/students/';
      path: '/';
      fullPath: '/students/';
      preLoaderRoute: typeof AuthLayoutStudentsIndexImport;
      parentRoute: typeof AuthLayoutStudentsRouteImport;
    };
    '/_auth/_layout/payment/hourly-tuition/drafts': {
      id: '/_auth/_layout/payment/hourly-tuition/drafts';
      path: '/hourly-tuition/drafts';
      fullPath: '/payment/hourly-tuition/drafts';
      preLoaderRoute: typeof AuthLayoutPaymentHourlyTuitionDraftsRouteImport;
      parentRoute: typeof AuthLayoutPaymentRouteImport;
    };
    '/_auth/_layout/payment/hourly-tuition/review': {
      id: '/_auth/_layout/payment/hourly-tuition/review';
      path: '/hourly-tuition/review';
      fullPath: '/payment/hourly-tuition/review';
      preLoaderRoute: typeof AuthLayoutPaymentHourlyTuitionReviewRouteImport;
      parentRoute: typeof AuthLayoutPaymentRouteImport;
    };
    '/_auth/_layout/payment/hourly-tuition/settings': {
      id: '/_auth/_layout/payment/hourly-tuition/settings';
      path: '/hourly-tuition/settings';
      fullPath: '/payment/hourly-tuition/settings';
      preLoaderRoute: typeof AuthLayoutPaymentHourlyTuitionSettingsRouteImport;
      parentRoute: typeof AuthLayoutPaymentRouteImport;
    };
    '/_auth/_layout/classes/$classId/bulk-enroll-students': {
      id: '/_auth/_layout/classes/$classId/bulk-enroll-students';
      path: '/bulk-enroll-students';
      fullPath: '/classes/$classId/bulk-enroll-students';
      preLoaderRoute: typeof AuthLayoutClassesClassIdBulkEnrollStudentsImport;
      parentRoute: typeof AuthLayoutClassesClassIdRouteImport;
    };
    '/_auth/_layout/classes/$classId/enrolled-students': {
      id: '/_auth/_layout/classes/$classId/enrolled-students';
      path: '/enrolled-students';
      fullPath: '/classes/$classId/enrolled-students';
      preLoaderRoute: typeof AuthLayoutClassesClassIdEnrolledStudentsImport;
      parentRoute: typeof AuthLayoutClassesClassIdRouteImport;
    };
    '/_auth/_layout/classes/$classId/update': {
      id: '/_auth/_layout/classes/$classId/update';
      path: '/update';
      fullPath: '/classes/$classId/update';
      preLoaderRoute: typeof AuthLayoutClassesClassIdUpdateImport;
      parentRoute: typeof AuthLayoutClassesClassIdRouteImport;
    };
    '/_auth/_layout/classes/$classId/wait-list': {
      id: '/_auth/_layout/classes/$classId/wait-list';
      path: '/wait-list';
      fullPath: '/classes/$classId/wait-list';
      preLoaderRoute: typeof AuthLayoutClassesClassIdWaitListImport;
      parentRoute: typeof AuthLayoutClassesClassIdRouteImport;
    };
    '/_auth/_layout/events/$eventId/enrolled-students': {
      id: '/_auth/_layout/events/$eventId/enrolled-students';
      path: '/enrolled-students';
      fullPath: '/events/$eventId/enrolled-students';
      preLoaderRoute: typeof AuthLayoutEventsEventIdEnrolledStudentsImport;
      parentRoute: typeof AuthLayoutEventsEventIdRouteImport;
    };
    '/_auth/_layout/events/$eventId/payments': {
      id: '/_auth/_layout/events/$eventId/payments';
      path: '/payments';
      fullPath: '/events/$eventId/payments';
      preLoaderRoute: typeof AuthLayoutEventsEventIdPaymentsImport;
      parentRoute: typeof AuthLayoutEventsEventIdRouteImport;
    };
    '/_auth/_layout/events/$eventId/update': {
      id: '/_auth/_layout/events/$eventId/update';
      path: '/update';
      fullPath: '/events/$eventId/update';
      preLoaderRoute: typeof AuthLayoutEventsEventIdUpdateImport;
      parentRoute: typeof AuthLayoutEventsEventIdRouteImport;
    };
    '/_auth/_layout/families/$familyId/billing': {
      id: '/_auth/_layout/families/$familyId/billing';
      path: '/billing';
      fullPath: '/families/$familyId/billing';
      preLoaderRoute: typeof AuthLayoutFamiliesFamilyIdBillingImport;
      parentRoute: typeof AuthLayoutFamiliesFamilyIdRouteImport;
    };
    '/_auth/_layout/families/$familyId/classes': {
      id: '/_auth/_layout/families/$familyId/classes';
      path: '/classes';
      fullPath: '/families/$familyId/classes';
      preLoaderRoute: typeof AuthLayoutFamiliesFamilyIdClassesImport;
      parentRoute: typeof AuthLayoutFamiliesFamilyIdRouteImport;
    };
    '/_auth/_layout/families/$familyId/contacts': {
      id: '/_auth/_layout/families/$familyId/contacts';
      path: '/contacts';
      fullPath: '/families/$familyId/contacts';
      preLoaderRoute: typeof AuthLayoutFamiliesFamilyIdContactsImport;
      parentRoute: typeof AuthLayoutFamiliesFamilyIdRouteImport;
    };
    '/_auth/_layout/families/$familyId/notes': {
      id: '/_auth/_layout/families/$familyId/notes';
      path: '/notes';
      fullPath: '/families/$familyId/notes';
      preLoaderRoute: typeof AuthLayoutFamiliesFamilyIdNotesImport;
      parentRoute: typeof AuthLayoutFamiliesFamilyIdRouteImport;
    };
    '/_auth/_layout/families/$familyId/summary': {
      id: '/_auth/_layout/families/$familyId/summary';
      path: '/summary';
      fullPath: '/families/$familyId/summary';
      preLoaderRoute: typeof AuthLayoutFamiliesFamilyIdSummaryImport;
      parentRoute: typeof AuthLayoutFamiliesFamilyIdRouteImport;
    };
    '/_auth/_layout/families/$familyId/transactions': {
      id: '/_auth/_layout/families/$familyId/transactions';
      path: '/transactions';
      fullPath: '/families/$familyId/transactions';
      preLoaderRoute: typeof AuthLayoutFamiliesFamilyIdTransactionsImport;
      parentRoute: typeof AuthLayoutFamiliesFamilyIdRouteImport;
    };
    '/_auth/_layout/parents/$parentId/saved-payment-methods': {
      id: '/_auth/_layout/parents/$parentId/saved-payment-methods';
      path: '/parents/$parentId/saved-payment-methods';
      fullPath: '/parents/$parentId/saved-payment-methods';
      preLoaderRoute: typeof AuthLayoutParentsParentIdSavedPaymentMethodsImport;
      parentRoute: typeof AuthLayoutRouteImport;
    };
    '/_auth/_layout/parents/bulk-upload/history': {
      id: '/_auth/_layout/parents/bulk-upload/history';
      path: '/parents/bulk-upload/history';
      fullPath: '/parents/bulk-upload/history';
      preLoaderRoute: typeof AuthLayoutParentsBulkUploadHistoryImport;
      parentRoute: typeof AuthLayoutRouteImport;
    };
    '/_auth/_layout/sessions/$sessionId/edit': {
      id: '/_auth/_layout/sessions/$sessionId/edit';
      path: '/$sessionId/edit';
      fullPath: '/sessions/$sessionId/edit';
      preLoaderRoute: typeof AuthLayoutSessionsSessionIdEditImport;
      parentRoute: typeof AuthLayoutSessionsRouteImport;
    };
    '/_auth/_layout/sessions/$sessionId/rollover': {
      id: '/_auth/_layout/sessions/$sessionId/rollover';
      path: '/$sessionId/rollover';
      fullPath: '/sessions/$sessionId/rollover';
      preLoaderRoute: typeof AuthLayoutSessionsSessionIdRolloverImport;
      parentRoute: typeof AuthLayoutSessionsRouteImport;
    };
    '/_auth/_layout/students/$studentId/classes': {
      id: '/_auth/_layout/students/$studentId/classes';
      path: '/classes';
      fullPath: '/students/$studentId/classes';
      preLoaderRoute: typeof AuthLayoutStudentsStudentIdClassesImport;
      parentRoute: typeof AuthLayoutStudentsStudentIdRouteImport;
    };
    '/_auth/_layout/students/$studentId/contacts': {
      id: '/_auth/_layout/students/$studentId/contacts';
      path: '/contacts';
      fullPath: '/students/$studentId/contacts';
      preLoaderRoute: typeof AuthLayoutStudentsStudentIdContactsImport;
      parentRoute: typeof AuthLayoutStudentsStudentIdRouteImport;
    };
    '/_auth/_layout/students/$studentId/details': {
      id: '/_auth/_layout/students/$studentId/details';
      path: '/details';
      fullPath: '/students/$studentId/details';
      preLoaderRoute: typeof AuthLayoutStudentsStudentIdDetailsImport;
      parentRoute: typeof AuthLayoutStudentsStudentIdRouteImport;
    };
    '/_auth/_layout/students/$studentId/makeups': {
      id: '/_auth/_layout/students/$studentId/makeups';
      path: '/makeups';
      fullPath: '/students/$studentId/makeups';
      preLoaderRoute: typeof AuthLayoutStudentsStudentIdMakeupsImport;
      parentRoute: typeof AuthLayoutStudentsStudentIdRouteImport;
    };
    '/_auth/_layout/students/$studentId/new-payments': {
      id: '/_auth/_layout/students/$studentId/new-payments';
      path: '/new-payments';
      fullPath: '/students/$studentId/new-payments';
      preLoaderRoute: typeof AuthLayoutStudentsStudentIdNewPaymentsImport;
      parentRoute: typeof AuthLayoutStudentsStudentIdRouteImport;
    };
    '/_auth/_layout/students/$studentId/notes': {
      id: '/_auth/_layout/students/$studentId/notes';
      path: '/notes';
      fullPath: '/students/$studentId/notes';
      preLoaderRoute: typeof AuthLayoutStudentsStudentIdNotesImport;
      parentRoute: typeof AuthLayoutStudentsStudentIdRouteImport;
    };
    '/_auth/_layout/students/$studentId/payments': {
      id: '/_auth/_layout/students/$studentId/payments';
      path: '/payments';
      fullPath: '/students/$studentId/payments';
      preLoaderRoute: typeof AuthLayoutStudentsStudentIdPaymentsImport;
      parentRoute: typeof AuthLayoutStudentsStudentIdRouteImport;
    };
    '/_auth/_layout/students/$studentId/policies': {
      id: '/_auth/_layout/students/$studentId/policies';
      path: '/policies';
      fullPath: '/students/$studentId/policies';
      preLoaderRoute: typeof AuthLayoutStudentsStudentIdPoliciesImport;
      parentRoute: typeof AuthLayoutStudentsStudentIdRouteImport;
    };
    '/_auth/_layout/announcements/$announcementId/': {
      id: '/_auth/_layout/announcements/$announcementId/';
      path: '/announcements/$announcementId';
      fullPath: '/announcements/$announcementId';
      preLoaderRoute: typeof AuthLayoutAnnouncementsAnnouncementIdIndexImport;
      parentRoute: typeof AuthLayoutRouteImport;
    };
    '/_auth/_layout/attendance/$classId/': {
      id: '/_auth/_layout/attendance/$classId/';
      path: '/';
      fullPath: '/attendance/$classId/';
      preLoaderRoute: typeof AuthLayoutAttendanceClassIdIndexImport;
      parentRoute: typeof AuthLayoutAttendanceClassIdRouteImport;
    };
    '/_auth/_layout/families/$familyId/': {
      id: '/_auth/_layout/families/$familyId/';
      path: '/';
      fullPath: '/families/$familyId/';
      preLoaderRoute: typeof AuthLayoutFamiliesFamilyIdIndexImport;
      parentRoute: typeof AuthLayoutFamiliesFamilyIdRouteImport;
    };
    '/_auth/_layout/parents/bulk-upload/': {
      id: '/_auth/_layout/parents/bulk-upload/';
      path: '/parents/bulk-upload';
      fullPath: '/parents/bulk-upload';
      preLoaderRoute: typeof AuthLayoutParentsBulkUploadIndexImport;
      parentRoute: typeof AuthLayoutRouteImport;
    };
    '/_auth/_layout/parents/csv-batch-processing/': {
      id: '/_auth/_layout/parents/csv-batch-processing/';
      path: '/parents/csv-batch-processing';
      fullPath: '/parents/csv-batch-processing';
      preLoaderRoute: typeof AuthLayoutParentsCsvBatchProcessingIndexImport;
      parentRoute: typeof AuthLayoutRouteImport;
    };
    '/_auth/_layout/payment/class-count-tuition/': {
      id: '/_auth/_layout/payment/class-count-tuition/';
      path: '/class-count-tuition';
      fullPath: '/payment/class-count-tuition';
      preLoaderRoute: typeof AuthLayoutPaymentClassCountTuitionIndexImport;
      parentRoute: typeof AuthLayoutPaymentRouteImport;
    };
    '/_auth/_layout/payment/hourly-tuition/': {
      id: '/_auth/_layout/payment/hourly-tuition/';
      path: '/hourly-tuition';
      fullPath: '/payment/hourly-tuition';
      preLoaderRoute: typeof AuthLayoutPaymentHourlyTuitionIndexImport;
      parentRoute: typeof AuthLayoutPaymentRouteImport;
    };
    '/_auth/_layout/policies/$policyId/': {
      id: '/_auth/_layout/policies/$policyId/';
      path: '/policies/$policyId';
      fullPath: '/policies/$policyId';
      preLoaderRoute: typeof AuthLayoutPoliciesPolicyIdIndexImport;
      parentRoute: typeof AuthLayoutRouteImport;
    };
    '/_auth/_layout/recitals/$recitalId/': {
      id: '/_auth/_layout/recitals/$recitalId/';
      path: '/';
      fullPath: '/recitals/$recitalId/';
      preLoaderRoute: typeof AuthLayoutRecitalsRecitalIdIndexImport;
      parentRoute: typeof AuthLayoutRecitalsRecitalIdRouteImport;
    };
    '/_auth/_layout/students/$studentId/': {
      id: '/_auth/_layout/students/$studentId/';
      path: '/';
      fullPath: '/students/$studentId/';
      preLoaderRoute: typeof AuthLayoutStudentsStudentIdIndexImport;
      parentRoute: typeof AuthLayoutStudentsStudentIdRouteImport;
    };
    '/_auth/_layout/parents/bulk-upload/results/$jobId': {
      id: '/_auth/_layout/parents/bulk-upload/results/$jobId';
      path: '/parents/bulk-upload/results/$jobId';
      fullPath: '/parents/bulk-upload/results/$jobId';
      preLoaderRoute: typeof AuthLayoutParentsBulkUploadResultsJobIdImport;
      parentRoute: typeof AuthLayoutRouteImport;
    };
    '/_auth/_layout/parents/csv-batch-processing/$id/': {
      id: '/_auth/_layout/parents/csv-batch-processing/$id/';
      path: '/parents/csv-batch-processing/$id';
      fullPath: '/parents/csv-batch-processing/$id';
      preLoaderRoute: typeof AuthLayoutParentsCsvBatchProcessingIdIndexImport;
      parentRoute: typeof AuthLayoutRouteImport;
    };
  }
}

// Create and export the route tree

interface AuthLayoutAttendanceClassIdRouteRouteChildren {
  AuthLayoutAttendanceClassIdIndexRoute: typeof AuthLayoutAttendanceClassIdIndexRoute;
}

const AuthLayoutAttendanceClassIdRouteRouteChildren: AuthLayoutAttendanceClassIdRouteRouteChildren =
  {
    AuthLayoutAttendanceClassIdIndexRoute:
      AuthLayoutAttendanceClassIdIndexRoute,
  };

const AuthLayoutAttendanceClassIdRouteRouteWithChildren =
  AuthLayoutAttendanceClassIdRouteRoute._addFileChildren(
    AuthLayoutAttendanceClassIdRouteRouteChildren,
  );

interface AuthLayoutAttendanceRouteRouteChildren {
  AuthLayoutAttendanceClassIdRouteRoute: typeof AuthLayoutAttendanceClassIdRouteRouteWithChildren;
  AuthLayoutAttendanceIndexRoute: typeof AuthLayoutAttendanceIndexRoute;
}

const AuthLayoutAttendanceRouteRouteChildren: AuthLayoutAttendanceRouteRouteChildren =
  {
    AuthLayoutAttendanceClassIdRouteRoute:
      AuthLayoutAttendanceClassIdRouteRouteWithChildren,
    AuthLayoutAttendanceIndexRoute: AuthLayoutAttendanceIndexRoute,
  };

const AuthLayoutAttendanceRouteRouteWithChildren =
  AuthLayoutAttendanceRouteRoute._addFileChildren(
    AuthLayoutAttendanceRouteRouteChildren,
  );

interface AuthLayoutCategoryConfigRouteRouteChildren {
  AuthLayoutCategoryConfigGroupsRoute: typeof AuthLayoutCategoryConfigGroupsRoute;
  AuthLayoutCategoryConfigInstructorsRoute: typeof AuthLayoutCategoryConfigInstructorsRoute;
  AuthLayoutCategoryConfigLocationsRoute: typeof AuthLayoutCategoryConfigLocationsRoute;
  AuthLayoutCategoryConfigRoomsRoute: typeof AuthLayoutCategoryConfigRoomsRoute;
  AuthLayoutCategoryConfigTagsRoute: typeof AuthLayoutCategoryConfigTagsRoute;
  AuthLayoutCategoryConfigIndexRoute: typeof AuthLayoutCategoryConfigIndexRoute;
}

const AuthLayoutCategoryConfigRouteRouteChildren: AuthLayoutCategoryConfigRouteRouteChildren =
  {
    AuthLayoutCategoryConfigGroupsRoute: AuthLayoutCategoryConfigGroupsRoute,
    AuthLayoutCategoryConfigInstructorsRoute:
      AuthLayoutCategoryConfigInstructorsRoute,
    AuthLayoutCategoryConfigLocationsRoute:
      AuthLayoutCategoryConfigLocationsRoute,
    AuthLayoutCategoryConfigRoomsRoute: AuthLayoutCategoryConfigRoomsRoute,
    AuthLayoutCategoryConfigTagsRoute: AuthLayoutCategoryConfigTagsRoute,
    AuthLayoutCategoryConfigIndexRoute: AuthLayoutCategoryConfigIndexRoute,
  };

const AuthLayoutCategoryConfigRouteRouteWithChildren =
  AuthLayoutCategoryConfigRouteRoute._addFileChildren(
    AuthLayoutCategoryConfigRouteRouteChildren,
  );

interface AuthLayoutClassAnalyticsRouteRouteChildren {
  AuthLayoutClassAnalyticsClassIdRouteRoute: typeof AuthLayoutClassAnalyticsClassIdRouteRoute;
}

const AuthLayoutClassAnalyticsRouteRouteChildren: AuthLayoutClassAnalyticsRouteRouteChildren =
  {
    AuthLayoutClassAnalyticsClassIdRouteRoute:
      AuthLayoutClassAnalyticsClassIdRouteRoute,
  };

const AuthLayoutClassAnalyticsRouteRouteWithChildren =
  AuthLayoutClassAnalyticsRouteRoute._addFileChildren(
    AuthLayoutClassAnalyticsRouteRouteChildren,
  );

interface AuthLayoutClassesClassIdRouteRouteChildren {
  AuthLayoutClassesClassIdBulkEnrollStudentsRoute: typeof AuthLayoutClassesClassIdBulkEnrollStudentsRoute;
  AuthLayoutClassesClassIdEnrolledStudentsRoute: typeof AuthLayoutClassesClassIdEnrolledStudentsRoute;
  AuthLayoutClassesClassIdUpdateRoute: typeof AuthLayoutClassesClassIdUpdateRoute;
  AuthLayoutClassesClassIdWaitListRoute: typeof AuthLayoutClassesClassIdWaitListRoute;
}

const AuthLayoutClassesClassIdRouteRouteChildren: AuthLayoutClassesClassIdRouteRouteChildren =
  {
    AuthLayoutClassesClassIdBulkEnrollStudentsRoute:
      AuthLayoutClassesClassIdBulkEnrollStudentsRoute,
    AuthLayoutClassesClassIdEnrolledStudentsRoute:
      AuthLayoutClassesClassIdEnrolledStudentsRoute,
    AuthLayoutClassesClassIdUpdateRoute: AuthLayoutClassesClassIdUpdateRoute,
    AuthLayoutClassesClassIdWaitListRoute:
      AuthLayoutClassesClassIdWaitListRoute,
  };

const AuthLayoutClassesClassIdRouteRouteWithChildren =
  AuthLayoutClassesClassIdRouteRoute._addFileChildren(
    AuthLayoutClassesClassIdRouteRouteChildren,
  );

interface AuthLayoutClassesRouteRouteChildren {
  AuthLayoutClassesClassIdRouteRoute: typeof AuthLayoutClassesClassIdRouteRouteWithChildren;
  AuthLayoutClassesNewRouteRoute: typeof AuthLayoutClassesNewRouteRoute;
  AuthLayoutClassesBulkUploadRoute: typeof AuthLayoutClassesBulkUploadRoute;
  AuthLayoutClassesPrivateLessonsRoute: typeof AuthLayoutClassesPrivateLessonsRoute;
  AuthLayoutClassesTrialStudentsRoute: typeof AuthLayoutClassesTrialStudentsRoute;
  AuthLayoutClassesIndexRoute: typeof AuthLayoutClassesIndexRoute;
}

const AuthLayoutClassesRouteRouteChildren: AuthLayoutClassesRouteRouteChildren =
  {
    AuthLayoutClassesClassIdRouteRoute:
      AuthLayoutClassesClassIdRouteRouteWithChildren,
    AuthLayoutClassesNewRouteRoute: AuthLayoutClassesNewRouteRoute,
    AuthLayoutClassesBulkUploadRoute: AuthLayoutClassesBulkUploadRoute,
    AuthLayoutClassesPrivateLessonsRoute: AuthLayoutClassesPrivateLessonsRoute,
    AuthLayoutClassesTrialStudentsRoute: AuthLayoutClassesTrialStudentsRoute,
    AuthLayoutClassesIndexRoute: AuthLayoutClassesIndexRoute,
  };

const AuthLayoutClassesRouteRouteWithChildren =
  AuthLayoutClassesRouteRoute._addFileChildren(
    AuthLayoutClassesRouteRouteChildren,
  );

interface AuthLayoutEventsEventIdRouteRouteChildren {
  AuthLayoutEventsEventIdEnrolledStudentsRoute: typeof AuthLayoutEventsEventIdEnrolledStudentsRoute;
  AuthLayoutEventsEventIdPaymentsRoute: typeof AuthLayoutEventsEventIdPaymentsRoute;
  AuthLayoutEventsEventIdUpdateRoute: typeof AuthLayoutEventsEventIdUpdateRoute;
}

const AuthLayoutEventsEventIdRouteRouteChildren: AuthLayoutEventsEventIdRouteRouteChildren =
  {
    AuthLayoutEventsEventIdEnrolledStudentsRoute:
      AuthLayoutEventsEventIdEnrolledStudentsRoute,
    AuthLayoutEventsEventIdPaymentsRoute: AuthLayoutEventsEventIdPaymentsRoute,
    AuthLayoutEventsEventIdUpdateRoute: AuthLayoutEventsEventIdUpdateRoute,
  };

const AuthLayoutEventsEventIdRouteRouteWithChildren =
  AuthLayoutEventsEventIdRouteRoute._addFileChildren(
    AuthLayoutEventsEventIdRouteRouteChildren,
  );

interface AuthLayoutEventsRouteRouteChildren {
  AuthLayoutEventsEventIdRouteRoute: typeof AuthLayoutEventsEventIdRouteRouteWithChildren;
  AuthLayoutEventsNewRoute: typeof AuthLayoutEventsNewRoute;
  AuthLayoutEventsIndexRoute: typeof AuthLayoutEventsIndexRoute;
}

const AuthLayoutEventsRouteRouteChildren: AuthLayoutEventsRouteRouteChildren = {
  AuthLayoutEventsEventIdRouteRoute:
    AuthLayoutEventsEventIdRouteRouteWithChildren,
  AuthLayoutEventsNewRoute: AuthLayoutEventsNewRoute,
  AuthLayoutEventsIndexRoute: AuthLayoutEventsIndexRoute,
};

const AuthLayoutEventsRouteRouteWithChildren =
  AuthLayoutEventsRouteRoute._addFileChildren(
    AuthLayoutEventsRouteRouteChildren,
  );

interface AuthLayoutPaymentRouteRouteChildren {
  AuthLayoutPaymentAttendanceReportRouteRoute: typeof AuthLayoutPaymentAttendanceReportRouteRoute;
  AuthLayoutPaymentBulkChargeStudentsRouteRoute: typeof AuthLayoutPaymentBulkChargeStudentsRouteRoute;
  AuthLayoutPaymentClassChargeHistoryRouteRoute: typeof AuthLayoutPaymentClassChargeHistoryRouteRoute;
  AuthLayoutPaymentFailedAndRefundedRouteRoute: typeof AuthLayoutPaymentFailedAndRefundedRouteRoute;
  AuthLayoutPaymentFailedPaymentsRouteRoute: typeof AuthLayoutPaymentFailedPaymentsRouteRoute;
  AuthLayoutPaymentInvoicesRouteRoute: typeof AuthLayoutPaymentInvoicesRouteRoute;
  AuthLayoutPaymentLateFeesRouteRoute: typeof AuthLayoutPaymentLateFeesRouteRoute;
  AuthLayoutPaymentOutstandingAndOverdueRouteRoute: typeof AuthLayoutPaymentOutstandingAndOverdueRouteRoute;
  AuthLayoutPaymentPaymentDashboardRouteRoute: typeof AuthLayoutPaymentPaymentDashboardRouteRoute;
  AuthLayoutPaymentPaymentIntegrationRouteRoute: typeof AuthLayoutPaymentPaymentIntegrationRouteRoute;
  AuthLayoutPaymentPaymentProcessingRouteRoute: typeof AuthLayoutPaymentPaymentProcessingRouteRoute;
  AuthLayoutPaymentPaymentReportsRouteRoute: typeof AuthLayoutPaymentPaymentReportsRouteRoute;
  AuthLayoutPaymentPaymentRunReviewRouteRoute: typeof AuthLayoutPaymentPaymentRunReviewRouteRoute;
  AuthLayoutPaymentPaymentSettingsRouteRoute: typeof AuthLayoutPaymentPaymentSettingsRouteRoute;
  AuthLayoutPaymentPortalCrmEmailSyncIssueRouteRoute: typeof AuthLayoutPaymentPortalCrmEmailSyncIssueRouteRoute;
  AuthLayoutPaymentStudentChargeHistoryRouteRoute: typeof AuthLayoutPaymentStudentChargeHistoryRouteRoute;
  AuthLayoutPaymentStudioTransactionTableRouteRoute: typeof AuthLayoutPaymentStudioTransactionTableRouteRoute;
  AuthLayoutPaymentTransactionCodesRouteRoute: typeof AuthLayoutPaymentTransactionCodesRouteRoute;
  AuthLayoutPaymentTransactionFeeSettingsRouteRoute: typeof AuthLayoutPaymentTransactionFeeSettingsRouteRoute;
  AuthLayoutPaymentUpcomingPaymentsRouteRoute: typeof AuthLayoutPaymentUpcomingPaymentsRouteRoute;
  AuthLayoutPaymentHourlyTuitionDraftsRouteRoute: typeof AuthLayoutPaymentHourlyTuitionDraftsRouteRoute;
  AuthLayoutPaymentHourlyTuitionReviewRouteRoute: typeof AuthLayoutPaymentHourlyTuitionReviewRouteRoute;
  AuthLayoutPaymentHourlyTuitionSettingsRouteRoute: typeof AuthLayoutPaymentHourlyTuitionSettingsRouteRoute;
  AuthLayoutPaymentClassCountTuitionIndexRoute: typeof AuthLayoutPaymentClassCountTuitionIndexRoute;
  AuthLayoutPaymentHourlyTuitionIndexRoute: typeof AuthLayoutPaymentHourlyTuitionIndexRoute;
}

const AuthLayoutPaymentRouteRouteChildren: AuthLayoutPaymentRouteRouteChildren =
  {
    AuthLayoutPaymentAttendanceReportRouteRoute:
      AuthLayoutPaymentAttendanceReportRouteRoute,
    AuthLayoutPaymentBulkChargeStudentsRouteRoute:
      AuthLayoutPaymentBulkChargeStudentsRouteRoute,
    AuthLayoutPaymentClassChargeHistoryRouteRoute:
      AuthLayoutPaymentClassChargeHistoryRouteRoute,
    AuthLayoutPaymentFailedAndRefundedRouteRoute:
      AuthLayoutPaymentFailedAndRefundedRouteRoute,
    AuthLayoutPaymentFailedPaymentsRouteRoute:
      AuthLayoutPaymentFailedPaymentsRouteRoute,
    AuthLayoutPaymentInvoicesRouteRoute: AuthLayoutPaymentInvoicesRouteRoute,
    AuthLayoutPaymentLateFeesRouteRoute: AuthLayoutPaymentLateFeesRouteRoute,
    AuthLayoutPaymentOutstandingAndOverdueRouteRoute:
      AuthLayoutPaymentOutstandingAndOverdueRouteRoute,
    AuthLayoutPaymentPaymentDashboardRouteRoute:
      AuthLayoutPaymentPaymentDashboardRouteRoute,
    AuthLayoutPaymentPaymentIntegrationRouteRoute:
      AuthLayoutPaymentPaymentIntegrationRouteRoute,
    AuthLayoutPaymentPaymentProcessingRouteRoute:
      AuthLayoutPaymentPaymentProcessingRouteRoute,
    AuthLayoutPaymentPaymentReportsRouteRoute:
      AuthLayoutPaymentPaymentReportsRouteRoute,
    AuthLayoutPaymentPaymentRunReviewRouteRoute:
      AuthLayoutPaymentPaymentRunReviewRouteRoute,
    AuthLayoutPaymentPaymentSettingsRouteRoute:
      AuthLayoutPaymentPaymentSettingsRouteRoute,
    AuthLayoutPaymentPortalCrmEmailSyncIssueRouteRoute:
      AuthLayoutPaymentPortalCrmEmailSyncIssueRouteRoute,
    AuthLayoutPaymentStudentChargeHistoryRouteRoute:
      AuthLayoutPaymentStudentChargeHistoryRouteRoute,
    AuthLayoutPaymentStudioTransactionTableRouteRoute:
      AuthLayoutPaymentStudioTransactionTableRouteRoute,
    AuthLayoutPaymentTransactionCodesRouteRoute:
      AuthLayoutPaymentTransactionCodesRouteRoute,
    AuthLayoutPaymentTransactionFeeSettingsRouteRoute:
      AuthLayoutPaymentTransactionFeeSettingsRouteRoute,
    AuthLayoutPaymentUpcomingPaymentsRouteRoute:
      AuthLayoutPaymentUpcomingPaymentsRouteRoute,
    AuthLayoutPaymentHourlyTuitionDraftsRouteRoute:
      AuthLayoutPaymentHourlyTuitionDraftsRouteRoute,
    AuthLayoutPaymentHourlyTuitionReviewRouteRoute:
      AuthLayoutPaymentHourlyTuitionReviewRouteRoute,
    AuthLayoutPaymentHourlyTuitionSettingsRouteRoute:
      AuthLayoutPaymentHourlyTuitionSettingsRouteRoute,
    AuthLayoutPaymentClassCountTuitionIndexRoute:
      AuthLayoutPaymentClassCountTuitionIndexRoute,
    AuthLayoutPaymentHourlyTuitionIndexRoute:
      AuthLayoutPaymentHourlyTuitionIndexRoute,
  };

const AuthLayoutPaymentRouteRouteWithChildren =
  AuthLayoutPaymentRouteRoute._addFileChildren(
    AuthLayoutPaymentRouteRouteChildren,
  );

interface AuthLayoutRecitalsRecitalIdRouteRouteChildren {
  AuthLayoutRecitalsRecitalIdIndexRoute: typeof AuthLayoutRecitalsRecitalIdIndexRoute;
}

const AuthLayoutRecitalsRecitalIdRouteRouteChildren: AuthLayoutRecitalsRecitalIdRouteRouteChildren =
  {
    AuthLayoutRecitalsRecitalIdIndexRoute:
      AuthLayoutRecitalsRecitalIdIndexRoute,
  };

const AuthLayoutRecitalsRecitalIdRouteRouteWithChildren =
  AuthLayoutRecitalsRecitalIdRouteRoute._addFileChildren(
    AuthLayoutRecitalsRecitalIdRouteRouteChildren,
  );

interface AuthLayoutRecitalsRouteRouteChildren {
  AuthLayoutRecitalsRecitalIdRouteRoute: typeof AuthLayoutRecitalsRecitalIdRouteRouteWithChildren;
  AuthLayoutRecitalsNewRoute: typeof AuthLayoutRecitalsNewRoute;
  AuthLayoutRecitalsIndexRoute: typeof AuthLayoutRecitalsIndexRoute;
}

const AuthLayoutRecitalsRouteRouteChildren: AuthLayoutRecitalsRouteRouteChildren =
  {
    AuthLayoutRecitalsRecitalIdRouteRoute:
      AuthLayoutRecitalsRecitalIdRouteRouteWithChildren,
    AuthLayoutRecitalsNewRoute: AuthLayoutRecitalsNewRoute,
    AuthLayoutRecitalsIndexRoute: AuthLayoutRecitalsIndexRoute,
  };

const AuthLayoutRecitalsRouteRouteWithChildren =
  AuthLayoutRecitalsRouteRoute._addFileChildren(
    AuthLayoutRecitalsRouteRouteChildren,
  );

interface AuthLayoutSessionsRouteRouteChildren {
  AuthLayoutSessionsNewRoute: typeof AuthLayoutSessionsNewRoute;
  AuthLayoutSessionsRolloverRoute: typeof AuthLayoutSessionsRolloverRoute;
  AuthLayoutSessionsIndexRoute: typeof AuthLayoutSessionsIndexRoute;
  AuthLayoutSessionsSessionIdEditRoute: typeof AuthLayoutSessionsSessionIdEditRoute;
  AuthLayoutSessionsSessionIdRolloverRoute: typeof AuthLayoutSessionsSessionIdRolloverRoute;
}

const AuthLayoutSessionsRouteRouteChildren: AuthLayoutSessionsRouteRouteChildren =
  {
    AuthLayoutSessionsNewRoute: AuthLayoutSessionsNewRoute,
    AuthLayoutSessionsRolloverRoute: AuthLayoutSessionsRolloverRoute,
    AuthLayoutSessionsIndexRoute: AuthLayoutSessionsIndexRoute,
    AuthLayoutSessionsSessionIdEditRoute: AuthLayoutSessionsSessionIdEditRoute,
    AuthLayoutSessionsSessionIdRolloverRoute:
      AuthLayoutSessionsSessionIdRolloverRoute,
  };

const AuthLayoutSessionsRouteRouteWithChildren =
  AuthLayoutSessionsRouteRoute._addFileChildren(
    AuthLayoutSessionsRouteRouteChildren,
  );

interface AuthLayoutStudentsStudentIdRouteRouteChildren {
  AuthLayoutStudentsStudentIdClassesRoute: typeof AuthLayoutStudentsStudentIdClassesRoute;
  AuthLayoutStudentsStudentIdContactsRoute: typeof AuthLayoutStudentsStudentIdContactsRoute;
  AuthLayoutStudentsStudentIdDetailsRoute: typeof AuthLayoutStudentsStudentIdDetailsRoute;
  AuthLayoutStudentsStudentIdMakeupsRoute: typeof AuthLayoutStudentsStudentIdMakeupsRoute;
  AuthLayoutStudentsStudentIdNewPaymentsRoute: typeof AuthLayoutStudentsStudentIdNewPaymentsRoute;
  AuthLayoutStudentsStudentIdNotesRoute: typeof AuthLayoutStudentsStudentIdNotesRoute;
  AuthLayoutStudentsStudentIdPaymentsRoute: typeof AuthLayoutStudentsStudentIdPaymentsRoute;
  AuthLayoutStudentsStudentIdPoliciesRoute: typeof AuthLayoutStudentsStudentIdPoliciesRoute;
  AuthLayoutStudentsStudentIdIndexRoute: typeof AuthLayoutStudentsStudentIdIndexRoute;
}

const AuthLayoutStudentsStudentIdRouteRouteChildren: AuthLayoutStudentsStudentIdRouteRouteChildren =
  {
    AuthLayoutStudentsStudentIdClassesRoute:
      AuthLayoutStudentsStudentIdClassesRoute,
    AuthLayoutStudentsStudentIdContactsRoute:
      AuthLayoutStudentsStudentIdContactsRoute,
    AuthLayoutStudentsStudentIdDetailsRoute:
      AuthLayoutStudentsStudentIdDetailsRoute,
    AuthLayoutStudentsStudentIdMakeupsRoute:
      AuthLayoutStudentsStudentIdMakeupsRoute,
    AuthLayoutStudentsStudentIdNewPaymentsRoute:
      AuthLayoutStudentsStudentIdNewPaymentsRoute,
    AuthLayoutStudentsStudentIdNotesRoute:
      AuthLayoutStudentsStudentIdNotesRoute,
    AuthLayoutStudentsStudentIdPaymentsRoute:
      AuthLayoutStudentsStudentIdPaymentsRoute,
    AuthLayoutStudentsStudentIdPoliciesRoute:
      AuthLayoutStudentsStudentIdPoliciesRoute,
    AuthLayoutStudentsStudentIdIndexRoute:
      AuthLayoutStudentsStudentIdIndexRoute,
  };

const AuthLayoutStudentsStudentIdRouteRouteWithChildren =
  AuthLayoutStudentsStudentIdRouteRoute._addFileChildren(
    AuthLayoutStudentsStudentIdRouteRouteChildren,
  );

interface AuthLayoutStudentsRouteRouteChildren {
  AuthLayoutStudentsStudentIdRouteRoute: typeof AuthLayoutStudentsStudentIdRouteRouteWithChildren;
  AuthLayoutStudentsIndexRoute: typeof AuthLayoutStudentsIndexRoute;
}

const AuthLayoutStudentsRouteRouteChildren: AuthLayoutStudentsRouteRouteChildren =
  {
    AuthLayoutStudentsStudentIdRouteRoute:
      AuthLayoutStudentsStudentIdRouteRouteWithChildren,
    AuthLayoutStudentsIndexRoute: AuthLayoutStudentsIndexRoute,
  };

const AuthLayoutStudentsRouteRouteWithChildren =
  AuthLayoutStudentsRouteRoute._addFileChildren(
    AuthLayoutStudentsRouteRouteChildren,
  );

interface AuthLayoutFamiliesFamilyIdRouteRouteChildren {
  AuthLayoutFamiliesFamilyIdBillingRoute: typeof AuthLayoutFamiliesFamilyIdBillingRoute;
  AuthLayoutFamiliesFamilyIdClassesRoute: typeof AuthLayoutFamiliesFamilyIdClassesRoute;
  AuthLayoutFamiliesFamilyIdContactsRoute: typeof AuthLayoutFamiliesFamilyIdContactsRoute;
  AuthLayoutFamiliesFamilyIdNotesRoute: typeof AuthLayoutFamiliesFamilyIdNotesRoute;
  AuthLayoutFamiliesFamilyIdSummaryRoute: typeof AuthLayoutFamiliesFamilyIdSummaryRoute;
  AuthLayoutFamiliesFamilyIdTransactionsRoute: typeof AuthLayoutFamiliesFamilyIdTransactionsRoute;
  AuthLayoutFamiliesFamilyIdIndexRoute: typeof AuthLayoutFamiliesFamilyIdIndexRoute;
}

const AuthLayoutFamiliesFamilyIdRouteRouteChildren: AuthLayoutFamiliesFamilyIdRouteRouteChildren =
  {
    AuthLayoutFamiliesFamilyIdBillingRoute:
      AuthLayoutFamiliesFamilyIdBillingRoute,
    AuthLayoutFamiliesFamilyIdClassesRoute:
      AuthLayoutFamiliesFamilyIdClassesRoute,
    AuthLayoutFamiliesFamilyIdContactsRoute:
      AuthLayoutFamiliesFamilyIdContactsRoute,
    AuthLayoutFamiliesFamilyIdNotesRoute: AuthLayoutFamiliesFamilyIdNotesRoute,
    AuthLayoutFamiliesFamilyIdSummaryRoute:
      AuthLayoutFamiliesFamilyIdSummaryRoute,
    AuthLayoutFamiliesFamilyIdTransactionsRoute:
      AuthLayoutFamiliesFamilyIdTransactionsRoute,
    AuthLayoutFamiliesFamilyIdIndexRoute: AuthLayoutFamiliesFamilyIdIndexRoute,
  };

const AuthLayoutFamiliesFamilyIdRouteRouteWithChildren =
  AuthLayoutFamiliesFamilyIdRouteRoute._addFileChildren(
    AuthLayoutFamiliesFamilyIdRouteRouteChildren,
  );

interface AuthLayoutRouteRouteChildren {
  AuthLayoutAttendanceRouteRoute: typeof AuthLayoutAttendanceRouteRouteWithChildren;
  AuthLayoutCategoryConfigRouteRoute: typeof AuthLayoutCategoryConfigRouteRouteWithChildren;
  AuthLayoutClassAnalyticsRouteRoute: typeof AuthLayoutClassAnalyticsRouteRouteWithChildren;
  AuthLayoutClassesRouteRoute: typeof AuthLayoutClassesRouteRouteWithChildren;
  AuthLayoutEventsRouteRoute: typeof AuthLayoutEventsRouteRouteWithChildren;
  AuthLayoutPaymentRouteRoute: typeof AuthLayoutPaymentRouteRouteWithChildren;
  AuthLayoutPerformanceDashboardRouteRoute: typeof AuthLayoutPerformanceDashboardRouteRoute;
  AuthLayoutRecitalsRouteRoute: typeof AuthLayoutRecitalsRouteRouteWithChildren;
  AuthLayoutSessionsRouteRoute: typeof AuthLayoutSessionsRouteRouteWithChildren;
  AuthLayoutStudentsRouteRoute: typeof AuthLayoutStudentsRouteRouteWithChildren;
  AuthLayoutStudioProfileRouteRoute: typeof AuthLayoutStudioProfileRouteRoute;
  AuthLayoutAuditLogsRoute: typeof AuthLayoutAuditLogsRoute;
  AuthLayoutBugsFeatureRoute: typeof AuthLayoutBugsFeatureRoute;
  AuthLayoutDailyDigestRoute: typeof AuthLayoutDailyDigestRoute;
  AuthLayoutDemoModeRoute: typeof AuthLayoutDemoModeRoute;
  AuthLayoutDiscountsRoute: typeof AuthLayoutDiscountsRoute;
  AuthLayoutDowntimeRoute: typeof AuthLayoutDowntimeRoute;
  AuthLayoutDrtIntegrationRoute: typeof AuthLayoutDrtIntegrationRoute;
  AuthLayoutEmailBuilderRoute: typeof AuthLayoutEmailBuilderRoute;
  AuthLayoutEmailCampaignsRoute: typeof AuthLayoutEmailCampaignsRoute;
  AuthLayoutEmailCustomizerRoute: typeof AuthLayoutEmailCustomizerRoute;
  AuthLayoutFormSubmissionsRoute: typeof AuthLayoutFormSubmissionsRoute;
  AuthLayoutFormsRoute: typeof AuthLayoutFormsRoute;
  AuthLayoutIntegrationsRoute: typeof AuthLayoutIntegrationsRoute;
  AuthLayoutMobileInventorIntegrationRoute: typeof AuthLayoutMobileInventorIntegrationRoute;
  AuthLayoutNewDashboardRoute: typeof AuthLayoutNewDashboardRoute;
  AuthLayoutOutgoingEmailLogsRoute: typeof AuthLayoutOutgoingEmailLogsRoute;
  AuthLayoutParentFormConfigRoute: typeof AuthLayoutParentFormConfigRoute;
  AuthLayoutParentPortalLinkRoute: typeof AuthLayoutParentPortalLinkRoute;
  AuthLayoutPublicPageLinkRoute: typeof AuthLayoutPublicPageLinkRoute;
  AuthLayoutRoomOverviewRoute: typeof AuthLayoutRoomOverviewRoute;
  AuthLayoutV2ModeRoute: typeof AuthLayoutV2ModeRoute;
  AuthLayoutAnnouncementsNewRouteRoute: typeof AuthLayoutAnnouncementsNewRouteRoute;
  AuthLayoutFamiliesFamilyIdRouteRoute: typeof AuthLayoutFamiliesFamilyIdRouteRouteWithChildren;
  AuthLayoutPoliciesNewRouteRoute: typeof AuthLayoutPoliciesNewRouteRoute;
  AuthLayoutSettingsCrmEmailSyncRoute: typeof AuthLayoutSettingsCrmEmailSyncRoute;
  AuthLayoutSettingsEmailSettingsRoute: typeof AuthLayoutSettingsEmailSettingsRoute;
  AuthLayoutSettingsImportDataRoute: typeof AuthLayoutSettingsImportDataRoute;
  AuthLayoutSettingsImportDataLogsRoute: typeof AuthLayoutSettingsImportDataLogsRoute;
  AuthLayoutSettingsMakeupClassesRoute: typeof AuthLayoutSettingsMakeupClassesRoute;
  AuthLayoutSettingsPortalBannerRoute: typeof AuthLayoutSettingsPortalBannerRoute;
  AuthLayoutSettingsPreflightCheckRoute: typeof AuthLayoutSettingsPreflightCheckRoute;
  AuthLayoutSettingsRemindersRoute: typeof AuthLayoutSettingsRemindersRoute;
  AuthLayoutSettingsTrialBookingsRoute: typeof AuthLayoutSettingsTrialBookingsRoute;
  AuthLayoutSettingsUserManagementRoute: typeof AuthLayoutSettingsUserManagementRoute;
  AuthLayoutParentsTransactionsTableRoute: typeof AuthLayoutParentsTransactionsTableRoute;
  AuthLayoutAnnouncementsIndexRoute: typeof AuthLayoutAnnouncementsIndexRoute;
  AuthLayoutParentsIndexRoute: typeof AuthLayoutParentsIndexRoute;
  AuthLayoutPoliciesIndexRoute: typeof AuthLayoutPoliciesIndexRoute;
  AuthLayoutParentsParentIdSavedPaymentMethodsRoute: typeof AuthLayoutParentsParentIdSavedPaymentMethodsRoute;
  AuthLayoutParentsBulkUploadHistoryRoute: typeof AuthLayoutParentsBulkUploadHistoryRoute;
  AuthLayoutAnnouncementsAnnouncementIdIndexRoute: typeof AuthLayoutAnnouncementsAnnouncementIdIndexRoute;
  AuthLayoutParentsBulkUploadIndexRoute: typeof AuthLayoutParentsBulkUploadIndexRoute;
  AuthLayoutParentsCsvBatchProcessingIndexRoute: typeof AuthLayoutParentsCsvBatchProcessingIndexRoute;
  AuthLayoutPoliciesPolicyIdIndexRoute: typeof AuthLayoutPoliciesPolicyIdIndexRoute;
  AuthLayoutParentsBulkUploadResultsJobIdRoute: typeof AuthLayoutParentsBulkUploadResultsJobIdRoute;
  AuthLayoutParentsCsvBatchProcessingIdIndexRoute: typeof AuthLayoutParentsCsvBatchProcessingIdIndexRoute;
}

const AuthLayoutRouteRouteChildren: AuthLayoutRouteRouteChildren = {
  AuthLayoutAttendanceRouteRoute: AuthLayoutAttendanceRouteRouteWithChildren,
  AuthLayoutCategoryConfigRouteRoute:
    AuthLayoutCategoryConfigRouteRouteWithChildren,
  AuthLayoutClassAnalyticsRouteRoute:
    AuthLayoutClassAnalyticsRouteRouteWithChildren,
  AuthLayoutClassesRouteRoute: AuthLayoutClassesRouteRouteWithChildren,
  AuthLayoutEventsRouteRoute: AuthLayoutEventsRouteRouteWithChildren,
  AuthLayoutPaymentRouteRoute: AuthLayoutPaymentRouteRouteWithChildren,
  AuthLayoutPerformanceDashboardRouteRoute:
    AuthLayoutPerformanceDashboardRouteRoute,
  AuthLayoutRecitalsRouteRoute: AuthLayoutRecitalsRouteRouteWithChildren,
  AuthLayoutSessionsRouteRoute: AuthLayoutSessionsRouteRouteWithChildren,
  AuthLayoutStudentsRouteRoute: AuthLayoutStudentsRouteRouteWithChildren,
  AuthLayoutStudioProfileRouteRoute: AuthLayoutStudioProfileRouteRoute,
  AuthLayoutAuditLogsRoute: AuthLayoutAuditLogsRoute,
  AuthLayoutBugsFeatureRoute: AuthLayoutBugsFeatureRoute,
  AuthLayoutDailyDigestRoute: AuthLayoutDailyDigestRoute,
  AuthLayoutDemoModeRoute: AuthLayoutDemoModeRoute,
  AuthLayoutDiscountsRoute: AuthLayoutDiscountsRoute,
  AuthLayoutDowntimeRoute: AuthLayoutDowntimeRoute,
  AuthLayoutDrtIntegrationRoute: AuthLayoutDrtIntegrationRoute,
  AuthLayoutEmailBuilderRoute: AuthLayoutEmailBuilderRoute,
  AuthLayoutEmailCampaignsRoute: AuthLayoutEmailCampaignsRoute,
  AuthLayoutEmailCustomizerRoute: AuthLayoutEmailCustomizerRoute,
  AuthLayoutFormSubmissionsRoute: AuthLayoutFormSubmissionsRoute,
  AuthLayoutFormsRoute: AuthLayoutFormsRoute,
  AuthLayoutIntegrationsRoute: AuthLayoutIntegrationsRoute,
  AuthLayoutMobileInventorIntegrationRoute:
    AuthLayoutMobileInventorIntegrationRoute,
  AuthLayoutNewDashboardRoute: AuthLayoutNewDashboardRoute,
  AuthLayoutOutgoingEmailLogsRoute: AuthLayoutOutgoingEmailLogsRoute,
  AuthLayoutParentFormConfigRoute: AuthLayoutParentFormConfigRoute,
  AuthLayoutParentPortalLinkRoute: AuthLayoutParentPortalLinkRoute,
  AuthLayoutPublicPageLinkRoute: AuthLayoutPublicPageLinkRoute,
  AuthLayoutRoomOverviewRoute: AuthLayoutRoomOverviewRoute,
  AuthLayoutV2ModeRoute: AuthLayoutV2ModeRoute,
  AuthLayoutAnnouncementsNewRouteRoute: AuthLayoutAnnouncementsNewRouteRoute,
  AuthLayoutFamiliesFamilyIdRouteRoute:
    AuthLayoutFamiliesFamilyIdRouteRouteWithChildren,
  AuthLayoutPoliciesNewRouteRoute: AuthLayoutPoliciesNewRouteRoute,
  AuthLayoutSettingsCrmEmailSyncRoute: AuthLayoutSettingsCrmEmailSyncRoute,
  AuthLayoutSettingsEmailSettingsRoute: AuthLayoutSettingsEmailSettingsRoute,
  AuthLayoutSettingsImportDataRoute: AuthLayoutSettingsImportDataRoute,
  AuthLayoutSettingsImportDataLogsRoute: AuthLayoutSettingsImportDataLogsRoute,
  AuthLayoutSettingsMakeupClassesRoute: AuthLayoutSettingsMakeupClassesRoute,
  AuthLayoutSettingsPortalBannerRoute: AuthLayoutSettingsPortalBannerRoute,
  AuthLayoutSettingsPreflightCheckRoute: AuthLayoutSettingsPreflightCheckRoute,
  AuthLayoutSettingsRemindersRoute: AuthLayoutSettingsRemindersRoute,
  AuthLayoutSettingsTrialBookingsRoute: AuthLayoutSettingsTrialBookingsRoute,
  AuthLayoutSettingsUserManagementRoute: AuthLayoutSettingsUserManagementRoute,
  AuthLayoutParentsTransactionsTableRoute:
    AuthLayoutParentsTransactionsTableRoute,
  AuthLayoutAnnouncementsIndexRoute: AuthLayoutAnnouncementsIndexRoute,
  AuthLayoutParentsIndexRoute: AuthLayoutParentsIndexRoute,
  AuthLayoutPoliciesIndexRoute: AuthLayoutPoliciesIndexRoute,
  AuthLayoutParentsParentIdSavedPaymentMethodsRoute:
    AuthLayoutParentsParentIdSavedPaymentMethodsRoute,
  AuthLayoutParentsBulkUploadHistoryRoute:
    AuthLayoutParentsBulkUploadHistoryRoute,
  AuthLayoutAnnouncementsAnnouncementIdIndexRoute:
    AuthLayoutAnnouncementsAnnouncementIdIndexRoute,
  AuthLayoutParentsBulkUploadIndexRoute: AuthLayoutParentsBulkUploadIndexRoute,
  AuthLayoutParentsCsvBatchProcessingIndexRoute:
    AuthLayoutParentsCsvBatchProcessingIndexRoute,
  AuthLayoutPoliciesPolicyIdIndexRoute: AuthLayoutPoliciesPolicyIdIndexRoute,
  AuthLayoutParentsBulkUploadResultsJobIdRoute:
    AuthLayoutParentsBulkUploadResultsJobIdRoute,
  AuthLayoutParentsCsvBatchProcessingIdIndexRoute:
    AuthLayoutParentsCsvBatchProcessingIdIndexRoute,
};

const AuthLayoutRouteRouteWithChildren = AuthLayoutRouteRoute._addFileChildren(
  AuthLayoutRouteRouteChildren,
);

interface AuthRouteRouteChildren {
  AuthLayoutRouteRoute: typeof AuthLayoutRouteRouteWithChildren;
  AuthClassCalendarRoute: typeof AuthClassCalendarRoute;
  AuthDashboardRoute: typeof AuthDashboardRoute;
  AuthEventCalendarRoute: typeof AuthEventCalendarRoute;
  AuthFamilyRoute: typeof AuthFamilyRoute;
  AuthRegisterStudentRoute: typeof AuthRegisterStudentRoute;
  AuthScheduledDropsRoute: typeof AuthScheduledDropsRoute;
  AuthSetPasswordRoute: typeof AuthSetPasswordRoute;
  AuthSettingsRoute: typeof AuthSettingsRoute;
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthLayoutRouteRoute: AuthLayoutRouteRouteWithChildren,
  AuthClassCalendarRoute: AuthClassCalendarRoute,
  AuthDashboardRoute: AuthDashboardRoute,
  AuthEventCalendarRoute: AuthEventCalendarRoute,
  AuthFamilyRoute: AuthFamilyRoute,
  AuthRegisterStudentRoute: AuthRegisterStudentRoute,
  AuthScheduledDropsRoute: AuthScheduledDropsRoute,
  AuthSetPasswordRoute: AuthSetPasswordRoute,
  AuthSettingsRoute: AuthSettingsRoute,
};

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
);

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute;
  '': typeof AuthLayoutRouteRouteWithChildren;
  '/authorize': typeof AuthorizeRoute;
  '/connect-app': typeof ConnectAppRoute;
  '/crm-session-breakout': typeof CrmSessionBreakoutRoute;
  '/exchange-user-context': typeof ExchangeUserContextRoute;
  '/forgot-password': typeof ForgotPasswordRoute;
  '/ghl-authorize': typeof GhlAuthorizeRoute;
  '/login': typeof LoginRoute;
  '/class-calendar': typeof AuthClassCalendarRoute;
  '/dashboard': typeof AuthDashboardRoute;
  '/event-calendar': typeof AuthEventCalendarRoute;
  '/family': typeof AuthFamilyRoute;
  '/register-student': typeof AuthRegisterStudentRoute;
  '/scheduled-drops': typeof AuthScheduledDropsRoute;
  '/set-password': typeof AuthSetPasswordRoute;
  '/settings': typeof AuthSettingsRoute;
  '/embed/form': typeof EmbedFormRoute;
  '/public-class-share/$shareToken': typeof PublicClassShareShareTokenRoute;
  '/public-event-share/$shareToken': typeof PublicEventShareShareTokenRoute;
  '/attendance': typeof AuthLayoutAttendanceRouteRouteWithChildren;
  '/category-config': typeof AuthLayoutCategoryConfigRouteRouteWithChildren;
  '/class-analytics': typeof AuthLayoutClassAnalyticsRouteRouteWithChildren;
  '/classes': typeof AuthLayoutClassesRouteRouteWithChildren;
  '/events': typeof AuthLayoutEventsRouteRouteWithChildren;
  '/payment': typeof AuthLayoutPaymentRouteRouteWithChildren;
  '/performance-dashboard': typeof AuthLayoutPerformanceDashboardRouteRoute;
  '/recitals': typeof AuthLayoutRecitalsRouteRouteWithChildren;
  '/sessions': typeof AuthLayoutSessionsRouteRouteWithChildren;
  '/students': typeof AuthLayoutStudentsRouteRouteWithChildren;
  '/studio-profile': typeof AuthLayoutStudioProfileRouteRoute;
  '/audit-logs': typeof AuthLayoutAuditLogsRoute;
  '/bugs-feature': typeof AuthLayoutBugsFeatureRoute;
  '/daily-digest': typeof AuthLayoutDailyDigestRoute;
  '/demo-mode': typeof AuthLayoutDemoModeRoute;
  '/discounts': typeof AuthLayoutDiscountsRoute;
  '/downtime': typeof AuthLayoutDowntimeRoute;
  '/drt-integration': typeof AuthLayoutDrtIntegrationRoute;
  '/email-builder': typeof AuthLayoutEmailBuilderRoute;
  '/email-campaigns': typeof AuthLayoutEmailCampaignsRoute;
  '/email-customizer': typeof AuthLayoutEmailCustomizerRoute;
  '/form-submissions': typeof AuthLayoutFormSubmissionsRoute;
  '/forms': typeof AuthLayoutFormsRoute;
  '/integrations': typeof AuthLayoutIntegrationsRoute;
  '/mobile-inventor-integration': typeof AuthLayoutMobileInventorIntegrationRoute;
  '/new-dashboard': typeof AuthLayoutNewDashboardRoute;
  '/outgoing-email-logs': typeof AuthLayoutOutgoingEmailLogsRoute;
  '/parent-form-config': typeof AuthLayoutParentFormConfigRoute;
  '/parent-portal-link': typeof AuthLayoutParentPortalLinkRoute;
  '/public-page-link': typeof AuthLayoutPublicPageLinkRoute;
  '/room-overview': typeof AuthLayoutRoomOverviewRoute;
  '/v2-mode': typeof AuthLayoutV2ModeRoute;
  '/classes/$classId': typeof AuthLayoutClassesClassIdRouteRouteWithChildren;
  '/announcements/new': typeof AuthLayoutAnnouncementsNewRouteRoute;
  '/attendance/$classId': typeof AuthLayoutAttendanceClassIdRouteRouteWithChildren;
  '/class-analytics/$classId': typeof AuthLayoutClassAnalyticsClassIdRouteRoute;
  '/classes/new': typeof AuthLayoutClassesNewRouteRoute;
  '/events/$eventId': typeof AuthLayoutEventsEventIdRouteRouteWithChildren;
  '/families/$familyId': typeof AuthLayoutFamiliesFamilyIdRouteRouteWithChildren;
  '/payment/attendance-report': typeof AuthLayoutPaymentAttendanceReportRouteRoute;
  '/payment/bulk-charge-students': typeof AuthLayoutPaymentBulkChargeStudentsRouteRoute;
  '/payment/class-charge-history': typeof AuthLayoutPaymentClassChargeHistoryRouteRoute;
  '/payment/failed-and-refunded': typeof AuthLayoutPaymentFailedAndRefundedRouteRoute;
  '/payment/failed-payments': typeof AuthLayoutPaymentFailedPaymentsRouteRoute;
  '/payment/invoices': typeof AuthLayoutPaymentInvoicesRouteRoute;
  '/payment/late-fees': typeof AuthLayoutPaymentLateFeesRouteRoute;
  '/payment/outstanding-and-overdue': typeof AuthLayoutPaymentOutstandingAndOverdueRouteRoute;
  '/payment/payment-dashboard': typeof AuthLayoutPaymentPaymentDashboardRouteRoute;
  '/payment/payment-integration': typeof AuthLayoutPaymentPaymentIntegrationRouteRoute;
  '/payment/payment-processing': typeof AuthLayoutPaymentPaymentProcessingRouteRoute;
  '/payment/payment-reports': typeof AuthLayoutPaymentPaymentReportsRouteRoute;
  '/payment/payment-run-review': typeof AuthLayoutPaymentPaymentRunReviewRouteRoute;
  '/payment/payment-settings': typeof AuthLayoutPaymentPaymentSettingsRouteRoute;
  '/payment/portal-crm-email-sync-issue': typeof AuthLayoutPaymentPortalCrmEmailSyncIssueRouteRoute;
  '/payment/student-charge-history': typeof AuthLayoutPaymentStudentChargeHistoryRouteRoute;
  '/payment/studio-transaction-table': typeof AuthLayoutPaymentStudioTransactionTableRouteRoute;
  '/payment/transaction-codes': typeof AuthLayoutPaymentTransactionCodesRouteRoute;
  '/payment/transaction-fee-settings': typeof AuthLayoutPaymentTransactionFeeSettingsRouteRoute;
  '/payment/upcoming-payments': typeof AuthLayoutPaymentUpcomingPaymentsRouteRoute;
  '/policies/new': typeof AuthLayoutPoliciesNewRouteRoute;
  '/recitals/$recitalId': typeof AuthLayoutRecitalsRecitalIdRouteRouteWithChildren;
  '/students/$studentId': typeof AuthLayoutStudentsStudentIdRouteRouteWithChildren;
  '/crm-email-sync': typeof AuthLayoutSettingsCrmEmailSyncRoute;
  '/email-settings': typeof AuthLayoutSettingsEmailSettingsRoute;
  '/import-data': typeof AuthLayoutSettingsImportDataRoute;
  '/import-data-logs': typeof AuthLayoutSettingsImportDataLogsRoute;
  '/makeup-classes': typeof AuthLayoutSettingsMakeupClassesRoute;
  '/portal-banner': typeof AuthLayoutSettingsPortalBannerRoute;
  '/preflight-check': typeof AuthLayoutSettingsPreflightCheckRoute;
  '/reminders': typeof AuthLayoutSettingsRemindersRoute;
  '/trial-bookings': typeof AuthLayoutSettingsTrialBookingsRoute;
  '/user-management': typeof AuthLayoutSettingsUserManagementRoute;
  '/category-config/groups': typeof AuthLayoutCategoryConfigGroupsRoute;
  '/category-config/instructors': typeof AuthLayoutCategoryConfigInstructorsRoute;
  '/category-config/locations': typeof AuthLayoutCategoryConfigLocationsRoute;
  '/category-config/rooms': typeof AuthLayoutCategoryConfigRoomsRoute;
  '/category-config/tags': typeof AuthLayoutCategoryConfigTagsRoute;
  '/classes/bulk-upload': typeof AuthLayoutClassesBulkUploadRoute;
  '/classes/private-lessons': typeof AuthLayoutClassesPrivateLessonsRoute;
  '/classes/trial-students': typeof AuthLayoutClassesTrialStudentsRoute;
  '/events/new': typeof AuthLayoutEventsNewRoute;
  '/parents/transactions-table': typeof AuthLayoutParentsTransactionsTableRoute;
  '/recitals/new': typeof AuthLayoutRecitalsNewRoute;
  '/sessions/new': typeof AuthLayoutSessionsNewRoute;
  '/sessions/rollover': typeof AuthLayoutSessionsRolloverRoute;
  '/announcements': typeof AuthLayoutAnnouncementsIndexRoute;
  '/attendance/': typeof AuthLayoutAttendanceIndexRoute;
  '/category-config/': typeof AuthLayoutCategoryConfigIndexRoute;
  '/classes/': typeof AuthLayoutClassesIndexRoute;
  '/events/': typeof AuthLayoutEventsIndexRoute;
  '/parents': typeof AuthLayoutParentsIndexRoute;
  '/policies': typeof AuthLayoutPoliciesIndexRoute;
  '/recitals/': typeof AuthLayoutRecitalsIndexRoute;
  '/sessions/': typeof AuthLayoutSessionsIndexRoute;
  '/students/': typeof AuthLayoutStudentsIndexRoute;
  '/payment/hourly-tuition/drafts': typeof AuthLayoutPaymentHourlyTuitionDraftsRouteRoute;
  '/payment/hourly-tuition/review': typeof AuthLayoutPaymentHourlyTuitionReviewRouteRoute;
  '/payment/hourly-tuition/settings': typeof AuthLayoutPaymentHourlyTuitionSettingsRouteRoute;
  '/classes/$classId/bulk-enroll-students': typeof AuthLayoutClassesClassIdBulkEnrollStudentsRoute;
  '/classes/$classId/enrolled-students': typeof AuthLayoutClassesClassIdEnrolledStudentsRoute;
  '/classes/$classId/update': typeof AuthLayoutClassesClassIdUpdateRoute;
  '/classes/$classId/wait-list': typeof AuthLayoutClassesClassIdWaitListRoute;
  '/events/$eventId/enrolled-students': typeof AuthLayoutEventsEventIdEnrolledStudentsRoute;
  '/events/$eventId/payments': typeof AuthLayoutEventsEventIdPaymentsRoute;
  '/events/$eventId/update': typeof AuthLayoutEventsEventIdUpdateRoute;
  '/families/$familyId/billing': typeof AuthLayoutFamiliesFamilyIdBillingRoute;
  '/families/$familyId/classes': typeof AuthLayoutFamiliesFamilyIdClassesRoute;
  '/families/$familyId/contacts': typeof AuthLayoutFamiliesFamilyIdContactsRoute;
  '/families/$familyId/notes': typeof AuthLayoutFamiliesFamilyIdNotesRoute;
  '/families/$familyId/summary': typeof AuthLayoutFamiliesFamilyIdSummaryRoute;
  '/families/$familyId/transactions': typeof AuthLayoutFamiliesFamilyIdTransactionsRoute;
  '/parents/$parentId/saved-payment-methods': typeof AuthLayoutParentsParentIdSavedPaymentMethodsRoute;
  '/parents/bulk-upload/history': typeof AuthLayoutParentsBulkUploadHistoryRoute;
  '/sessions/$sessionId/edit': typeof AuthLayoutSessionsSessionIdEditRoute;
  '/sessions/$sessionId/rollover': typeof AuthLayoutSessionsSessionIdRolloverRoute;
  '/students/$studentId/classes': typeof AuthLayoutStudentsStudentIdClassesRoute;
  '/students/$studentId/contacts': typeof AuthLayoutStudentsStudentIdContactsRoute;
  '/students/$studentId/details': typeof AuthLayoutStudentsStudentIdDetailsRoute;
  '/students/$studentId/makeups': typeof AuthLayoutStudentsStudentIdMakeupsRoute;
  '/students/$studentId/new-payments': typeof AuthLayoutStudentsStudentIdNewPaymentsRoute;
  '/students/$studentId/notes': typeof AuthLayoutStudentsStudentIdNotesRoute;
  '/students/$studentId/payments': typeof AuthLayoutStudentsStudentIdPaymentsRoute;
  '/students/$studentId/policies': typeof AuthLayoutStudentsStudentIdPoliciesRoute;
  '/announcements/$announcementId': typeof AuthLayoutAnnouncementsAnnouncementIdIndexRoute;
  '/attendance/$classId/': typeof AuthLayoutAttendanceClassIdIndexRoute;
  '/families/$familyId/': typeof AuthLayoutFamiliesFamilyIdIndexRoute;
  '/parents/bulk-upload': typeof AuthLayoutParentsBulkUploadIndexRoute;
  '/parents/csv-batch-processing': typeof AuthLayoutParentsCsvBatchProcessingIndexRoute;
  '/payment/class-count-tuition': typeof AuthLayoutPaymentClassCountTuitionIndexRoute;
  '/payment/hourly-tuition': typeof AuthLayoutPaymentHourlyTuitionIndexRoute;
  '/policies/$policyId': typeof AuthLayoutPoliciesPolicyIdIndexRoute;
  '/recitals/$recitalId/': typeof AuthLayoutRecitalsRecitalIdIndexRoute;
  '/students/$studentId/': typeof AuthLayoutStudentsStudentIdIndexRoute;
  '/parents/bulk-upload/results/$jobId': typeof AuthLayoutParentsBulkUploadResultsJobIdRoute;
  '/parents/csv-batch-processing/$id': typeof AuthLayoutParentsCsvBatchProcessingIdIndexRoute;
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute;
  '': typeof AuthLayoutRouteRouteWithChildren;
  '/authorize': typeof AuthorizeRoute;
  '/connect-app': typeof ConnectAppRoute;
  '/crm-session-breakout': typeof CrmSessionBreakoutRoute;
  '/exchange-user-context': typeof ExchangeUserContextRoute;
  '/forgot-password': typeof ForgotPasswordRoute;
  '/ghl-authorize': typeof GhlAuthorizeRoute;
  '/login': typeof LoginRoute;
  '/class-calendar': typeof AuthClassCalendarRoute;
  '/dashboard': typeof AuthDashboardRoute;
  '/event-calendar': typeof AuthEventCalendarRoute;
  '/family': typeof AuthFamilyRoute;
  '/register-student': typeof AuthRegisterStudentRoute;
  '/scheduled-drops': typeof AuthScheduledDropsRoute;
  '/set-password': typeof AuthSetPasswordRoute;
  '/settings': typeof AuthSettingsRoute;
  '/embed/form': typeof EmbedFormRoute;
  '/public-class-share/$shareToken': typeof PublicClassShareShareTokenRoute;
  '/public-event-share/$shareToken': typeof PublicEventShareShareTokenRoute;
  '/class-analytics': typeof AuthLayoutClassAnalyticsRouteRouteWithChildren;
  '/payment': typeof AuthLayoutPaymentRouteRouteWithChildren;
  '/performance-dashboard': typeof AuthLayoutPerformanceDashboardRouteRoute;
  '/studio-profile': typeof AuthLayoutStudioProfileRouteRoute;
  '/audit-logs': typeof AuthLayoutAuditLogsRoute;
  '/bugs-feature': typeof AuthLayoutBugsFeatureRoute;
  '/daily-digest': typeof AuthLayoutDailyDigestRoute;
  '/demo-mode': typeof AuthLayoutDemoModeRoute;
  '/discounts': typeof AuthLayoutDiscountsRoute;
  '/downtime': typeof AuthLayoutDowntimeRoute;
  '/drt-integration': typeof AuthLayoutDrtIntegrationRoute;
  '/email-builder': typeof AuthLayoutEmailBuilderRoute;
  '/email-campaigns': typeof AuthLayoutEmailCampaignsRoute;
  '/email-customizer': typeof AuthLayoutEmailCustomizerRoute;
  '/form-submissions': typeof AuthLayoutFormSubmissionsRoute;
  '/forms': typeof AuthLayoutFormsRoute;
  '/integrations': typeof AuthLayoutIntegrationsRoute;
  '/mobile-inventor-integration': typeof AuthLayoutMobileInventorIntegrationRoute;
  '/new-dashboard': typeof AuthLayoutNewDashboardRoute;
  '/outgoing-email-logs': typeof AuthLayoutOutgoingEmailLogsRoute;
  '/parent-form-config': typeof AuthLayoutParentFormConfigRoute;
  '/parent-portal-link': typeof AuthLayoutParentPortalLinkRoute;
  '/public-page-link': typeof AuthLayoutPublicPageLinkRoute;
  '/room-overview': typeof AuthLayoutRoomOverviewRoute;
  '/v2-mode': typeof AuthLayoutV2ModeRoute;
  '/classes/$classId': typeof AuthLayoutClassesClassIdRouteRouteWithChildren;
  '/announcements/new': typeof AuthLayoutAnnouncementsNewRouteRoute;
  '/class-analytics/$classId': typeof AuthLayoutClassAnalyticsClassIdRouteRoute;
  '/classes/new': typeof AuthLayoutClassesNewRouteRoute;
  '/events/$eventId': typeof AuthLayoutEventsEventIdRouteRouteWithChildren;
  '/payment/attendance-report': typeof AuthLayoutPaymentAttendanceReportRouteRoute;
  '/payment/bulk-charge-students': typeof AuthLayoutPaymentBulkChargeStudentsRouteRoute;
  '/payment/class-charge-history': typeof AuthLayoutPaymentClassChargeHistoryRouteRoute;
  '/payment/failed-and-refunded': typeof AuthLayoutPaymentFailedAndRefundedRouteRoute;
  '/payment/failed-payments': typeof AuthLayoutPaymentFailedPaymentsRouteRoute;
  '/payment/invoices': typeof AuthLayoutPaymentInvoicesRouteRoute;
  '/payment/late-fees': typeof AuthLayoutPaymentLateFeesRouteRoute;
  '/payment/outstanding-and-overdue': typeof AuthLayoutPaymentOutstandingAndOverdueRouteRoute;
  '/payment/payment-dashboard': typeof AuthLayoutPaymentPaymentDashboardRouteRoute;
  '/payment/payment-integration': typeof AuthLayoutPaymentPaymentIntegrationRouteRoute;
  '/payment/payment-processing': typeof AuthLayoutPaymentPaymentProcessingRouteRoute;
  '/payment/payment-reports': typeof AuthLayoutPaymentPaymentReportsRouteRoute;
  '/payment/payment-run-review': typeof AuthLayoutPaymentPaymentRunReviewRouteRoute;
  '/payment/payment-settings': typeof AuthLayoutPaymentPaymentSettingsRouteRoute;
  '/payment/portal-crm-email-sync-issue': typeof AuthLayoutPaymentPortalCrmEmailSyncIssueRouteRoute;
  '/payment/student-charge-history': typeof AuthLayoutPaymentStudentChargeHistoryRouteRoute;
  '/payment/studio-transaction-table': typeof AuthLayoutPaymentStudioTransactionTableRouteRoute;
  '/payment/transaction-codes': typeof AuthLayoutPaymentTransactionCodesRouteRoute;
  '/payment/transaction-fee-settings': typeof AuthLayoutPaymentTransactionFeeSettingsRouteRoute;
  '/payment/upcoming-payments': typeof AuthLayoutPaymentUpcomingPaymentsRouteRoute;
  '/policies/new': typeof AuthLayoutPoliciesNewRouteRoute;
  '/crm-email-sync': typeof AuthLayoutSettingsCrmEmailSyncRoute;
  '/email-settings': typeof AuthLayoutSettingsEmailSettingsRoute;
  '/import-data': typeof AuthLayoutSettingsImportDataRoute;
  '/import-data-logs': typeof AuthLayoutSettingsImportDataLogsRoute;
  '/makeup-classes': typeof AuthLayoutSettingsMakeupClassesRoute;
  '/portal-banner': typeof AuthLayoutSettingsPortalBannerRoute;
  '/preflight-check': typeof AuthLayoutSettingsPreflightCheckRoute;
  '/reminders': typeof AuthLayoutSettingsRemindersRoute;
  '/trial-bookings': typeof AuthLayoutSettingsTrialBookingsRoute;
  '/user-management': typeof AuthLayoutSettingsUserManagementRoute;
  '/category-config/groups': typeof AuthLayoutCategoryConfigGroupsRoute;
  '/category-config/instructors': typeof AuthLayoutCategoryConfigInstructorsRoute;
  '/category-config/locations': typeof AuthLayoutCategoryConfigLocationsRoute;
  '/category-config/rooms': typeof AuthLayoutCategoryConfigRoomsRoute;
  '/category-config/tags': typeof AuthLayoutCategoryConfigTagsRoute;
  '/classes/bulk-upload': typeof AuthLayoutClassesBulkUploadRoute;
  '/classes/private-lessons': typeof AuthLayoutClassesPrivateLessonsRoute;
  '/classes/trial-students': typeof AuthLayoutClassesTrialStudentsRoute;
  '/events/new': typeof AuthLayoutEventsNewRoute;
  '/parents/transactions-table': typeof AuthLayoutParentsTransactionsTableRoute;
  '/recitals/new': typeof AuthLayoutRecitalsNewRoute;
  '/sessions/new': typeof AuthLayoutSessionsNewRoute;
  '/sessions/rollover': typeof AuthLayoutSessionsRolloverRoute;
  '/announcements': typeof AuthLayoutAnnouncementsIndexRoute;
  '/attendance': typeof AuthLayoutAttendanceIndexRoute;
  '/category-config': typeof AuthLayoutCategoryConfigIndexRoute;
  '/classes': typeof AuthLayoutClassesIndexRoute;
  '/events': typeof AuthLayoutEventsIndexRoute;
  '/parents': typeof AuthLayoutParentsIndexRoute;
  '/policies': typeof AuthLayoutPoliciesIndexRoute;
  '/recitals': typeof AuthLayoutRecitalsIndexRoute;
  '/sessions': typeof AuthLayoutSessionsIndexRoute;
  '/students': typeof AuthLayoutStudentsIndexRoute;
  '/payment/hourly-tuition/drafts': typeof AuthLayoutPaymentHourlyTuitionDraftsRouteRoute;
  '/payment/hourly-tuition/review': typeof AuthLayoutPaymentHourlyTuitionReviewRouteRoute;
  '/payment/hourly-tuition/settings': typeof AuthLayoutPaymentHourlyTuitionSettingsRouteRoute;
  '/classes/$classId/bulk-enroll-students': typeof AuthLayoutClassesClassIdBulkEnrollStudentsRoute;
  '/classes/$classId/enrolled-students': typeof AuthLayoutClassesClassIdEnrolledStudentsRoute;
  '/classes/$classId/update': typeof AuthLayoutClassesClassIdUpdateRoute;
  '/classes/$classId/wait-list': typeof AuthLayoutClassesClassIdWaitListRoute;
  '/events/$eventId/enrolled-students': typeof AuthLayoutEventsEventIdEnrolledStudentsRoute;
  '/events/$eventId/payments': typeof AuthLayoutEventsEventIdPaymentsRoute;
  '/events/$eventId/update': typeof AuthLayoutEventsEventIdUpdateRoute;
  '/families/$familyId/billing': typeof AuthLayoutFamiliesFamilyIdBillingRoute;
  '/families/$familyId/classes': typeof AuthLayoutFamiliesFamilyIdClassesRoute;
  '/families/$familyId/contacts': typeof AuthLayoutFamiliesFamilyIdContactsRoute;
  '/families/$familyId/notes': typeof AuthLayoutFamiliesFamilyIdNotesRoute;
  '/families/$familyId/summary': typeof AuthLayoutFamiliesFamilyIdSummaryRoute;
  '/families/$familyId/transactions': typeof AuthLayoutFamiliesFamilyIdTransactionsRoute;
  '/parents/$parentId/saved-payment-methods': typeof AuthLayoutParentsParentIdSavedPaymentMethodsRoute;
  '/parents/bulk-upload/history': typeof AuthLayoutParentsBulkUploadHistoryRoute;
  '/sessions/$sessionId/edit': typeof AuthLayoutSessionsSessionIdEditRoute;
  '/sessions/$sessionId/rollover': typeof AuthLayoutSessionsSessionIdRolloverRoute;
  '/students/$studentId/classes': typeof AuthLayoutStudentsStudentIdClassesRoute;
  '/students/$studentId/contacts': typeof AuthLayoutStudentsStudentIdContactsRoute;
  '/students/$studentId/details': typeof AuthLayoutStudentsStudentIdDetailsRoute;
  '/students/$studentId/makeups': typeof AuthLayoutStudentsStudentIdMakeupsRoute;
  '/students/$studentId/new-payments': typeof AuthLayoutStudentsStudentIdNewPaymentsRoute;
  '/students/$studentId/notes': typeof AuthLayoutStudentsStudentIdNotesRoute;
  '/students/$studentId/payments': typeof AuthLayoutStudentsStudentIdPaymentsRoute;
  '/students/$studentId/policies': typeof AuthLayoutStudentsStudentIdPoliciesRoute;
  '/announcements/$announcementId': typeof AuthLayoutAnnouncementsAnnouncementIdIndexRoute;
  '/attendance/$classId': typeof AuthLayoutAttendanceClassIdIndexRoute;
  '/families/$familyId': typeof AuthLayoutFamiliesFamilyIdIndexRoute;
  '/parents/bulk-upload': typeof AuthLayoutParentsBulkUploadIndexRoute;
  '/parents/csv-batch-processing': typeof AuthLayoutParentsCsvBatchProcessingIndexRoute;
  '/payment/class-count-tuition': typeof AuthLayoutPaymentClassCountTuitionIndexRoute;
  '/payment/hourly-tuition': typeof AuthLayoutPaymentHourlyTuitionIndexRoute;
  '/policies/$policyId': typeof AuthLayoutPoliciesPolicyIdIndexRoute;
  '/recitals/$recitalId': typeof AuthLayoutRecitalsRecitalIdIndexRoute;
  '/students/$studentId': typeof AuthLayoutStudentsStudentIdIndexRoute;
  '/parents/bulk-upload/results/$jobId': typeof AuthLayoutParentsBulkUploadResultsJobIdRoute;
  '/parents/csv-batch-processing/$id': typeof AuthLayoutParentsCsvBatchProcessingIdIndexRoute;
}

export interface FileRoutesById {
  __root__: typeof rootRoute;
  '/': typeof IndexRoute;
  '/_auth': typeof AuthRouteRouteWithChildren;
  '/authorize': typeof AuthorizeRoute;
  '/connect-app': typeof ConnectAppRoute;
  '/crm-session-breakout': typeof CrmSessionBreakoutRoute;
  '/exchange-user-context': typeof ExchangeUserContextRoute;
  '/forgot-password': typeof ForgotPasswordRoute;
  '/ghl-authorize': typeof GhlAuthorizeRoute;
  '/login': typeof LoginRoute;
  '/_auth/_layout': typeof AuthLayoutRouteRouteWithChildren;
  '/_auth/class-calendar': typeof AuthClassCalendarRoute;
  '/_auth/dashboard': typeof AuthDashboardRoute;
  '/_auth/event-calendar': typeof AuthEventCalendarRoute;
  '/_auth/family': typeof AuthFamilyRoute;
  '/_auth/register-student': typeof AuthRegisterStudentRoute;
  '/_auth/scheduled-drops': typeof AuthScheduledDropsRoute;
  '/_auth/set-password': typeof AuthSetPasswordRoute;
  '/_auth/settings': typeof AuthSettingsRoute;
  '/embed/form': typeof EmbedFormRoute;
  '/public-class-share/$shareToken': typeof PublicClassShareShareTokenRoute;
  '/public-event-share/$shareToken': typeof PublicEventShareShareTokenRoute;
  '/_auth/_layout/attendance': typeof AuthLayoutAttendanceRouteRouteWithChildren;
  '/_auth/_layout/category-config': typeof AuthLayoutCategoryConfigRouteRouteWithChildren;
  '/_auth/_layout/class-analytics': typeof AuthLayoutClassAnalyticsRouteRouteWithChildren;
  '/_auth/_layout/classes': typeof AuthLayoutClassesRouteRouteWithChildren;
  '/_auth/_layout/events': typeof AuthLayoutEventsRouteRouteWithChildren;
  '/_auth/_layout/payment': typeof AuthLayoutPaymentRouteRouteWithChildren;
  '/_auth/_layout/performance-dashboard': typeof AuthLayoutPerformanceDashboardRouteRoute;
  '/_auth/_layout/recitals': typeof AuthLayoutRecitalsRouteRouteWithChildren;
  '/_auth/_layout/sessions': typeof AuthLayoutSessionsRouteRouteWithChildren;
  '/_auth/_layout/students': typeof AuthLayoutStudentsRouteRouteWithChildren;
  '/_auth/_layout/studio-profile': typeof AuthLayoutStudioProfileRouteRoute;
  '/_auth/_layout/audit-logs': typeof AuthLayoutAuditLogsRoute;
  '/_auth/_layout/bugs-feature': typeof AuthLayoutBugsFeatureRoute;
  '/_auth/_layout/daily-digest': typeof AuthLayoutDailyDigestRoute;
  '/_auth/_layout/demo-mode': typeof AuthLayoutDemoModeRoute;
  '/_auth/_layout/discounts': typeof AuthLayoutDiscountsRoute;
  '/_auth/_layout/downtime': typeof AuthLayoutDowntimeRoute;
  '/_auth/_layout/drt-integration': typeof AuthLayoutDrtIntegrationRoute;
  '/_auth/_layout/email-builder': typeof AuthLayoutEmailBuilderRoute;
  '/_auth/_layout/email-campaigns': typeof AuthLayoutEmailCampaignsRoute;
  '/_auth/_layout/email-customizer': typeof AuthLayoutEmailCustomizerRoute;
  '/_auth/_layout/form-submissions': typeof AuthLayoutFormSubmissionsRoute;
  '/_auth/_layout/forms': typeof AuthLayoutFormsRoute;
  '/_auth/_layout/integrations': typeof AuthLayoutIntegrationsRoute;
  '/_auth/_layout/mobile-inventor-integration': typeof AuthLayoutMobileInventorIntegrationRoute;
  '/_auth/_layout/new-dashboard': typeof AuthLayoutNewDashboardRoute;
  '/_auth/_layout/outgoing-email-logs': typeof AuthLayoutOutgoingEmailLogsRoute;
  '/_auth/_layout/parent-form-config': typeof AuthLayoutParentFormConfigRoute;
  '/_auth/_layout/parent-portal-link': typeof AuthLayoutParentPortalLinkRoute;
  '/_auth/_layout/public-page-link': typeof AuthLayoutPublicPageLinkRoute;
  '/_auth/_layout/room-overview': typeof AuthLayoutRoomOverviewRoute;
  '/_auth/_layout/v2-mode': typeof AuthLayoutV2ModeRoute;
  '/_public/classes/$classId': typeof PublicClassesClassIdRoute;
  '/_auth/_layout/announcements/new': typeof AuthLayoutAnnouncementsNewRouteRoute;
  '/_auth/_layout/attendance/$classId': typeof AuthLayoutAttendanceClassIdRouteRouteWithChildren;
  '/_auth/_layout/class-analytics/$classId': typeof AuthLayoutClassAnalyticsClassIdRouteRoute;
  '/_auth/_layout/classes/$classId': typeof AuthLayoutClassesClassIdRouteRouteWithChildren;
  '/_auth/_layout/classes/new': typeof AuthLayoutClassesNewRouteRoute;
  '/_auth/_layout/events/$eventId': typeof AuthLayoutEventsEventIdRouteRouteWithChildren;
  '/_auth/_layout/families/$familyId': typeof AuthLayoutFamiliesFamilyIdRouteRouteWithChildren;
  '/_auth/_layout/payment/attendance-report': typeof AuthLayoutPaymentAttendanceReportRouteRoute;
  '/_auth/_layout/payment/bulk-charge-students': typeof AuthLayoutPaymentBulkChargeStudentsRouteRoute;
  '/_auth/_layout/payment/class-charge-history': typeof AuthLayoutPaymentClassChargeHistoryRouteRoute;
  '/_auth/_layout/payment/failed-and-refunded': typeof AuthLayoutPaymentFailedAndRefundedRouteRoute;
  '/_auth/_layout/payment/failed-payments': typeof AuthLayoutPaymentFailedPaymentsRouteRoute;
  '/_auth/_layout/payment/invoices': typeof AuthLayoutPaymentInvoicesRouteRoute;
  '/_auth/_layout/payment/late-fees': typeof AuthLayoutPaymentLateFeesRouteRoute;
  '/_auth/_layout/payment/outstanding-and-overdue': typeof AuthLayoutPaymentOutstandingAndOverdueRouteRoute;
  '/_auth/_layout/payment/payment-dashboard': typeof AuthLayoutPaymentPaymentDashboardRouteRoute;
  '/_auth/_layout/payment/payment-integration': typeof AuthLayoutPaymentPaymentIntegrationRouteRoute;
  '/_auth/_layout/payment/payment-processing': typeof AuthLayoutPaymentPaymentProcessingRouteRoute;
  '/_auth/_layout/payment/payment-reports': typeof AuthLayoutPaymentPaymentReportsRouteRoute;
  '/_auth/_layout/payment/payment-run-review': typeof AuthLayoutPaymentPaymentRunReviewRouteRoute;
  '/_auth/_layout/payment/payment-settings': typeof AuthLayoutPaymentPaymentSettingsRouteRoute;
  '/_auth/_layout/payment/portal-crm-email-sync-issue': typeof AuthLayoutPaymentPortalCrmEmailSyncIssueRouteRoute;
  '/_auth/_layout/payment/student-charge-history': typeof AuthLayoutPaymentStudentChargeHistoryRouteRoute;
  '/_auth/_layout/payment/studio-transaction-table': typeof AuthLayoutPaymentStudioTransactionTableRouteRoute;
  '/_auth/_layout/payment/transaction-codes': typeof AuthLayoutPaymentTransactionCodesRouteRoute;
  '/_auth/_layout/payment/transaction-fee-settings': typeof AuthLayoutPaymentTransactionFeeSettingsRouteRoute;
  '/_auth/_layout/payment/upcoming-payments': typeof AuthLayoutPaymentUpcomingPaymentsRouteRoute;
  '/_auth/_layout/policies/new': typeof AuthLayoutPoliciesNewRouteRoute;
  '/_auth/_layout/recitals/$recitalId': typeof AuthLayoutRecitalsRecitalIdRouteRouteWithChildren;
  '/_auth/_layout/students/$studentId': typeof AuthLayoutStudentsStudentIdRouteRouteWithChildren;
  '/_auth/_layout/_settings/crm-email-sync': typeof AuthLayoutSettingsCrmEmailSyncRoute;
  '/_auth/_layout/_settings/email-settings': typeof AuthLayoutSettingsEmailSettingsRoute;
  '/_auth/_layout/_settings/import-data': typeof AuthLayoutSettingsImportDataRoute;
  '/_auth/_layout/_settings/import-data-logs': typeof AuthLayoutSettingsImportDataLogsRoute;
  '/_auth/_layout/_settings/makeup-classes': typeof AuthLayoutSettingsMakeupClassesRoute;
  '/_auth/_layout/_settings/portal-banner': typeof AuthLayoutSettingsPortalBannerRoute;
  '/_auth/_layout/_settings/preflight-check': typeof AuthLayoutSettingsPreflightCheckRoute;
  '/_auth/_layout/_settings/reminders': typeof AuthLayoutSettingsRemindersRoute;
  '/_auth/_layout/_settings/trial-bookings': typeof AuthLayoutSettingsTrialBookingsRoute;
  '/_auth/_layout/_settings/user-management': typeof AuthLayoutSettingsUserManagementRoute;
  '/_auth/_layout/category-config/groups': typeof AuthLayoutCategoryConfigGroupsRoute;
  '/_auth/_layout/category-config/instructors': typeof AuthLayoutCategoryConfigInstructorsRoute;
  '/_auth/_layout/category-config/locations': typeof AuthLayoutCategoryConfigLocationsRoute;
  '/_auth/_layout/category-config/rooms': typeof AuthLayoutCategoryConfigRoomsRoute;
  '/_auth/_layout/category-config/tags': typeof AuthLayoutCategoryConfigTagsRoute;
  '/_auth/_layout/classes/bulk-upload': typeof AuthLayoutClassesBulkUploadRoute;
  '/_auth/_layout/classes/private-lessons': typeof AuthLayoutClassesPrivateLessonsRoute;
  '/_auth/_layout/classes/trial-students': typeof AuthLayoutClassesTrialStudentsRoute;
  '/_auth/_layout/events/new': typeof AuthLayoutEventsNewRoute;
  '/_auth/_layout/parents/transactions-table': typeof AuthLayoutParentsTransactionsTableRoute;
  '/_auth/_layout/recitals/new': typeof AuthLayoutRecitalsNewRoute;
  '/_auth/_layout/sessions/new': typeof AuthLayoutSessionsNewRoute;
  '/_auth/_layout/sessions/rollover': typeof AuthLayoutSessionsRolloverRoute;
  '/_auth/_layout/announcements/': typeof AuthLayoutAnnouncementsIndexRoute;
  '/_auth/_layout/attendance/': typeof AuthLayoutAttendanceIndexRoute;
  '/_auth/_layout/category-config/': typeof AuthLayoutCategoryConfigIndexRoute;
  '/_auth/_layout/classes/': typeof AuthLayoutClassesIndexRoute;
  '/_auth/_layout/events/': typeof AuthLayoutEventsIndexRoute;
  '/_auth/_layout/parents/': typeof AuthLayoutParentsIndexRoute;
  '/_auth/_layout/policies/': typeof AuthLayoutPoliciesIndexRoute;
  '/_auth/_layout/recitals/': typeof AuthLayoutRecitalsIndexRoute;
  '/_auth/_layout/sessions/': typeof AuthLayoutSessionsIndexRoute;
  '/_auth/_layout/students/': typeof AuthLayoutStudentsIndexRoute;
  '/_auth/_layout/payment/hourly-tuition/drafts': typeof AuthLayoutPaymentHourlyTuitionDraftsRouteRoute;
  '/_auth/_layout/payment/hourly-tuition/review': typeof AuthLayoutPaymentHourlyTuitionReviewRouteRoute;
  '/_auth/_layout/payment/hourly-tuition/settings': typeof AuthLayoutPaymentHourlyTuitionSettingsRouteRoute;
  '/_auth/_layout/classes/$classId/bulk-enroll-students': typeof AuthLayoutClassesClassIdBulkEnrollStudentsRoute;
  '/_auth/_layout/classes/$classId/enrolled-students': typeof AuthLayoutClassesClassIdEnrolledStudentsRoute;
  '/_auth/_layout/classes/$classId/update': typeof AuthLayoutClassesClassIdUpdateRoute;
  '/_auth/_layout/classes/$classId/wait-list': typeof AuthLayoutClassesClassIdWaitListRoute;
  '/_auth/_layout/events/$eventId/enrolled-students': typeof AuthLayoutEventsEventIdEnrolledStudentsRoute;
  '/_auth/_layout/events/$eventId/payments': typeof AuthLayoutEventsEventIdPaymentsRoute;
  '/_auth/_layout/events/$eventId/update': typeof AuthLayoutEventsEventIdUpdateRoute;
  '/_auth/_layout/families/$familyId/billing': typeof AuthLayoutFamiliesFamilyIdBillingRoute;
  '/_auth/_layout/families/$familyId/classes': typeof AuthLayoutFamiliesFamilyIdClassesRoute;
  '/_auth/_layout/families/$familyId/contacts': typeof AuthLayoutFamiliesFamilyIdContactsRoute;
  '/_auth/_layout/families/$familyId/notes': typeof AuthLayoutFamiliesFamilyIdNotesRoute;
  '/_auth/_layout/families/$familyId/summary': typeof AuthLayoutFamiliesFamilyIdSummaryRoute;
  '/_auth/_layout/families/$familyId/transactions': typeof AuthLayoutFamiliesFamilyIdTransactionsRoute;
  '/_auth/_layout/parents/$parentId/saved-payment-methods': typeof AuthLayoutParentsParentIdSavedPaymentMethodsRoute;
  '/_auth/_layout/parents/bulk-upload/history': typeof AuthLayoutParentsBulkUploadHistoryRoute;
  '/_auth/_layout/sessions/$sessionId/edit': typeof AuthLayoutSessionsSessionIdEditRoute;
  '/_auth/_layout/sessions/$sessionId/rollover': typeof AuthLayoutSessionsSessionIdRolloverRoute;
  '/_auth/_layout/students/$studentId/classes': typeof AuthLayoutStudentsStudentIdClassesRoute;
  '/_auth/_layout/students/$studentId/contacts': typeof AuthLayoutStudentsStudentIdContactsRoute;
  '/_auth/_layout/students/$studentId/details': typeof AuthLayoutStudentsStudentIdDetailsRoute;
  '/_auth/_layout/students/$studentId/makeups': typeof AuthLayoutStudentsStudentIdMakeupsRoute;
  '/_auth/_layout/students/$studentId/new-payments': typeof AuthLayoutStudentsStudentIdNewPaymentsRoute;
  '/_auth/_layout/students/$studentId/notes': typeof AuthLayoutStudentsStudentIdNotesRoute;
  '/_auth/_layout/students/$studentId/payments': typeof AuthLayoutStudentsStudentIdPaymentsRoute;
  '/_auth/_layout/students/$studentId/policies': typeof AuthLayoutStudentsStudentIdPoliciesRoute;
  '/_auth/_layout/announcements/$announcementId/': typeof AuthLayoutAnnouncementsAnnouncementIdIndexRoute;
  '/_auth/_layout/attendance/$classId/': typeof AuthLayoutAttendanceClassIdIndexRoute;
  '/_auth/_layout/families/$familyId/': typeof AuthLayoutFamiliesFamilyIdIndexRoute;
  '/_auth/_layout/parents/bulk-upload/': typeof AuthLayoutParentsBulkUploadIndexRoute;
  '/_auth/_layout/parents/csv-batch-processing/': typeof AuthLayoutParentsCsvBatchProcessingIndexRoute;
  '/_auth/_layout/payment/class-count-tuition/': typeof AuthLayoutPaymentClassCountTuitionIndexRoute;
  '/_auth/_layout/payment/hourly-tuition/': typeof AuthLayoutPaymentHourlyTuitionIndexRoute;
  '/_auth/_layout/policies/$policyId/': typeof AuthLayoutPoliciesPolicyIdIndexRoute;
  '/_auth/_layout/recitals/$recitalId/': typeof AuthLayoutRecitalsRecitalIdIndexRoute;
  '/_auth/_layout/students/$studentId/': typeof AuthLayoutStudentsStudentIdIndexRoute;
  '/_auth/_layout/parents/bulk-upload/results/$jobId': typeof AuthLayoutParentsBulkUploadResultsJobIdRoute;
  '/_auth/_layout/parents/csv-batch-processing/$id/': typeof AuthLayoutParentsCsvBatchProcessingIdIndexRoute;
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | ''
    | '/authorize'
    | '/connect-app'
    | '/crm-session-breakout'
    | '/exchange-user-context'
    | '/forgot-password'
    | '/ghl-authorize'
    | '/login'
    | '/class-calendar'
    | '/dashboard'
    | '/event-calendar'
    | '/family'
    | '/register-student'
    | '/scheduled-drops'
    | '/set-password'
    | '/settings'
    | '/embed/form'
    | '/public-class-share/$shareToken'
    | '/public-event-share/$shareToken'
    | '/attendance'
    | '/category-config'
    | '/class-analytics'
    | '/classes'
    | '/events'
    | '/payment'
    | '/performance-dashboard'
    | '/recitals'
    | '/sessions'
    | '/students'
    | '/studio-profile'
    | '/audit-logs'
    | '/bugs-feature'
    | '/daily-digest'
    | '/demo-mode'
    | '/discounts'
    | '/downtime'
    | '/drt-integration'
    | '/email-builder'
    | '/email-campaigns'
    | '/email-customizer'
    | '/form-submissions'
    | '/forms'
    | '/integrations'
    | '/mobile-inventor-integration'
    | '/new-dashboard'
    | '/outgoing-email-logs'
    | '/parent-form-config'
    | '/parent-portal-link'
    | '/public-page-link'
    | '/room-overview'
    | '/v2-mode'
    | '/classes/$classId'
    | '/announcements/new'
    | '/attendance/$classId'
    | '/class-analytics/$classId'
    | '/classes/new'
    | '/events/$eventId'
    | '/families/$familyId'
    | '/payment/attendance-report'
    | '/payment/bulk-charge-students'
    | '/payment/class-charge-history'
    | '/payment/failed-and-refunded'
    | '/payment/failed-payments'
    | '/payment/invoices'
    | '/payment/late-fees'
    | '/payment/outstanding-and-overdue'
    | '/payment/payment-dashboard'
    | '/payment/payment-integration'
    | '/payment/payment-processing'
    | '/payment/payment-reports'
    | '/payment/payment-run-review'
    | '/payment/payment-settings'
    | '/payment/portal-crm-email-sync-issue'
    | '/payment/student-charge-history'
    | '/payment/studio-transaction-table'
    | '/payment/transaction-codes'
    | '/payment/transaction-fee-settings'
    | '/payment/upcoming-payments'
    | '/policies/new'
    | '/recitals/$recitalId'
    | '/students/$studentId'
    | '/crm-email-sync'
    | '/email-settings'
    | '/import-data'
    | '/import-data-logs'
    | '/makeup-classes'
    | '/portal-banner'
    | '/preflight-check'
    | '/reminders'
    | '/trial-bookings'
    | '/user-management'
    | '/category-config/groups'
    | '/category-config/instructors'
    | '/category-config/locations'
    | '/category-config/rooms'
    | '/category-config/tags'
    | '/classes/bulk-upload'
    | '/classes/private-lessons'
    | '/classes/trial-students'
    | '/events/new'
    | '/parents/transactions-table'
    | '/recitals/new'
    | '/sessions/new'
    | '/sessions/rollover'
    | '/announcements'
    | '/attendance/'
    | '/category-config/'
    | '/classes/'
    | '/events/'
    | '/parents'
    | '/policies'
    | '/recitals/'
    | '/sessions/'
    | '/students/'
    | '/payment/hourly-tuition/drafts'
    | '/payment/hourly-tuition/review'
    | '/payment/hourly-tuition/settings'
    | '/classes/$classId/bulk-enroll-students'
    | '/classes/$classId/enrolled-students'
    | '/classes/$classId/update'
    | '/classes/$classId/wait-list'
    | '/events/$eventId/enrolled-students'
    | '/events/$eventId/payments'
    | '/events/$eventId/update'
    | '/families/$familyId/billing'
    | '/families/$familyId/classes'
    | '/families/$familyId/contacts'
    | '/families/$familyId/notes'
    | '/families/$familyId/summary'
    | '/families/$familyId/transactions'
    | '/parents/$parentId/saved-payment-methods'
    | '/parents/bulk-upload/history'
    | '/sessions/$sessionId/edit'
    | '/sessions/$sessionId/rollover'
    | '/students/$studentId/classes'
    | '/students/$studentId/contacts'
    | '/students/$studentId/details'
    | '/students/$studentId/makeups'
    | '/students/$studentId/new-payments'
    | '/students/$studentId/notes'
    | '/students/$studentId/payments'
    | '/students/$studentId/policies'
    | '/announcements/$announcementId'
    | '/attendance/$classId/'
    | '/families/$familyId/'
    | '/parents/bulk-upload'
    | '/parents/csv-batch-processing'
    | '/payment/class-count-tuition'
    | '/payment/hourly-tuition'
    | '/policies/$policyId'
    | '/recitals/$recitalId/'
    | '/students/$studentId/'
    | '/parents/bulk-upload/results/$jobId'
    | '/parents/csv-batch-processing/$id';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | ''
    | '/authorize'
    | '/connect-app'
    | '/crm-session-breakout'
    | '/exchange-user-context'
    | '/forgot-password'
    | '/ghl-authorize'
    | '/login'
    | '/class-calendar'
    | '/dashboard'
    | '/event-calendar'
    | '/family'
    | '/register-student'
    | '/scheduled-drops'
    | '/set-password'
    | '/settings'
    | '/embed/form'
    | '/public-class-share/$shareToken'
    | '/public-event-share/$shareToken'
    | '/class-analytics'
    | '/payment'
    | '/performance-dashboard'
    | '/studio-profile'
    | '/audit-logs'
    | '/bugs-feature'
    | '/daily-digest'
    | '/demo-mode'
    | '/discounts'
    | '/downtime'
    | '/drt-integration'
    | '/email-builder'
    | '/email-campaigns'
    | '/email-customizer'
    | '/form-submissions'
    | '/forms'
    | '/integrations'
    | '/mobile-inventor-integration'
    | '/new-dashboard'
    | '/outgoing-email-logs'
    | '/parent-form-config'
    | '/parent-portal-link'
    | '/public-page-link'
    | '/room-overview'
    | '/v2-mode'
    | '/classes/$classId'
    | '/announcements/new'
    | '/class-analytics/$classId'
    | '/classes/new'
    | '/events/$eventId'
    | '/payment/attendance-report'
    | '/payment/bulk-charge-students'
    | '/payment/class-charge-history'
    | '/payment/failed-and-refunded'
    | '/payment/failed-payments'
    | '/payment/invoices'
    | '/payment/late-fees'
    | '/payment/outstanding-and-overdue'
    | '/payment/payment-dashboard'
    | '/payment/payment-integration'
    | '/payment/payment-processing'
    | '/payment/payment-reports'
    | '/payment/payment-run-review'
    | '/payment/payment-settings'
    | '/payment/portal-crm-email-sync-issue'
    | '/payment/student-charge-history'
    | '/payment/studio-transaction-table'
    | '/payment/transaction-codes'
    | '/payment/transaction-fee-settings'
    | '/payment/upcoming-payments'
    | '/policies/new'
    | '/crm-email-sync'
    | '/email-settings'
    | '/import-data'
    | '/import-data-logs'
    | '/makeup-classes'
    | '/portal-banner'
    | '/preflight-check'
    | '/reminders'
    | '/trial-bookings'
    | '/user-management'
    | '/category-config/groups'
    | '/category-config/instructors'
    | '/category-config/locations'
    | '/category-config/rooms'
    | '/category-config/tags'
    | '/classes/bulk-upload'
    | '/classes/private-lessons'
    | '/classes/trial-students'
    | '/events/new'
    | '/parents/transactions-table'
    | '/recitals/new'
    | '/sessions/new'
    | '/sessions/rollover'
    | '/announcements'
    | '/attendance'
    | '/category-config'
    | '/classes'
    | '/events'
    | '/parents'
    | '/policies'
    | '/recitals'
    | '/sessions'
    | '/students'
    | '/payment/hourly-tuition/drafts'
    | '/payment/hourly-tuition/review'
    | '/payment/hourly-tuition/settings'
    | '/classes/$classId/bulk-enroll-students'
    | '/classes/$classId/enrolled-students'
    | '/classes/$classId/update'
    | '/classes/$classId/wait-list'
    | '/events/$eventId/enrolled-students'
    | '/events/$eventId/payments'
    | '/events/$eventId/update'
    | '/families/$familyId/billing'
    | '/families/$familyId/classes'
    | '/families/$familyId/contacts'
    | '/families/$familyId/notes'
    | '/families/$familyId/summary'
    | '/families/$familyId/transactions'
    | '/parents/$parentId/saved-payment-methods'
    | '/parents/bulk-upload/history'
    | '/sessions/$sessionId/edit'
    | '/sessions/$sessionId/rollover'
    | '/students/$studentId/classes'
    | '/students/$studentId/contacts'
    | '/students/$studentId/details'
    | '/students/$studentId/makeups'
    | '/students/$studentId/new-payments'
    | '/students/$studentId/notes'
    | '/students/$studentId/payments'
    | '/students/$studentId/policies'
    | '/announcements/$announcementId'
    | '/attendance/$classId'
    | '/families/$familyId'
    | '/parents/bulk-upload'
    | '/parents/csv-batch-processing'
    | '/payment/class-count-tuition'
    | '/payment/hourly-tuition'
    | '/policies/$policyId'
    | '/recitals/$recitalId'
    | '/students/$studentId'
    | '/parents/bulk-upload/results/$jobId'
    | '/parents/csv-batch-processing/$id';
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/authorize'
    | '/connect-app'
    | '/crm-session-breakout'
    | '/exchange-user-context'
    | '/forgot-password'
    | '/ghl-authorize'
    | '/login'
    | '/_auth/_layout'
    | '/_auth/class-calendar'
    | '/_auth/dashboard'
    | '/_auth/event-calendar'
    | '/_auth/family'
    | '/_auth/register-student'
    | '/_auth/scheduled-drops'
    | '/_auth/set-password'
    | '/_auth/settings'
    | '/embed/form'
    | '/public-class-share/$shareToken'
    | '/public-event-share/$shareToken'
    | '/_auth/_layout/attendance'
    | '/_auth/_layout/category-config'
    | '/_auth/_layout/class-analytics'
    | '/_auth/_layout/classes'
    | '/_auth/_layout/events'
    | '/_auth/_layout/payment'
    | '/_auth/_layout/performance-dashboard'
    | '/_auth/_layout/recitals'
    | '/_auth/_layout/sessions'
    | '/_auth/_layout/students'
    | '/_auth/_layout/studio-profile'
    | '/_auth/_layout/audit-logs'
    | '/_auth/_layout/bugs-feature'
    | '/_auth/_layout/daily-digest'
    | '/_auth/_layout/demo-mode'
    | '/_auth/_layout/discounts'
    | '/_auth/_layout/downtime'
    | '/_auth/_layout/drt-integration'
    | '/_auth/_layout/email-builder'
    | '/_auth/_layout/email-campaigns'
    | '/_auth/_layout/email-customizer'
    | '/_auth/_layout/form-submissions'
    | '/_auth/_layout/forms'
    | '/_auth/_layout/integrations'
    | '/_auth/_layout/mobile-inventor-integration'
    | '/_auth/_layout/new-dashboard'
    | '/_auth/_layout/outgoing-email-logs'
    | '/_auth/_layout/parent-form-config'
    | '/_auth/_layout/parent-portal-link'
    | '/_auth/_layout/public-page-link'
    | '/_auth/_layout/room-overview'
    | '/_auth/_layout/v2-mode'
    | '/_public/classes/$classId'
    | '/_auth/_layout/announcements/new'
    | '/_auth/_layout/attendance/$classId'
    | '/_auth/_layout/class-analytics/$classId'
    | '/_auth/_layout/classes/$classId'
    | '/_auth/_layout/classes/new'
    | '/_auth/_layout/events/$eventId'
    | '/_auth/_layout/families/$familyId'
    | '/_auth/_layout/payment/attendance-report'
    | '/_auth/_layout/payment/bulk-charge-students'
    | '/_auth/_layout/payment/class-charge-history'
    | '/_auth/_layout/payment/failed-and-refunded'
    | '/_auth/_layout/payment/failed-payments'
    | '/_auth/_layout/payment/invoices'
    | '/_auth/_layout/payment/late-fees'
    | '/_auth/_layout/payment/outstanding-and-overdue'
    | '/_auth/_layout/payment/payment-dashboard'
    | '/_auth/_layout/payment/payment-integration'
    | '/_auth/_layout/payment/payment-processing'
    | '/_auth/_layout/payment/payment-reports'
    | '/_auth/_layout/payment/payment-run-review'
    | '/_auth/_layout/payment/payment-settings'
    | '/_auth/_layout/payment/portal-crm-email-sync-issue'
    | '/_auth/_layout/payment/student-charge-history'
    | '/_auth/_layout/payment/studio-transaction-table'
    | '/_auth/_layout/payment/transaction-codes'
    | '/_auth/_layout/payment/transaction-fee-settings'
    | '/_auth/_layout/payment/upcoming-payments'
    | '/_auth/_layout/policies/new'
    | '/_auth/_layout/recitals/$recitalId'
    | '/_auth/_layout/students/$studentId'
    | '/_auth/_layout/_settings/crm-email-sync'
    | '/_auth/_layout/_settings/email-settings'
    | '/_auth/_layout/_settings/import-data'
    | '/_auth/_layout/_settings/import-data-logs'
    | '/_auth/_layout/_settings/makeup-classes'
    | '/_auth/_layout/_settings/portal-banner'
    | '/_auth/_layout/_settings/preflight-check'
    | '/_auth/_layout/_settings/reminders'
    | '/_auth/_layout/_settings/trial-bookings'
    | '/_auth/_layout/_settings/user-management'
    | '/_auth/_layout/category-config/groups'
    | '/_auth/_layout/category-config/instructors'
    | '/_auth/_layout/category-config/locations'
    | '/_auth/_layout/category-config/rooms'
    | '/_auth/_layout/category-config/tags'
    | '/_auth/_layout/classes/bulk-upload'
    | '/_auth/_layout/classes/private-lessons'
    | '/_auth/_layout/classes/trial-students'
    | '/_auth/_layout/events/new'
    | '/_auth/_layout/parents/transactions-table'
    | '/_auth/_layout/recitals/new'
    | '/_auth/_layout/sessions/new'
    | '/_auth/_layout/sessions/rollover'
    | '/_auth/_layout/announcements/'
    | '/_auth/_layout/attendance/'
    | '/_auth/_layout/category-config/'
    | '/_auth/_layout/classes/'
    | '/_auth/_layout/events/'
    | '/_auth/_layout/parents/'
    | '/_auth/_layout/policies/'
    | '/_auth/_layout/recitals/'
    | '/_auth/_layout/sessions/'
    | '/_auth/_layout/students/'
    | '/_auth/_layout/payment/hourly-tuition/drafts'
    | '/_auth/_layout/payment/hourly-tuition/review'
    | '/_auth/_layout/payment/hourly-tuition/settings'
    | '/_auth/_layout/classes/$classId/bulk-enroll-students'
    | '/_auth/_layout/classes/$classId/enrolled-students'
    | '/_auth/_layout/classes/$classId/update'
    | '/_auth/_layout/classes/$classId/wait-list'
    | '/_auth/_layout/events/$eventId/enrolled-students'
    | '/_auth/_layout/events/$eventId/payments'
    | '/_auth/_layout/events/$eventId/update'
    | '/_auth/_layout/families/$familyId/billing'
    | '/_auth/_layout/families/$familyId/classes'
    | '/_auth/_layout/families/$familyId/contacts'
    | '/_auth/_layout/families/$familyId/notes'
    | '/_auth/_layout/families/$familyId/summary'
    | '/_auth/_layout/families/$familyId/transactions'
    | '/_auth/_layout/parents/$parentId/saved-payment-methods'
    | '/_auth/_layout/parents/bulk-upload/history'
    | '/_auth/_layout/sessions/$sessionId/edit'
    | '/_auth/_layout/sessions/$sessionId/rollover'
    | '/_auth/_layout/students/$studentId/classes'
    | '/_auth/_layout/students/$studentId/contacts'
    | '/_auth/_layout/students/$studentId/details'
    | '/_auth/_layout/students/$studentId/makeups'
    | '/_auth/_layout/students/$studentId/new-payments'
    | '/_auth/_layout/students/$studentId/notes'
    | '/_auth/_layout/students/$studentId/payments'
    | '/_auth/_layout/students/$studentId/policies'
    | '/_auth/_layout/announcements/$announcementId/'
    | '/_auth/_layout/attendance/$classId/'
    | '/_auth/_layout/families/$familyId/'
    | '/_auth/_layout/parents/bulk-upload/'
    | '/_auth/_layout/parents/csv-batch-processing/'
    | '/_auth/_layout/payment/class-count-tuition/'
    | '/_auth/_layout/payment/hourly-tuition/'
    | '/_auth/_layout/policies/$policyId/'
    | '/_auth/_layout/recitals/$recitalId/'
    | '/_auth/_layout/students/$studentId/'
    | '/_auth/_layout/parents/bulk-upload/results/$jobId'
    | '/_auth/_layout/parents/csv-batch-processing/$id/';
  fileRoutesById: FileRoutesById;
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  AuthRouteRoute: typeof AuthRouteRouteWithChildren;
  AuthorizeRoute: typeof AuthorizeRoute;
  ConnectAppRoute: typeof ConnectAppRoute;
  CrmSessionBreakoutRoute: typeof CrmSessionBreakoutRoute;
  ExchangeUserContextRoute: typeof ExchangeUserContextRoute;
  ForgotPasswordRoute: typeof ForgotPasswordRoute;
  GhlAuthorizeRoute: typeof GhlAuthorizeRoute;
  LoginRoute: typeof LoginRoute;
  EmbedFormRoute: typeof EmbedFormRoute;
  PublicClassShareShareTokenRoute: typeof PublicClassShareShareTokenRoute;
  PublicEventShareShareTokenRoute: typeof PublicEventShareShareTokenRoute;
  PublicClassesClassIdRoute: typeof PublicClassesClassIdRoute;
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRouteRoute: AuthRouteRouteWithChildren,
  AuthorizeRoute: AuthorizeRoute,
  ConnectAppRoute: ConnectAppRoute,
  CrmSessionBreakoutRoute: CrmSessionBreakoutRoute,
  ExchangeUserContextRoute: ExchangeUserContextRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  GhlAuthorizeRoute: GhlAuthorizeRoute,
  LoginRoute: LoginRoute,
  EmbedFormRoute: EmbedFormRoute,
  PublicClassShareShareTokenRoute: PublicClassShareShareTokenRoute,
  PublicEventShareShareTokenRoute: PublicEventShareShareTokenRoute,
  PublicClassesClassIdRoute: PublicClassesClassIdRoute,
};

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_auth",
        "/authorize",
        "/connect-app",
        "/crm-session-breakout",
        "/exchange-user-context",
        "/forgot-password",
        "/ghl-authorize",
        "/login",
        "/embed/form",
        "/public-class-share/$shareToken",
        "/public-event-share/$shareToken",
        "/_public/classes/$classId"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_auth": {
      "filePath": "_auth/route.tsx",
      "children": [
        "/_auth/_layout",
        "/_auth/class-calendar",
        "/_auth/dashboard",
        "/_auth/event-calendar",
        "/_auth/family",
        "/_auth/register-student",
        "/_auth/scheduled-drops",
        "/_auth/set-password",
        "/_auth/settings"
      ]
    },
    "/authorize": {
      "filePath": "authorize.tsx"
    },
    "/connect-app": {
      "filePath": "connect-app.tsx"
    },
    "/crm-session-breakout": {
      "filePath": "crm-session-breakout.tsx"
    },
    "/exchange-user-context": {
      "filePath": "exchange-user-context.tsx"
    },
    "/forgot-password": {
      "filePath": "forgot-password.tsx"
    },
    "/ghl-authorize": {
      "filePath": "ghl-authorize.tsx"
    },
    "/login": {
      "filePath": "login.tsx"
    },
    "/_auth/_layout": {
      "filePath": "_auth/_layout/route.tsx",
      "parent": "/_auth",
      "children": [
        "/_auth/_layout/attendance",
        "/_auth/_layout/category-config",
        "/_auth/_layout/class-analytics",
        "/_auth/_layout/classes",
        "/_auth/_layout/events",
        "/_auth/_layout/payment",
        "/_auth/_layout/performance-dashboard",
        "/_auth/_layout/recitals",
        "/_auth/_layout/sessions",
        "/_auth/_layout/students",
        "/_auth/_layout/studio-profile",
        "/_auth/_layout/audit-logs",
        "/_auth/_layout/bugs-feature",
        "/_auth/_layout/daily-digest",
        "/_auth/_layout/demo-mode",
        "/_auth/_layout/discounts",
        "/_auth/_layout/downtime",
        "/_auth/_layout/drt-integration",
        "/_auth/_layout/email-builder",
        "/_auth/_layout/email-campaigns",
        "/_auth/_layout/email-customizer",
        "/_auth/_layout/form-submissions",
        "/_auth/_layout/forms",
        "/_auth/_layout/integrations",
        "/_auth/_layout/mobile-inventor-integration",
        "/_auth/_layout/new-dashboard",
        "/_auth/_layout/outgoing-email-logs",
        "/_auth/_layout/parent-form-config",
        "/_auth/_layout/parent-portal-link",
        "/_auth/_layout/public-page-link",
        "/_auth/_layout/room-overview",
        "/_auth/_layout/v2-mode",
        "/_auth/_layout/announcements/new",
        "/_auth/_layout/families/$familyId",
        "/_auth/_layout/policies/new",
        "/_auth/_layout/_settings/crm-email-sync",
        "/_auth/_layout/_settings/email-settings",
        "/_auth/_layout/_settings/import-data",
        "/_auth/_layout/_settings/import-data-logs",
        "/_auth/_layout/_settings/makeup-classes",
        "/_auth/_layout/_settings/portal-banner",
        "/_auth/_layout/_settings/preflight-check",
        "/_auth/_layout/_settings/reminders",
        "/_auth/_layout/_settings/trial-bookings",
        "/_auth/_layout/_settings/user-management",
        "/_auth/_layout/parents/transactions-table",
        "/_auth/_layout/announcements/",
        "/_auth/_layout/parents/",
        "/_auth/_layout/policies/",
        "/_auth/_layout/parents/$parentId/saved-payment-methods",
        "/_auth/_layout/parents/bulk-upload/history",
        "/_auth/_layout/announcements/$announcementId/",
        "/_auth/_layout/parents/bulk-upload/",
        "/_auth/_layout/parents/csv-batch-processing/",
        "/_auth/_layout/policies/$policyId/",
        "/_auth/_layout/parents/bulk-upload/results/$jobId",
        "/_auth/_layout/parents/csv-batch-processing/$id/"
      ]
    },
    "/_auth/class-calendar": {
      "filePath": "_auth/class-calendar.tsx",
      "parent": "/_auth"
    },
    "/_auth/dashboard": {
      "filePath": "_auth/dashboard.tsx",
      "parent": "/_auth"
    },
    "/_auth/event-calendar": {
      "filePath": "_auth/event-calendar.tsx",
      "parent": "/_auth"
    },
    "/_auth/family": {
      "filePath": "_auth/family.tsx",
      "parent": "/_auth"
    },
    "/_auth/register-student": {
      "filePath": "_auth/register-student.tsx",
      "parent": "/_auth"
    },
    "/_auth/scheduled-drops": {
      "filePath": "_auth/scheduled-drops.tsx",
      "parent": "/_auth"
    },
    "/_auth/set-password": {
      "filePath": "_auth/set-password.tsx",
      "parent": "/_auth"
    },
    "/_auth/settings": {
      "filePath": "_auth/settings.tsx",
      "parent": "/_auth"
    },
    "/embed/form": {
      "filePath": "embed/form.tsx"
    },
    "/public-class-share/$shareToken": {
      "filePath": "public-class-share/$shareToken.tsx"
    },
    "/public-event-share/$shareToken": {
      "filePath": "public-event-share/$shareToken.tsx"
    },
    "/_auth/_layout/attendance": {
      "filePath": "_auth/_layout/attendance/route.tsx",
      "parent": "/_auth/_layout",
      "children": [
        "/_auth/_layout/attendance/$classId",
        "/_auth/_layout/attendance/"
      ]
    },
    "/_auth/_layout/category-config": {
      "filePath": "_auth/_layout/category-config/route.tsx",
      "parent": "/_auth/_layout",
      "children": [
        "/_auth/_layout/category-config/groups",
        "/_auth/_layout/category-config/instructors",
        "/_auth/_layout/category-config/locations",
        "/_auth/_layout/category-config/rooms",
        "/_auth/_layout/category-config/tags",
        "/_auth/_layout/category-config/"
      ]
    },
    "/_auth/_layout/class-analytics": {
      "filePath": "_auth/_layout/class-analytics/route.tsx",
      "parent": "/_auth/_layout",
      "children": [
        "/_auth/_layout/class-analytics/$classId"
      ]
    },
    "/_auth/_layout/classes": {
      "filePath": "_auth/_layout/classes/route.tsx",
      "parent": "/_auth/_layout",
      "children": [
        "/_auth/_layout/classes/$classId",
        "/_auth/_layout/classes/new",
        "/_auth/_layout/classes/bulk-upload",
        "/_auth/_layout/classes/private-lessons",
        "/_auth/_layout/classes/trial-students",
        "/_auth/_layout/classes/"
      ]
    },
    "/_auth/_layout/events": {
      "filePath": "_auth/_layout/events/route.tsx",
      "parent": "/_auth/_layout",
      "children": [
        "/_auth/_layout/events/$eventId",
        "/_auth/_layout/events/new",
        "/_auth/_layout/events/"
      ]
    },
    "/_auth/_layout/payment": {
      "filePath": "_auth/_layout/payment/route.tsx",
      "parent": "/_auth/_layout",
      "children": [
        "/_auth/_layout/payment/attendance-report",
        "/_auth/_layout/payment/bulk-charge-students",
        "/_auth/_layout/payment/class-charge-history",
        "/_auth/_layout/payment/failed-and-refunded",
        "/_auth/_layout/payment/failed-payments",
        "/_auth/_layout/payment/invoices",
        "/_auth/_layout/payment/late-fees",
        "/_auth/_layout/payment/outstanding-and-overdue",
        "/_auth/_layout/payment/payment-dashboard",
        "/_auth/_layout/payment/payment-integration",
        "/_auth/_layout/payment/payment-processing",
        "/_auth/_layout/payment/payment-reports",
        "/_auth/_layout/payment/payment-run-review",
        "/_auth/_layout/payment/payment-settings",
        "/_auth/_layout/payment/portal-crm-email-sync-issue",
        "/_auth/_layout/payment/student-charge-history",
        "/_auth/_layout/payment/studio-transaction-table",
        "/_auth/_layout/payment/transaction-codes",
        "/_auth/_layout/payment/transaction-fee-settings",
        "/_auth/_layout/payment/upcoming-payments",
        "/_auth/_layout/payment/hourly-tuition/drafts",
        "/_auth/_layout/payment/hourly-tuition/review",
        "/_auth/_layout/payment/hourly-tuition/settings",
        "/_auth/_layout/payment/class-count-tuition/",
        "/_auth/_layout/payment/hourly-tuition/"
      ]
    },
    "/_auth/_layout/performance-dashboard": {
      "filePath": "_auth/_layout/performance-dashboard/route.tsx",
      "parent": "/_auth/_layout"
    },
    "/_auth/_layout/recitals": {
      "filePath": "_auth/_layout/recitals/route.tsx",
      "parent": "/_auth/_layout",
      "children": [
        "/_auth/_layout/recitals/$recitalId",
        "/_auth/_layout/recitals/new",
        "/_auth/_layout/recitals/"
      ]
    },
    "/_auth/_layout/sessions": {
      "filePath": "_auth/_layout/sessions/route.tsx",
      "parent": "/_auth/_layout",
      "children": [
        "/_auth/_layout/sessions/new",
        "/_auth/_layout/sessions/rollover",
        "/_auth/_layout/sessions/",
        "/_auth/_layout/sessions/$sessionId/edit",
        "/_auth/_layout/sessions/$sessionId/rollover"
      ]
    },
    "/_auth/_layout/students": {
      "filePath": "_auth/_layout/students/route.tsx",
      "parent": "/_auth/_layout",
      "children": [
        "/_auth/_layout/students/$studentId",
        "/_auth/_layout/students/"
      ]
    },
    "/_auth/_layout/studio-profile": {
      "filePath": "_auth/_layout/studio-profile/route.tsx",
      "parent": "/_auth/_layout"
    },
    "/_auth/_layout/audit-logs": {
      "filePath": "_auth/_layout/audit-logs.tsx",
      "parent": "/_auth/_layout"
    },
    "/_auth/_layout/bugs-feature": {
      "filePath": "_auth/_layout/bugs-feature.tsx",
      "parent": "/_auth/_layout"
    },
    "/_auth/_layout/daily-digest": {
      "filePath": "_auth/_layout/daily-digest.tsx",
      "parent": "/_auth/_layout"
    },
    "/_auth/_layout/demo-mode": {
      "filePath": "_auth/_layout/demo-mode.tsx",
      "parent": "/_auth/_layout"
    },
    "/_auth/_layout/discounts": {
      "filePath": "_auth/_layout/discounts.tsx",
      "parent": "/_auth/_layout"
    },
    "/_auth/_layout/downtime": {
      "filePath": "_auth/_layout/downtime.tsx",
      "parent": "/_auth/_layout"
    },
    "/_auth/_layout/drt-integration": {
      "filePath": "_auth/_layout/drt-integration.tsx",
      "parent": "/_auth/_layout"
    },
    "/_auth/_layout/email-builder": {
      "filePath": "_auth/_layout/email-builder.tsx",
      "parent": "/_auth/_layout"
    },
    "/_auth/_layout/email-campaigns": {
      "filePath": "_auth/_layout/email-campaigns.tsx",
      "parent": "/_auth/_layout"
    },
    "/_auth/_layout/email-customizer": {
      "filePath": "_auth/_layout/email-customizer.tsx",
      "parent": "/_auth/_layout"
    },
    "/_auth/_layout/form-submissions": {
      "filePath": "_auth/_layout/form-submissions.tsx",
      "parent": "/_auth/_layout"
    },
    "/_auth/_layout/forms": {
      "filePath": "_auth/_layout/forms.tsx",
      "parent": "/_auth/_layout"
    },
    "/_auth/_layout/integrations": {
      "filePath": "_auth/_layout/integrations.tsx",
      "parent": "/_auth/_layout"
    },
    "/_auth/_layout/mobile-inventor-integration": {
      "filePath": "_auth/_layout/mobile-inventor-integration.tsx",
      "parent": "/_auth/_layout"
    },
    "/_auth/_layout/new-dashboard": {
      "filePath": "_auth/_layout/new-dashboard.tsx",
      "parent": "/_auth/_layout"
    },
    "/_auth/_layout/outgoing-email-logs": {
      "filePath": "_auth/_layout/outgoing-email-logs.tsx",
      "parent": "/_auth/_layout"
    },
    "/_auth/_layout/parent-form-config": {
      "filePath": "_auth/_layout/parent-form-config.tsx",
      "parent": "/_auth/_layout"
    },
    "/_auth/_layout/parent-portal-link": {
      "filePath": "_auth/_layout/parent-portal-link.tsx",
      "parent": "/_auth/_layout"
    },
    "/_auth/_layout/public-page-link": {
      "filePath": "_auth/_layout/public-page-link.tsx",
      "parent": "/_auth/_layout"
    },
    "/_auth/_layout/room-overview": {
      "filePath": "_auth/_layout/room-overview.tsx",
      "parent": "/_auth/_layout"
    },
    "/_auth/_layout/v2-mode": {
      "filePath": "_auth/_layout/v2-mode.tsx",
      "parent": "/_auth/_layout"
    },
    "/_public/classes/$classId": {
      "filePath": "_public/classes/$classId.tsx"
    },
    "/_auth/_layout/announcements/new": {
      "filePath": "_auth/_layout/announcements/new/route.tsx",
      "parent": "/_auth/_layout"
    },
    "/_auth/_layout/attendance/$classId": {
      "filePath": "_auth/_layout/attendance/$classId/route.tsx",
      "parent": "/_auth/_layout/attendance",
      "children": [
        "/_auth/_layout/attendance/$classId/"
      ]
    },
    "/_auth/_layout/class-analytics/$classId": {
      "filePath": "_auth/_layout/class-analytics/$classId/route.tsx",
      "parent": "/_auth/_layout/class-analytics"
    },
    "/_auth/_layout/classes/$classId": {
      "filePath": "_auth/_layout/classes/$classId/route.tsx",
      "parent": "/_auth/_layout/classes",
      "children": [
        "/_auth/_layout/classes/$classId/bulk-enroll-students",
        "/_auth/_layout/classes/$classId/enrolled-students",
        "/_auth/_layout/classes/$classId/update",
        "/_auth/_layout/classes/$classId/wait-list"
      ]
    },
    "/_auth/_layout/classes/new": {
      "filePath": "_auth/_layout/classes/new/route.tsx",
      "parent": "/_auth/_layout/classes"
    },
    "/_auth/_layout/events/$eventId": {
      "filePath": "_auth/_layout/events/$eventId/route.tsx",
      "parent": "/_auth/_layout/events",
      "children": [
        "/_auth/_layout/events/$eventId/enrolled-students",
        "/_auth/_layout/events/$eventId/payments",
        "/_auth/_layout/events/$eventId/update"
      ]
    },
    "/_auth/_layout/families/$familyId": {
      "filePath": "_auth/_layout/families/$familyId/route.tsx",
      "parent": "/_auth/_layout",
      "children": [
        "/_auth/_layout/families/$familyId/billing",
        "/_auth/_layout/families/$familyId/classes",
        "/_auth/_layout/families/$familyId/contacts",
        "/_auth/_layout/families/$familyId/notes",
        "/_auth/_layout/families/$familyId/summary",
        "/_auth/_layout/families/$familyId/transactions",
        "/_auth/_layout/families/$familyId/"
      ]
    },
    "/_auth/_layout/payment/attendance-report": {
      "filePath": "_auth/_layout/payment/attendance-report/route.tsx",
      "parent": "/_auth/_layout/payment"
    },
    "/_auth/_layout/payment/bulk-charge-students": {
      "filePath": "_auth/_layout/payment/bulk-charge-students/route.tsx",
      "parent": "/_auth/_layout/payment"
    },
    "/_auth/_layout/payment/class-charge-history": {
      "filePath": "_auth/_layout/payment/class-charge-history/route.tsx",
      "parent": "/_auth/_layout/payment"
    },
    "/_auth/_layout/payment/failed-and-refunded": {
      "filePath": "_auth/_layout/payment/failed-and-refunded/route.tsx",
      "parent": "/_auth/_layout/payment"
    },
    "/_auth/_layout/payment/failed-payments": {
      "filePath": "_auth/_layout/payment/failed-payments/route.tsx",
      "parent": "/_auth/_layout/payment"
    },
    "/_auth/_layout/payment/invoices": {
      "filePath": "_auth/_layout/payment/invoices/route.tsx",
      "parent": "/_auth/_layout/payment"
    },
    "/_auth/_layout/payment/late-fees": {
      "filePath": "_auth/_layout/payment/late-fees/route.tsx",
      "parent": "/_auth/_layout/payment"
    },
    "/_auth/_layout/payment/outstanding-and-overdue": {
      "filePath": "_auth/_layout/payment/outstanding-and-overdue/route.tsx",
      "parent": "/_auth/_layout/payment"
    },
    "/_auth/_layout/payment/payment-dashboard": {
      "filePath": "_auth/_layout/payment/payment-dashboard/route.tsx",
      "parent": "/_auth/_layout/payment"
    },
    "/_auth/_layout/payment/payment-integration": {
      "filePath": "_auth/_layout/payment/payment-integration/route.tsx",
      "parent": "/_auth/_layout/payment"
    },
    "/_auth/_layout/payment/payment-processing": {
      "filePath": "_auth/_layout/payment/payment-processing/route.tsx",
      "parent": "/_auth/_layout/payment"
    },
    "/_auth/_layout/payment/payment-reports": {
      "filePath": "_auth/_layout/payment/payment-reports/route.tsx",
      "parent": "/_auth/_layout/payment"
    },
    "/_auth/_layout/payment/payment-run-review": {
      "filePath": "_auth/_layout/payment/payment-run-review/route.tsx",
      "parent": "/_auth/_layout/payment"
    },
    "/_auth/_layout/payment/payment-settings": {
      "filePath": "_auth/_layout/payment/payment-settings/route.tsx",
      "parent": "/_auth/_layout/payment"
    },
    "/_auth/_layout/payment/portal-crm-email-sync-issue": {
      "filePath": "_auth/_layout/payment/portal-crm-email-sync-issue/route.tsx",
      "parent": "/_auth/_layout/payment"
    },
    "/_auth/_layout/payment/student-charge-history": {
      "filePath": "_auth/_layout/payment/student-charge-history/route.tsx",
      "parent": "/_auth/_layout/payment"
    },
    "/_auth/_layout/payment/studio-transaction-table": {
      "filePath": "_auth/_layout/payment/studio-transaction-table/route.tsx",
      "parent": "/_auth/_layout/payment"
    },
    "/_auth/_layout/payment/transaction-codes": {
      "filePath": "_auth/_layout/payment/transaction-codes/route.tsx",
      "parent": "/_auth/_layout/payment"
    },
    "/_auth/_layout/payment/transaction-fee-settings": {
      "filePath": "_auth/_layout/payment/transaction-fee-settings/route.tsx",
      "parent": "/_auth/_layout/payment"
    },
    "/_auth/_layout/payment/upcoming-payments": {
      "filePath": "_auth/_layout/payment/upcoming-payments/route.tsx",
      "parent": "/_auth/_layout/payment"
    },
    "/_auth/_layout/policies/new": {
      "filePath": "_auth/_layout/policies/new/route.tsx",
      "parent": "/_auth/_layout"
    },
    "/_auth/_layout/recitals/$recitalId": {
      "filePath": "_auth/_layout/recitals/$recitalId/route.tsx",
      "parent": "/_auth/_layout/recitals",
      "children": [
        "/_auth/_layout/recitals/$recitalId/"
      ]
    },
    "/_auth/_layout/students/$studentId": {
      "filePath": "_auth/_layout/students/$studentId/route.tsx",
      "parent": "/_auth/_layout/students",
      "children": [
        "/_auth/_layout/students/$studentId/classes",
        "/_auth/_layout/students/$studentId/contacts",
        "/_auth/_layout/students/$studentId/details",
        "/_auth/_layout/students/$studentId/makeups",
        "/_auth/_layout/students/$studentId/new-payments",
        "/_auth/_layout/students/$studentId/notes",
        "/_auth/_layout/students/$studentId/payments",
        "/_auth/_layout/students/$studentId/policies",
        "/_auth/_layout/students/$studentId/"
      ]
    },
    "/_auth/_layout/_settings/crm-email-sync": {
      "filePath": "_auth/_layout/_settings/crm-email-sync.tsx",
      "parent": "/_auth/_layout"
    },
    "/_auth/_layout/_settings/email-settings": {
      "filePath": "_auth/_layout/_settings/email-settings.tsx",
      "parent": "/_auth/_layout"
    },
    "/_auth/_layout/_settings/import-data": {
      "filePath": "_auth/_layout/_settings/import-data.tsx",
      "parent": "/_auth/_layout"
    },
    "/_auth/_layout/_settings/import-data-logs": {
      "filePath": "_auth/_layout/_settings/import-data-logs.tsx",
      "parent": "/_auth/_layout"
    },
    "/_auth/_layout/_settings/makeup-classes": {
      "filePath": "_auth/_layout/_settings/makeup-classes.tsx",
      "parent": "/_auth/_layout"
    },
    "/_auth/_layout/_settings/portal-banner": {
      "filePath": "_auth/_layout/_settings/portal-banner.tsx",
      "parent": "/_auth/_layout"
    },
    "/_auth/_layout/_settings/preflight-check": {
      "filePath": "_auth/_layout/_settings/preflight-check.tsx",
      "parent": "/_auth/_layout"
    },
    "/_auth/_layout/_settings/reminders": {
      "filePath": "_auth/_layout/_settings/reminders.tsx",
      "parent": "/_auth/_layout"
    },
    "/_auth/_layout/_settings/trial-bookings": {
      "filePath": "_auth/_layout/_settings/trial-bookings.tsx",
      "parent": "/_auth/_layout"
    },
    "/_auth/_layout/_settings/user-management": {
      "filePath": "_auth/_layout/_settings/user-management.tsx",
      "parent": "/_auth/_layout"
    },
    "/_auth/_layout/category-config/groups": {
      "filePath": "_auth/_layout/category-config/groups.tsx",
      "parent": "/_auth/_layout/category-config"
    },
    "/_auth/_layout/category-config/instructors": {
      "filePath": "_auth/_layout/category-config/instructors.tsx",
      "parent": "/_auth/_layout/category-config"
    },
    "/_auth/_layout/category-config/locations": {
      "filePath": "_auth/_layout/category-config/locations.tsx",
      "parent": "/_auth/_layout/category-config"
    },
    "/_auth/_layout/category-config/rooms": {
      "filePath": "_auth/_layout/category-config/rooms.tsx",
      "parent": "/_auth/_layout/category-config"
    },
    "/_auth/_layout/category-config/tags": {
      "filePath": "_auth/_layout/category-config/tags.tsx",
      "parent": "/_auth/_layout/category-config"
    },
    "/_auth/_layout/classes/bulk-upload": {
      "filePath": "_auth/_layout/classes/bulk-upload.tsx",
      "parent": "/_auth/_layout/classes"
    },
    "/_auth/_layout/classes/private-lessons": {
      "filePath": "_auth/_layout/classes/private-lessons.tsx",
      "parent": "/_auth/_layout/classes"
    },
    "/_auth/_layout/classes/trial-students": {
      "filePath": "_auth/_layout/classes/trial-students.tsx",
      "parent": "/_auth/_layout/classes"
    },
    "/_auth/_layout/events/new": {
      "filePath": "_auth/_layout/events/new.tsx",
      "parent": "/_auth/_layout/events"
    },
    "/_auth/_layout/parents/transactions-table": {
      "filePath": "_auth/_layout/parents/transactions-table.tsx",
      "parent": "/_auth/_layout"
    },
    "/_auth/_layout/recitals/new": {
      "filePath": "_auth/_layout/recitals/new.tsx",
      "parent": "/_auth/_layout/recitals"
    },
    "/_auth/_layout/sessions/new": {
      "filePath": "_auth/_layout/sessions/new.tsx",
      "parent": "/_auth/_layout/sessions"
    },
    "/_auth/_layout/sessions/rollover": {
      "filePath": "_auth/_layout/sessions/rollover.tsx",
      "parent": "/_auth/_layout/sessions"
    },
    "/_auth/_layout/announcements/": {
      "filePath": "_auth/_layout/announcements/index.tsx",
      "parent": "/_auth/_layout"
    },
    "/_auth/_layout/attendance/": {
      "filePath": "_auth/_layout/attendance/index.tsx",
      "parent": "/_auth/_layout/attendance"
    },
    "/_auth/_layout/category-config/": {
      "filePath": "_auth/_layout/category-config/index.tsx",
      "parent": "/_auth/_layout/category-config"
    },
    "/_auth/_layout/classes/": {
      "filePath": "_auth/_layout/classes/index.tsx",
      "parent": "/_auth/_layout/classes"
    },
    "/_auth/_layout/events/": {
      "filePath": "_auth/_layout/events/index.tsx",
      "parent": "/_auth/_layout/events"
    },
    "/_auth/_layout/parents/": {
      "filePath": "_auth/_layout/parents/index.tsx",
      "parent": "/_auth/_layout"
    },
    "/_auth/_layout/policies/": {
      "filePath": "_auth/_layout/policies/index.tsx",
      "parent": "/_auth/_layout"
    },
    "/_auth/_layout/recitals/": {
      "filePath": "_auth/_layout/recitals/index.tsx",
      "parent": "/_auth/_layout/recitals"
    },
    "/_auth/_layout/sessions/": {
      "filePath": "_auth/_layout/sessions/index.tsx",
      "parent": "/_auth/_layout/sessions"
    },
    "/_auth/_layout/students/": {
      "filePath": "_auth/_layout/students/index.tsx",
      "parent": "/_auth/_layout/students"
    },
    "/_auth/_layout/payment/hourly-tuition/drafts": {
      "filePath": "_auth/_layout/payment/hourly-tuition/drafts/route.tsx",
      "parent": "/_auth/_layout/payment"
    },
    "/_auth/_layout/payment/hourly-tuition/review": {
      "filePath": "_auth/_layout/payment/hourly-tuition/review/route.tsx",
      "parent": "/_auth/_layout/payment"
    },
    "/_auth/_layout/payment/hourly-tuition/settings": {
      "filePath": "_auth/_layout/payment/hourly-tuition/settings/route.tsx",
      "parent": "/_auth/_layout/payment"
    },
    "/_auth/_layout/classes/$classId/bulk-enroll-students": {
      "filePath": "_auth/_layout/classes/$classId/bulk-enroll-students.tsx",
      "parent": "/_auth/_layout/classes/$classId"
    },
    "/_auth/_layout/classes/$classId/enrolled-students": {
      "filePath": "_auth/_layout/classes/$classId/enrolled-students.tsx",
      "parent": "/_auth/_layout/classes/$classId"
    },
    "/_auth/_layout/classes/$classId/update": {
      "filePath": "_auth/_layout/classes/$classId/update.tsx",
      "parent": "/_auth/_layout/classes/$classId"
    },
    "/_auth/_layout/classes/$classId/wait-list": {
      "filePath": "_auth/_layout/classes/$classId/wait-list.tsx",
      "parent": "/_auth/_layout/classes/$classId"
    },
    "/_auth/_layout/events/$eventId/enrolled-students": {
      "filePath": "_auth/_layout/events/$eventId/enrolled-students.tsx",
      "parent": "/_auth/_layout/events/$eventId"
    },
    "/_auth/_layout/events/$eventId/payments": {
      "filePath": "_auth/_layout/events/$eventId/payments.tsx",
      "parent": "/_auth/_layout/events/$eventId"
    },
    "/_auth/_layout/events/$eventId/update": {
      "filePath": "_auth/_layout/events/$eventId/update.tsx",
      "parent": "/_auth/_layout/events/$eventId"
    },
    "/_auth/_layout/families/$familyId/billing": {
      "filePath": "_auth/_layout/families/$familyId/billing.tsx",
      "parent": "/_auth/_layout/families/$familyId"
    },
    "/_auth/_layout/families/$familyId/classes": {
      "filePath": "_auth/_layout/families/$familyId/classes.tsx",
      "parent": "/_auth/_layout/families/$familyId"
    },
    "/_auth/_layout/families/$familyId/contacts": {
      "filePath": "_auth/_layout/families/$familyId/contacts.tsx",
      "parent": "/_auth/_layout/families/$familyId"
    },
    "/_auth/_layout/families/$familyId/notes": {
      "filePath": "_auth/_layout/families/$familyId/notes.tsx",
      "parent": "/_auth/_layout/families/$familyId"
    },
    "/_auth/_layout/families/$familyId/summary": {
      "filePath": "_auth/_layout/families/$familyId/summary.tsx",
      "parent": "/_auth/_layout/families/$familyId"
    },
    "/_auth/_layout/families/$familyId/transactions": {
      "filePath": "_auth/_layout/families/$familyId/transactions.tsx",
      "parent": "/_auth/_layout/families/$familyId"
    },
    "/_auth/_layout/parents/$parentId/saved-payment-methods": {
      "filePath": "_auth/_layout/parents/$parentId/saved-payment-methods.tsx",
      "parent": "/_auth/_layout"
    },
    "/_auth/_layout/parents/bulk-upload/history": {
      "filePath": "_auth/_layout/parents/bulk-upload/history.tsx",
      "parent": "/_auth/_layout"
    },
    "/_auth/_layout/sessions/$sessionId/edit": {
      "filePath": "_auth/_layout/sessions/$sessionId/edit.tsx",
      "parent": "/_auth/_layout/sessions"
    },
    "/_auth/_layout/sessions/$sessionId/rollover": {
      "filePath": "_auth/_layout/sessions/$sessionId/rollover.tsx",
      "parent": "/_auth/_layout/sessions"
    },
    "/_auth/_layout/students/$studentId/classes": {
      "filePath": "_auth/_layout/students/$studentId/classes.tsx",
      "parent": "/_auth/_layout/students/$studentId"
    },
    "/_auth/_layout/students/$studentId/contacts": {
      "filePath": "_auth/_layout/students/$studentId/contacts.tsx",
      "parent": "/_auth/_layout/students/$studentId"
    },
    "/_auth/_layout/students/$studentId/details": {
      "filePath": "_auth/_layout/students/$studentId/details.tsx",
      "parent": "/_auth/_layout/students/$studentId"
    },
    "/_auth/_layout/students/$studentId/makeups": {
      "filePath": "_auth/_layout/students/$studentId/makeups.tsx",
      "parent": "/_auth/_layout/students/$studentId"
    },
    "/_auth/_layout/students/$studentId/new-payments": {
      "filePath": "_auth/_layout/students/$studentId/new-payments.tsx",
      "parent": "/_auth/_layout/students/$studentId"
    },
    "/_auth/_layout/students/$studentId/notes": {
      "filePath": "_auth/_layout/students/$studentId/notes.tsx",
      "parent": "/_auth/_layout/students/$studentId"
    },
    "/_auth/_layout/students/$studentId/payments": {
      "filePath": "_auth/_layout/students/$studentId/payments.tsx",
      "parent": "/_auth/_layout/students/$studentId"
    },
    "/_auth/_layout/students/$studentId/policies": {
      "filePath": "_auth/_layout/students/$studentId/policies.tsx",
      "parent": "/_auth/_layout/students/$studentId"
    },
    "/_auth/_layout/announcements/$announcementId/": {
      "filePath": "_auth/_layout/announcements/$announcementId/index.tsx",
      "parent": "/_auth/_layout"
    },
    "/_auth/_layout/attendance/$classId/": {
      "filePath": "_auth/_layout/attendance/$classId/index.tsx",
      "parent": "/_auth/_layout/attendance/$classId"
    },
    "/_auth/_layout/families/$familyId/": {
      "filePath": "_auth/_layout/families/$familyId/index.tsx",
      "parent": "/_auth/_layout/families/$familyId"
    },
    "/_auth/_layout/parents/bulk-upload/": {
      "filePath": "_auth/_layout/parents/bulk-upload/index.tsx",
      "parent": "/_auth/_layout"
    },
    "/_auth/_layout/parents/csv-batch-processing/": {
      "filePath": "_auth/_layout/parents/csv-batch-processing/index.tsx",
      "parent": "/_auth/_layout"
    },
    "/_auth/_layout/payment/class-count-tuition/": {
      "filePath": "_auth/_layout/payment/class-count-tuition/index.tsx",
      "parent": "/_auth/_layout/payment"
    },
    "/_auth/_layout/payment/hourly-tuition/": {
      "filePath": "_auth/_layout/payment/hourly-tuition/index.tsx",
      "parent": "/_auth/_layout/payment"
    },
    "/_auth/_layout/policies/$policyId/": {
      "filePath": "_auth/_layout/policies/$policyId/index.tsx",
      "parent": "/_auth/_layout"
    },
    "/_auth/_layout/recitals/$recitalId/": {
      "filePath": "_auth/_layout/recitals/$recitalId/index.tsx",
      "parent": "/_auth/_layout/recitals/$recitalId"
    },
    "/_auth/_layout/students/$studentId/": {
      "filePath": "_auth/_layout/students/$studentId/index.tsx",
      "parent": "/_auth/_layout/students/$studentId"
    },
    "/_auth/_layout/parents/bulk-upload/results/$jobId": {
      "filePath": "_auth/_layout/parents/bulk-upload/results.$jobId.tsx",
      "parent": "/_auth/_layout"
    },
    "/_auth/_layout/parents/csv-batch-processing/$id/": {
      "filePath": "_auth/_layout/parents/csv-batch-processing/$id/index.tsx",
      "parent": "/_auth/_layout"
    }
  }
}
ROUTE_MANIFEST_END */
